!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("mobx"), require("mobx-react"), require("@miriamtech/if2-ui"), require("@miriamtech/if2-js-model"), require("@miriamtech/if2"), require("url-pattern"), require("@miriamtech/if2-fields"), require("ramda"), require("jsonschema"), require("mobx-utils"), require("lodash.orderby"), require("i18next-browser-languagedetector"), require("@miriamtech/if2-core"), require("lodash.debounce"), require("react_ujs"), require("react-svg"), require("uuid")) : "function" == typeof define && define.amd ? define(["react", "mobx", "mobx-react", "@miriamtech/if2-ui", "@miriamtech/if2-js-model", "@miriamtech/if2", "url-pattern", "@miriamtech/if2-fields", "ramda", "jsonschema", "mobx-utils", "lodash.orderby", "i18next-browser-languagedetector", "@miriamtech/if2-core", "lodash.debounce", "react_ujs", "react-svg", "uuid"], t) : "object" == typeof exports ? exports["if2-work_orders"] = t(require("react"), require("mobx"), require("mobx-react"), require("@miriamtech/if2-ui"), require("@miriamtech/if2-js-model"), require("@miriamtech/if2"), require("url-pattern"), require("@miriamtech/if2-fields"), require("ramda"), require("jsonschema"), require("mobx-utils"), require("lodash.orderby"), require("i18next-browser-languagedetector"), require("@miriamtech/if2-core"), require("lodash.debounce"), require("react_ujs"), require("react-svg"), require("uuid")) : e["if2-work_orders"] = t(e.react, e.mobx, e["mobx-react"], e["@miriamtech/if2-ui"], e["@miriamtech/if2-js-model"], e["@miriamtech/if2"], e["url-pattern"], e["@miriamtech/if2-fields"], e.ramda, e.jsonschema, e["mobx-utils"], e["lodash.orderby"], e["i18next-browser-languagedetector"], e["@miriamtech/if2-core"], e["lodash.debounce"], e.react_ujs, e["react-svg"], e.uuid);
}(window, function (e, t, r, n, o, i, a, c, u, l, s, f, p, d, y, b, h, v) {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 50);
  }([function (t, r) {
    t.exports = e;
  }, function (e, r) {
    e.exports = t;
  }, function (e, t) {
    e.exports = r;
  }, function (e, t) {
    e.exports = n;
  }, function (e, t) {
    e.exports = o;
  },, function (e, t) {
    e.exports = i;
  }, function (e, t) {
    e.exports = a;
  }, function (e, t) {
    e.exports = c;
  }, function (e, t) {
    e.exports = u;
  }, function (e, t, r) {
    var n = r(15);
    e.exports = function (e, t, r) {
      return (t = n(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = l;
  }, function (e, t, r) {
    var n = r(29),
        o = r(30),
        i = r(31),
        a = r(33);
    e.exports = function (e, t) {
      return n(e) || o(e, t) || i(e, t) || a();
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = s;
  }, function (e, t) {
    e.exports = f;
  }, function (e, t, r) {
    var n = r(16).default,
        o = r(28);
    e.exports = function (e) {
      var t = o(e, "string");
      return "symbol" === n(t) ? t : String(t);
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    function r(t) {
      return e.exports = r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, r(t);
    }

    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = p;
  }, function (e) {
    e.exports = JSON.parse('{"en":{"IF2::WorkOrders::WorkOrder":"work order","activerecord":{"attributes":{"if2/work_orders/work_order":{"name":"Title","target_coverage":"Target coverage","target_coverage_percentage":"Target coverage","target_gallons_per_acre":"Target gallons per acre"}},"errors":{"messages":{"incompatible_units":"Incompatible Units","invalid_json":"do not match the required schema","invalid_units":"Invalid Units","missing_units":"Missing Units","recommendation_fields_deleted":"Recommendation has fields that have been deleted","recommendation_products_not_found":"Recommendation includes products that could not be found in the database"}}},"helpers":{"submit":{"field_worksheet":{"create":"Create Field Worksheet","update":"Update Field Worksheet"},"work_order":{"create":"Create Work Order","update":"Update Work Order"}}},"if2":{"work_orders":{"account":"Account","acres":"Acres","action_not_authorized":"You are not authorized to perform this action","amount_per_tank":"Amount Per Tank","application_method":"Application Method","application_record":"Application Record","calculate":"Calculate","cancel":"Cancel","create":"Create","create_application_record":"Create Application Record","crop":"Crop","date":"Date","delete":"Delete","edit":"Edit","field":"Field","field_worksheet":"Field Worksheet","field_worksheets":{"applicator_count":"Applicator Count","confirm_delete":"Are you sure you want to delete %{name}?","edit":{"page_help":"Use the form below to edit this field worksheet.","page_title":"Edit Field Worksheet"},"form":{"applicator_count_label":"Applicator Count","applicator_count_placeholder":"Applicator count (optional)","errors_encountered":{"one":"1 error prohibited this field worksheet from being saved","other":"%{count} errors prohibited this field worksheet from being saved"},"name_label":"Title","name_placeholder":"Title of this field worksheet (optional)","tank_size_label":"Tank size","tank_size_placeholder":"Tank size (optional)"},"new":{"page_help":"Use the form below to create a new field worksheet.","page_title":"New Field Worksheet"},"successfully_created":"Field worksheet was successfully created","successfully_deleted":"Field worksheet was successfully deleted","successfully_updated":"Field worksheet was successfully updated"},"fields":"Fields","load_sheet":"Load Sheet","load_sheets":{"specific_fields_to_treat":"Specific Fields, Varieties, and Acreages to Treat"},"max":"Max","method":"Method","name":"Name","navigation_title":"Work Orders","new_work_order":"New Work Order","none_fem":"None","notes":"Notes","ordered_by":"Ordered By","post":"Post","print":"Print","privileges":{"edit_field_worksheets":"Edit Field Worksheets","edit_work_orders":"Edit Work Orders","groups":{"field_worksheets":"Field Worksheets","work_orders":"Work Orders"},"view_field_worksheets":"View Field Worksheets","view_work_orders":"View Work Orders"},"product":"Product","products_to_apply":"Products to Apply","rate":"Rate","recommendation":"Recommendation","recommendation_date":"Recommendation date","recommended_by":"Recommended by","rei":"REI","rei_poster":"REI Poster","rei_poster_title":"REI Poster: %{title}","related":"Related","save":"Save","spray_record":{"account":{"choose_accounts":"Choose Accounts","choose_which_accounts_this_application_record_applies_to":"Choose which accounts this application record applies to"}},"status":"Status","target_coverage":"Target coverage","target_rate":"Target rate","title":"Title","unspecified":"Unspecified","untitled_work_order":"Untitled Work Order","variety":"Variety","work_order":"Work Order","work_orders":{"change_fields":"Change Fields","confirm_delete":"Are you sure you want to delete %{name}?","confirm_remove_field":"Confirm remove field","edit":{"page_help":"Use the form below to edit this work order.","page_title":"Edit Work Order"},"fields_editor":{"add_fields":"Add fields","no_fields_have_been_added":"No fields have been added"},"fields_title":"Select Fields","form":{"errors_encountered":{"one":"1 error prohibited this work order from being saved","other":"%{count} errors prohibited this work order from being saved"},"organic_tooltip_when_disabled":"This work order includes organic fields.","some_options_may_be_disabled":"* Some options may be deactivated depending on the fields that have been added to the work order.","start_date":"Start Date","target_coverage_percentage":"Target Coverage (%)","target_gallons_per_acre":"Target Gallons Per Acre","title_optional":"Title of this work order (optional)"},"new":{"page_help":"Use the form below to create a new work order.","page_title":"New Work Order"},"posted":{"no_products_were_specified":"No products were specified on this work order"},"products_editor":{"no_products_have_been_added":"No products have been added","product_already_applied":"Product already applied","reg_number_short":"Reg #","target_reason":"Target/Reason","valid_product_required":"Valid product required","valid_rate_required":"Valid rate required","valid_units_required":"Valid units required"},"search_work_orders":"Search work orders","successfully_created":"Work order was successfully created","successfully_deleted":"Work order was successfully deleted","successfully_posted":"Work order was successfully posted","successfully_updated":"Work order was successfully updated","tank_load_sheet":"Tank Load Sheet","tank_size":"Tank Size","target_spray_rate":"Target Spray Rate","valid_rate_required":"Valid rate required","valid_tank_size_required":"Valid tank size required","valid_units_required":"Valid units required"}}}}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"IF2::WorkOrders::WorkOrder":"work order","activerecord":{"attributes":{"if2/work_orders/work_order":{"name":"Título","target_coverage":"Cobertura meta","target_coverage_percentage":"Cobertura meta","target_gallons_per_acre":"Galones por acre meta"}},"errors":{"messages":{"incompatible_units":"Unidades son incompatibles","invalid_json":"no emparejan con el esquema requerido","invalid_units":"Unidades no válidas","missing_units":"Unidades faltantes","recommendation_fields_deleted":"La recomendación tiene campos que se han eliminado","recommendation_products_not_found":"La recomendación incluye productos que no se pudieron encontrar (en la base de datos)"}}},"helpers":{"submit":{"field_worksheet":{"create":"Crear hoja de trabajo de campo","update":"Actualizar hoja de trabajo de campo"},"work_order":{"create":"Crear orden de trabajo","update":"Actualizar orden de trabajo"}}},"if2":{"work_orders":{"account":"Cuenta","acres":"Acres","action_not_authorized":"No está autorizado para realizar esta acción","amount_per_tank":"Cantidad por tanque","application_method":"Método de aplicación","application_record":"Registro de solicitud","calculate":"Calcular","cancel":"Cancelar","create":"Crear","create_application_record":"Crear registro de aplicación","crop":"Cultivo","date":"Fecha","delete":"Eliminar","edit":"Editar","field":"Campo","field_worksheet":"Hoja de trabajo de campo","field_worksheets":{"applicator_count":"Recuento de aplicadores","confirm_delete":"¿Está seguro de que quiere eliminar a %{name}?","edit":{"page_help":"Utilice el siguiente formulario para editar esta hoja de trabajo de campo.","page_title":"Editar hoja de trabajo de campo"},"form":{"applicator_count_label":"Recuento de aplicadores","applicator_count_placeholder":"Recuento de aplicadores (opcional)","errors_encountered":{"one":"1 error impidió que se guardara esta hoja de trabajo de campo","other":"%{count} errores impidieron que se guardara esta hoja de trabajo de campo"},"name_label":"Título","name_placeholder":"Título de esta hoja de trabajo de campo (opcional)","tank_size_label":"Tamaño del tanque","tank_size_placeholder":"Tamaño del tanque (opcional)"},"new":{"page_help":"Utilice el siguiente formulario para crear una nueva hoja de trabajo de campo.","page_title":"Nueva hoja de trabajo de campo"},"successfully_created":"La hoja de trabajo de campo se creó correctamente","successfully_deleted":"La hoja de trabajo de campo se eliminó correctamente","successfully_updated":"La hoja de trabajo de campo se actualizó correctamente"},"fields":"Campos","load_sheet":"Hoja de carga","load_sheets":{"specific_fields_to_treat":"Campos, variedades y superficie específicos a tratar"},"max":"Máximo","method":"Method","name":"Nombre","navigation_title":"Órdenes de trabajo","new_work_order":"Nueva orden de trabajo","none_fem":"None","notes":"Apuntes","ordered_by":"Ordenado por","post":"Publicar","print":"Imprimir","privileges":{"edit_field_worksheets":"Editar hojas de trabajo de campo","edit_work_orders":"Editar órdenes de trabajo","groups":{"field_worksheets":"Hojas de trabajo de campo","work_orders":"Órdenes de trabajo"},"view_field_worksheets":"Ver hojas de trabajo de campo","view_work_orders":"Ver órdenes de trabajo"},"product":"Producto","products_to_apply":"Productos que aplicar","rate":"Ritmo","recommendation":"Recomendación","recommendation_date":"Recommendation date","recommended_by":"Recommended by","rei":"Reingreso","rei_poster":"Póster REI","rei_poster_title":"REI Póster: %{title}","related":"Registros relacionados","save":"Save","spray_record":{"account":{"choose_accounts":"Choose Accounts","choose_which_accounts_this_application_record_applies_to":"Choose which accounts this application record applies to"}},"status":"Estado","target_coverage":"Cobertura meta","target_rate":"Target rate","title":"Título","unspecified":"No especificado","untitled_work_order":"Orden de trabajo sin título","variety":"Variety","work_order":"Orden de trabajo","work_orders":{"change_fields":"Cambiar campos","confirm_delete":"¿Está seguro de que quiere eliminar a %{name}?","confirm_remove_field":"Confirm remove field","edit":{"page_help":"Use el siguiente formulario para editar esta orden de trabajo.","page_title":"Editar orden de trabajo"},"fields_editor":{"add_fields":"Añadir campos","no_fields_have_been_added":"No se ha añadido ningún campo a este orden de trabajo."},"fields_title":"Seleccionar campos","form":{"errors_encountered":{"one":"1 error prohibió que se guardara esta orden de trabajo","other":"%{count} errores prohibieron guardar esta orden de trabajo"},"organic_tooltip_when_disabled":"Este orden de trabajo ya incluye campos orgánicos.","some_options_may_be_disabled":"* Algunas opciones pueden estar desactivadas dependiendo de los campos que han sido añadidos al orden de trabajo.","start_date":"Fecha de inicio","target_coverage_percentage":"Cobertura meta","target_gallons_per_acre":"Galones por acre meta","title_optional":"Título de este orden de trabajo (opcional)"},"new":{"page_help":"Use el formulario de abajo para crear un nuevo orden de trabajo.","page_title":"Nuevo orden de trabajo"},"posted":{"no_products_were_specified":"No se ha especificado ningún producto en esta orden de trabajo"},"products_editor":{"no_products_have_been_added":"No se ha añadido ningún products.","product_already_applied":"El producto ya se aplicó","reg_number_short":"No. de registro","target_reason":"Meta/Razón","valid_product_required":"Se requiere un producto válido","valid_rate_required":"Se requiere un ritmo válido","valid_units_required":"Se requieren unidades válidas"},"search_work_orders":"Buscar órdenes de trabajo","successfully_created":"La orden de trabajo se creó con éxito","successfully_deleted":"La orden de trabajo se eliminó con éxito","successfully_posted":"Work order was successfully posted","successfully_updated":"La orden de trabajo se actualizó con éxito","tank_load_sheet":"Hoja de carga del tanque","tank_size":"Capacidad del tanque de solución","target_spray_rate":"Ritmo de rocío meta","valid_rate_required":"Se requiere un ritmo válido","valid_tank_size_required":"Se requiere una capacidad de tanque válida","valid_units_required":"Se requieren unidades válidas"}}}}}');
  }, function (e, t) {
    e.exports = function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, r) {
    var n = r(15);

    function o(e, t) {
      for (var r = 0; r < t.length; r++) {
        var o = t[r];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, n(o.key), o);
      }
    }

    e.exports = function (e, t, r) {
      return t && o(e.prototype, t), r && o(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, r) {
    var n = r(34);
    e.exports = function (e, t) {
      if (null == e) return {};
      var r,
          o,
          i = n(e, t);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);

        for (o = 0; o < a.length; o++) r = a[o], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
      }

      return i;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = d;
  }, function (e, t) {
    e.exports = y;
  }, function (e, t) {
    e.exports = b;
  }, function (e, t) {
    e.exports = h;
  }, function (e, t) {
    e.exports = v;
  }, function (e, t, r) {
    var n = r(16).default;
    e.exports = function (e, t) {
      if ("object" !== n(e) || null === e) return e;
      var r = e[Symbol.toPrimitive];

      if (void 0 !== r) {
        var o = r.call(e, t || "default");
        if ("object" !== n(o)) return o;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }

      return ("string" === t ? String : Number)(e);
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function (e) {
      if (Array.isArray(e)) return e;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function (e, t) {
      var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

      if (null != r) {
        var n,
            o,
            i,
            a,
            c = [],
            u = !0,
            l = !1;

        try {
          if (i = (r = r.call(e)).next, 0 === t) {
            if (Object(r) !== r) return;
            u = !1;
          } else for (; !(u = (n = i.call(r)).done) && (c.push(n.value), c.length !== t); u = !0);
        } catch (e) {
          l = !0, o = e;
        } finally {
          try {
            if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
          } finally {
            if (l) throw o;
          }
        }

        return c;
      }
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, r) {
    var n = r(32);
    e.exports = function (e, t) {
      if (e) {
        if ("string" == typeof e) return n(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(e, t) : void 0;
      }
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function (e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];

      return n;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function (e, t) {
      if (null == e) return {};
      var r,
          n,
          o = {},
          i = Object.keys(e);

      for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);

      return o;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, r) {
    var n = {
      "./models/field_worksheet/reference.json": 36,
      "./models/product_application.json": 37,
      "./models/product_application/product.json": 38,
      "./models/work_order.json": 39,
      "./models/work_order/crop_names.json": 40,
      "./models/work_order/field.json": 41,
      "./models/work_order/fields.json": 42,
      "./models/work_order/ordered_by.json": 43,
      "./models/work_order/product_applications.json": 44,
      "./models/work_order/recommendation.json": 45,
      "./models/work_order/recommendation/freehand.json": 46,
      "./models/work_order/recommendation/reference.json": 47,
      "./references/activerecord_reference.json": 48,
      "./references/couchbase_reference.json": 49
    };

    function o(e) {
      var t = i(e);
      return r(t);
    }

    function i(e) {
      if (!r.o(n, e)) {
        var t = new Error("Cannot find module '" + e + "'");
        throw t.code = "MODULE_NOT_FOUND", t;
      }

      return n[e];
    }

    o.keys = function () {
      return Object.keys(n);
    }, o.resolve = i, e.exports = o, o.id = 35;
  }, function (e) {
    e.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/work_orders/field_worksheet/reference","type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"}},"required":["type","id"],"additionalProperties":false}');
  }, function (e) {
    e.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/work_orders/product_application","type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"rate":{"type":"string"},"target":{"type":["string","null"]},"position":{"type":"integer"},"work_order_id":{"type":"integer"},"phi":{"type":["string","null"]},"phi_override":{"type":["string","null"]},"phi_override_by":{"type":["string","null"]},"phi_override_reason":{"type":["string","null"]},"rei":{"type":["string","null"]},"rei_override":{"type":["string","null"]},"rei_override_by":{"type":["string","null"]},"rei_override_reason":{"type":["string","null"]},"product":{"$ref":"./product_application/product"}},"required":["id","serial","product","rate","position"],"additionalProperties":false}');
  }, function (e) {
    e.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/work_orders/product_application/product","anyOf":[{"$ref":"https://schemas.miriamtech.com/if2/work_orders/internal/activerecord_reference"}]}');
  }, function (e) {
    e.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/work_orders/work_order","type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"created_at":{"type":"date-time"},"updated_at":{"type":"date-time"},"start_date":{"anyOf":[{"type":"null"},{"type":"string","format":"date"}]},"name":{"type":"string"},"status":{"type":"string","enum":["draft","posted"]},"application_method":{"type":["null","string"]},"notes":{"type":["null","string"]},"target_rate":{"type":["null","string"]},"target_coverage":{"type":["null","number","string"]},"organic":{"type":"boolean"},"max_phi":{"type":["string","null"]},"max_rei":{"type":["string","null"]},"crop_names":{"type":"array","items":{"type":"string"}},"fields":{"$ref":"./work_order/fields"},"product_applications":{"$ref":"./work_order/product_applications"},"recommendation":{"$ref":"./work_order/recommendation"},"account":{"$ref":"./internal/activerecord_reference"},"ordered_by":{"$ref":"./work_order/ordered_by"}},"required":["type","id","serial","created_at","updated_at","name","status","application_method","notes","target_rate","target_coverage","max_phi","max_rei","organic","fields","crop_names","recommendation","account","ordered_by","start_date"],"additionalProperties":false}');
  }, function (e) {
    e.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/work_orders/work_order/crop_names","type":"array","items":{"type":["string"]}}');
  }, function (e) {
    e.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/work_orders/work_order/field","type":"object","properties":{"type":{"type":"string"},"id":{"type":"string"},"serial":{"type":"integer"},"name":{"type":"string"},"area":{"type":"string"},"account":{"$ref":"https://schemas.miriamtech.com/if2/work_orders/internal/activerecord_reference"}},"required":["id","serial","name"],"additionalProperties":false}');
  }, function (e) {
    e.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/work_orders/work_order/fields","type":"array","items":{"$ref":"./field"}}');
  }, function (e) {
    e.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/work_orders/work_order/ordered_by","anyOf":[{"$ref":"https://schemas.miriamtech.com/if2/work_orders/internal/activerecord_reference"}]}');
  }, function (e) {
    e.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/work_orders/work_order/product_applications","type":"array","items":{"$ref":"https://schemas.miriamtech.com/if2/work_orders/product_application"}}');
  }, function (e) {
    e.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/work_orders/work_order/recommendation","anyOf":[{"type":"null"},{"type":"object","additionalProperties":false},{"$ref":"./recommendation/reference"},{"$ref":"./recommendation/freehand"}]}');
  }, function (e) {
    e.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/work_orders/work_order/recommendation/freehand","type":"object","properties":{"document_number":{"type":"string"},"date":{"anyOf":[{"type":"string","format":"date"},{"type":"string","maxLength":0}]},"written_by":{"type":"object","properties":{"name":{"type":"string"}},"required":["name"],"additionalProperties":false}},"additionalProperties":false}');
  }, function (e) {
    e.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/work_orders/work_order/recommendation/reference","type":"object","properties":{"id":{"type":["string"]},"serial":{"type":"integer"},"name":{"type":"string"},"document_number":{"type":"string"},"date":{"type":"string","format":"date"},"written_by":{"anyOf":[{"type":"null"},{"$ref":"https://schemas.miriamtech.com/if2/work_orders/internal/activerecord_reference"}]}},"required":["id","name","document_number"],"additionalProperties":false}');
  }, function (e) {
    e.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/work_orders/internal/activerecord_reference","type":"object","properties":{"type":{"type":"string"},"id":{"type":["integer","string"]},"serial":{"type":"integer"},"name":{"type":"string"}},"required":["id","serial","name"],"additionalProperties":false}');
  }, function (e) {
    e.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/work_orders/internal/couchbase_reference","type":"object","properties":{"id":{"type":["integer","string"]},"name":{"type":"string"}},"required":["id","name"],"additionalProperties":false}');
  }, function (e, t, r) {
    "use strict";

    r.r(t), r.d(t, "IF2WorkOrders", function () {
      return n;
    });
    var n = {};
    r.r(n), r.d(n, "LoadSheetRequestor", function () {
      return bn;
    }), r.d(n, "WorkOrderInitializer", function () {
      return vi;
    }), r.d(n, "WorkOrderFields", function () {
      return Da;
    }), r.d(n, "WorkOrderFieldsEditor", function () {
      return $c;
    }), r.d(n, "WorkOrderProducts", function () {
      return rd;
    }), r.d(n, "WorkOrdersDashboard", function () {
      return vh;
    }), r.d(n, "SprayRecordAccountSelector", function () {
      return Dh;
    }), r.d(n, "Notes", function () {
      return mv;
    }), r.d(n, "UnitSelector", function () {
      return Sv;
    });

    var o = r(0),
        i = r.n(o),
        a = r(2),
        c = r(10),
        u = r.n(c),
        l = r(12),
        s = r.n(l),
        f = r(22),
        p = r.n(f),
        d = r(20),
        y = r.n(d),
        b = r(21),
        h = r.n(b),
        v = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g,
        m = {
      "&amp;": "&",
      "&#38;": "&",
      "&lt;": "<",
      "&#60;": "<",
      "&gt;": ">",
      "&#62;": ">",
      "&apos;": "'",
      "&#39;": "'",
      "&quot;": '"',
      "&#34;": '"',
      "&nbsp;": " ",
      "&#160;": " ",
      "&copy;": "©",
      "&#169;": "©",
      "&reg;": "®",
      "&#174;": "®",
      "&hellip;": "…",
      "&#8230;": "…",
      "&#x2F;": "/",
      "&#47;": "/"
    },
        g = function (e) {
      return m[e];
    };

    function O(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function w(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? O(Object(r), !0).forEach(function (t) {
          u()(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : O(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    var P,
        j = {
      bindI18n: "languageChanged",
      bindI18nStore: "",
      transEmptyNodeValue: "",
      transSupportBasicHtmlNodes: !0,
      transWrapTextNodes: "",
      transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
      useSuspense: !0,
      unescape: function (e) {
        return e.replace(v, g);
      }
    },
        _ = Object(o.createContext)();

    function k() {
      return j;
    }

    var E = function () {
      function e() {
        y()(this, e), this.usedNamespaces = {};
      }

      return h()(e, [{
        key: "addUsedNamespaces",
        value: function (e) {
          var t = this;
          e.forEach(function (e) {
            t.usedNamespaces[e] || (t.usedNamespaces[e] = !0);
          });
        }
      }, {
        key: "getUsedNamespaces",
        value: function () {
          return Object.keys(this.usedNamespaces);
        }
      }]), e;
    }();

    function S() {
      return P;
    }

    var R = {
      type: "3rdParty",
      init: function (e) {
        !function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          j = w(w({}, j), e);
        }(e.options.react), function (e) {
          P = e;
        }(e);
      }
    };

    function x() {
      if (console && console.warn) {
        for (var e, t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];

        "string" == typeof r[0] && (r[0] = "react-i18next:: ".concat(r[0])), (e = console).warn.apply(e, r);
      }
    }

    var C = {};

    function T() {
      for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

      "string" == typeof t[0] && C[t[0]] || ("string" == typeof t[0] && (C[t[0]] = new Date()), x.apply(void 0, t));
    }

    function N(e, t, r) {
      e.loadNamespaces(t, function () {
        if (e.isInitialized) r();else {
          e.on("initialized", function t() {
            setTimeout(function () {
              e.off("initialized", t);
            }, 0), r();
          });
        }
      });
    }

    function D(e, t) {
      var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          n = t.languages[0],
          o = !!t.options && t.options.fallbackLng,
          i = t.languages[t.languages.length - 1];
      if ("cimode" === n.toLowerCase()) return !0;

      var a = function (e, r) {
        var n = t.services.backendConnector.state["".concat(e, "|").concat(r)];
        return -1 === n || 2 === n;
      };

      return !(r.bindI18n && r.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !a(t.isLanguageChangingTo, e)) && (!!t.hasResourceBundle(n, e) || !(t.services.backendConnector.backend && (!t.options.resources || t.options.partialBundledLanguages)) || !(!a(n, e) || o && !a(i, e)));
    }

    function M(e, t) {
      var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      if (!t.languages || !t.languages.length) return T("i18n.languages were undefined or empty", t.languages), !0;
      var n = void 0 !== t.options.ignoreJSONStructure;
      return n ? t.hasLoadedNamespace(e, {
        precheck: function (t, n) {
          if (r.bindI18n && r.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !n(t.isLanguageChangingTo, e)) return !1;
        }
      }) : D(e, t, r);
    }

    function A(e) {
      return e.displayName || e.name || ("string" == typeof e && e.length > 0 ? e : "Unknown");
    }

    function z(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function B(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? z(Object(r), !0).forEach(function (t) {
          u()(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : z(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    var L = function (e, t) {
      var r = Object(o.useRef)();
      return Object(o.useEffect)(function () {
        r.current = t ? r.current : e;
      }, [e, t]), r.current;
    };

    function F(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = t.i18n,
          n = Object(o.useContext)(_) || {},
          i = n.i18n,
          a = n.defaultNS,
          c = r || i || S();

      if (c && !c.reportNamespaces && (c.reportNamespaces = new E()), !c) {
        T("You will need to pass in an i18next instance by using initReactI18next");

        var u = function (e) {
          return Array.isArray(e) ? e[e.length - 1] : e;
        },
            l = [u, {}, !1];

        return l.t = u, l.i18n = {}, l.ready = !1, l;
      }

      c.options.react && void 0 !== c.options.react.wait && T("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
      var f = B(B(B({}, k()), c.options.react), t),
          p = f.useSuspense,
          d = f.keyPrefix,
          y = e || a || c.options && c.options.defaultNS;
      y = "string" == typeof y ? [y] : y || ["translation"], c.reportNamespaces.addUsedNamespaces && c.reportNamespaces.addUsedNamespaces(y);
      var b = (c.isInitialized || c.initializedStoreOnce) && y.every(function (e) {
        return M(e, c, f);
      });

      function h() {
        return c.getFixedT(null, "fallback" === f.nsMode ? y : y[0], d);
      }

      var v = Object(o.useState)(h),
          m = s()(v, 2),
          g = m[0],
          O = m[1],
          w = y.join(),
          P = L(w),
          j = Object(o.useRef)(!0);
      Object(o.useEffect)(function () {
        var e = f.bindI18n,
            t = f.bindI18nStore;

        function r() {
          j.current && O(h);
        }

        return j.current = !0, b || p || N(c, y, function () {
          j.current && O(h);
        }), b && P && P !== w && j.current && O(h), e && c && c.on(e, r), t && c && c.store.on(t, r), function () {
          j.current = !1, e && c && e.split(" ").forEach(function (e) {
            return c.off(e, r);
          }), t && c && t.split(" ").forEach(function (e) {
            return c.store.off(e, r);
          });
        };
      }, [c, w]);
      var R = Object(o.useRef)(!0);
      Object(o.useEffect)(function () {
        j.current && !R.current && O(h), R.current = !1;
      }, [c, d]);
      var x = [g, c, b];
      if (x.t = g, x.i18n = c, x.ready = b, b) return x;
      if (!b && !p) return x;
      throw new Promise(function (e) {
        N(c, y, function () {
          e();
        });
      });
    }

    var U = ["forwardedRef"];

    function I(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function q(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? I(Object(r), !0).forEach(function (t) {
          u()(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : I(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function V(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return function (r) {
        function n(n) {
          var i = n.forwardedRef,
              a = p()(n, U),
              c = F(e, q(q({}, a), {}, {
            keyPrefix: t.keyPrefix
          })),
              u = s()(c, 3),
              l = u[0],
              f = u[1],
              d = u[2],
              y = q(q({}, a), {}, {
            t: l,
            i18n: f,
            tReady: d
          });
          return t.withRef && i ? y.ref = i : !t.withRef && i && (y.forwardedRef = i), Object(o.createElement)(r, y);
        }

        n.displayName = "withI18nextTranslation(".concat(A(r), ")"), n.WrappedComponent = r;
        return t.withRef ? Object(o.forwardRef)(function (e, t) {
          return Object(o.createElement)(n, Object.assign({}, e, {
            forwardedRef: t
          }));
        }) : n;
      };
    }

    var W,
        K,
        J = r(1),
        H = r(9),
        Q = r(3),
        G = r(4);

    function Y(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function X(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var Z = (K = X((W = function () {
      function e(t) {
        var r, n, o, i;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), r = this, n = "props", i = this, (o = K) && Object.defineProperty(r, n, {
          enumerable: o.enumerable,
          configurable: o.configurable,
          writable: o.writable,
          value: o.initializer ? o.initializer.call(i) : void 0
        }), this.initialize(t);
      }

      var t, r, n;
      return t = e, (r = [{
        key: "dispose",
        value: function () {}
      }, {
        key: "initBindings",
        value: function () {}
      }, {
        key: "initialize",
        value: function (e) {
          this.update(e), this.initBindings();
        }
      }, {
        key: "update",
        value: function (e) {
          var t = this;
          Object.keys(e || {}).forEach(function (r) {
            t.props[r] = e[r];
          });
        }
      }]) && Y(t.prototype, r), n && Y(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), e;
    }()).prototype, "props", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return {};
      }
    }), X(W.prototype, "initialize", [J.action], Object.getOwnPropertyDescriptor(W.prototype, "initialize"), W.prototype), X(W.prototype, "update", [J.action], Object.getOwnPropertyDescriptor(W.prototype, "update"), W.prototype), W);

    function ee(e) {
      return (ee = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function te(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function re(e) {
      var t = function (e, t) {
        if ("object" !== ee(e) || null === e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" !== ee(n)) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" === ee(t) ? t : String(t);
    }

    function ne(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, re(n.key), n);
      }
    }

    function oe(e, t, r) {
      return t && ne(e.prototype, t), r && ne(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }

    function ie(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function ae(e, t) {
      return (ae = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function ce(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && ae(e, t);
    }

    function ue(e, t) {
      if (t && ("object" === ee(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return ie(e);
    }

    function le(e) {
      return (le = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function se(e, t, r) {
      return (t = re(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function fe(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];

      return n;
    }

    function pe(e) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(e) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return fe(e, t);
          var r = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? fe(e, t) : void 0;
        }
      }(e) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function de(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function ye(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? de(Object(r), !0).forEach(function (t) {
          se(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : de(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    var be = {
      type: "logger",
      log: function (e) {
        this.output("log", e);
      },
      warn: function (e) {
        this.output("warn", e);
      },
      error: function (e) {
        this.output("error", e);
      },
      output: function (e, t) {
        console && console[e] && console[e].apply(console, t);
      }
    },
        he = new (function () {
      function e(t) {
        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        te(this, e), this.init(t, r);
      }

      return oe(e, [{
        key: "init",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this.prefix = t.prefix || "i18next:", this.logger = e || be, this.options = t, this.debug = t.debug;
        }
      }, {
        key: "setDebug",
        value: function (e) {
          this.debug = e;
        }
      }, {
        key: "log",
        value: function () {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

          return this.forward(t, "log", "", !0);
        }
      }, {
        key: "warn",
        value: function () {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

          return this.forward(t, "warn", "", !0);
        }
      }, {
        key: "error",
        value: function () {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

          return this.forward(t, "error", "");
        }
      }, {
        key: "deprecate",
        value: function () {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

          return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
        }
      }, {
        key: "forward",
        value: function (e, t, r, n) {
          return n && !this.debug ? null : ("string" == typeof e[0] && (e[0] = "".concat(r).concat(this.prefix, " ").concat(e[0])), this.logger[t](e));
        }
      }, {
        key: "create",
        value: function (t) {
          return new e(this.logger, ye(ye({}, {
            prefix: "".concat(this.prefix, ":").concat(t, ":")
          }), this.options));
        }
      }, {
        key: "clone",
        value: function (t) {
          return (t = t || this.options).prefix = t.prefix || this.prefix, new e(this.logger, t);
        }
      }]), e;
    }())(),
        ve = function () {
      function e() {
        te(this, e), this.observers = {};
      }

      return oe(e, [{
        key: "on",
        value: function (e, t) {
          var r = this;
          return e.split(" ").forEach(function (e) {
            r.observers[e] = r.observers[e] || [], r.observers[e].push(t);
          }), this;
        }
      }, {
        key: "off",
        value: function (e, t) {
          this.observers[e] && (t ? this.observers[e] = this.observers[e].filter(function (e) {
            return e !== t;
          }) : delete this.observers[e]);
        }
      }, {
        key: "emit",
        value: function (e) {
          for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];

          if (this.observers[e]) {
            var o = [].concat(this.observers[e]);
            o.forEach(function (e) {
              e.apply(void 0, r);
            });
          }

          if (this.observers["*"]) {
            var i = [].concat(this.observers["*"]);
            i.forEach(function (t) {
              t.apply(t, [e].concat(r));
            });
          }
        }
      }]), e;
    }();

    function me() {
      var e,
          t,
          r = new Promise(function (r, n) {
        e = r, t = n;
      });
      return r.resolve = e, r.reject = t, r;
    }

    function ge(e) {
      return null == e ? "" : "" + e;
    }

    function Oe(e, t, r) {
      e.forEach(function (e) {
        t[e] && (r[e] = t[e]);
      });
    }

    function we(e, t, r) {
      function n(e) {
        return e && e.indexOf("###") > -1 ? e.replace(/###/g, ".") : e;
      }

      function o() {
        return !e || "string" == typeof e;
      }

      for (var i = "string" != typeof t ? [].concat(t) : t.split("."); i.length > 1;) {
        if (o()) return {};
        var a = n(i.shift());
        !e[a] && r && (e[a] = new r()), e = Object.prototype.hasOwnProperty.call(e, a) ? e[a] : {};
      }

      return o() ? {} : {
        obj: e,
        k: n(i.shift())
      };
    }

    function Pe(e, t, r) {
      var n = we(e, t, Object);
      n.obj[n.k] = r;
    }

    function je(e, t) {
      var r = we(e, t),
          n = r.obj,
          o = r.k;
      if (n) return n[o];
    }

    function _e(e, t, r) {
      var n = je(e, r);
      return void 0 !== n ? n : je(t, r);
    }

    function ke(e, t, r) {
      for (var n in t) "__proto__" !== n && "constructor" !== n && (n in e ? "string" == typeof e[n] || e[n] instanceof String || "string" == typeof t[n] || t[n] instanceof String ? r && (e[n] = t[n]) : ke(e[n], t[n], r) : e[n] = t[n]);

      return e;
    }

    function Ee(e) {
      return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    }

    var Se = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "/": "&#x2F;"
    };

    function Re(e) {
      return "string" == typeof e ? e.replace(/[&<>"'\/]/g, function (e) {
        return Se[e];
      }) : e;
    }

    var xe = "undefined" != typeof window && window.navigator && void 0 === window.navigator.userAgentData && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1,
        Ce = [" ", ",", "?", "!", ";"];

    function Te(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Ne(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Te(Object(r), !0).forEach(function (t) {
          se(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Te(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function De(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = le(e);

        if (t) {
          var o = le(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return ue(this, r);
      };
    }

    function Me(e, t) {
      var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ".";

      if (e) {
        if (e[t]) return e[t];

        for (var n = t.split(r), o = e, i = 0; i < n.length; ++i) {
          if (!o) return;
          if ("string" == typeof o[n[i]] && i + 1 < n.length) return;

          if (void 0 === o[n[i]]) {
            for (var a = 2, c = n.slice(i, i + a).join(r), u = o[c]; void 0 === u && n.length > i + a;) a++, u = o[c = n.slice(i, i + a).join(r)];

            if (void 0 === u) return;
            if (null === u) return null;

            if (t.endsWith(c)) {
              if ("string" == typeof u) return u;
              if (c && "string" == typeof u[c]) return u[c];
            }

            var l = n.slice(i + a).join(r);
            return l ? Me(u, l, r) : void 0;
          }

          o = o[n[i]];
        }

        return o;
      }
    }

    var Ae = function (e) {
      ce(r, e);
      var t = De(r);

      function r(e) {
        var n,
            o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
          ns: ["translation"],
          defaultNS: "translation"
        };
        return te(this, r), n = t.call(this), xe && ve.call(ie(n)), n.data = e || {}, n.options = o, void 0 === n.options.keySeparator && (n.options.keySeparator = "."), void 0 === n.options.ignoreJSONStructure && (n.options.ignoreJSONStructure = !0), n;
      }

      return oe(r, [{
        key: "addNamespaces",
        value: function (e) {
          this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
        }
      }, {
        key: "removeNamespaces",
        value: function (e) {
          var t = this.options.ns.indexOf(e);
          t > -1 && this.options.ns.splice(t, 1);
        }
      }, {
        key: "getResource",
        value: function (e, t, r) {
          var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
              o = void 0 !== n.keySeparator ? n.keySeparator : this.options.keySeparator,
              i = void 0 !== n.ignoreJSONStructure ? n.ignoreJSONStructure : this.options.ignoreJSONStructure,
              a = [e, t];
          r && "string" != typeof r && (a = a.concat(r)), r && "string" == typeof r && (a = a.concat(o ? r.split(o) : r)), e.indexOf(".") > -1 && (a = e.split("."));
          var c = je(this.data, a);
          return c || !i || "string" != typeof r ? c : Me(this.data && this.data[e] && this.data[e][t], r, o);
        }
      }, {
        key: "addResource",
        value: function (e, t, r, n) {
          var o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {
            silent: !1
          },
              i = this.options.keySeparator;
          void 0 === i && (i = ".");
          var a = [e, t];
          r && (a = a.concat(i ? r.split(i) : r)), e.indexOf(".") > -1 && (n = t, t = (a = e.split("."))[1]), this.addNamespaces(t), Pe(this.data, a, n), o.silent || this.emit("added", e, t, r, n);
        }
      }, {
        key: "addResources",
        value: function (e, t, r) {
          var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
            silent: !1
          };

          for (var o in r) "string" != typeof r[o] && "[object Array]" !== Object.prototype.toString.apply(r[o]) || this.addResource(e, t, o, r[o], {
            silent: !0
          });

          n.silent || this.emit("added", e, t, r);
        }
      }, {
        key: "addResourceBundle",
        value: function (e, t, r, n, o) {
          var i = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {
            silent: !1
          },
              a = [e, t];
          e.indexOf(".") > -1 && (n = r, r = t, t = (a = e.split("."))[1]), this.addNamespaces(t);
          var c = je(this.data, a) || {};
          n ? ke(c, r, o) : c = Ne(Ne({}, c), r), Pe(this.data, a, c), i.silent || this.emit("added", e, t, r);
        }
      }, {
        key: "removeResourceBundle",
        value: function (e, t) {
          this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
        }
      }, {
        key: "hasResourceBundle",
        value: function (e, t) {
          return void 0 !== this.getResource(e, t);
        }
      }, {
        key: "getResourceBundle",
        value: function (e, t) {
          return t || (t = this.options.defaultNS), "v1" === this.options.compatibilityAPI ? Ne(Ne({}, {}), this.getResource(e, t)) : this.getResource(e, t);
        }
      }, {
        key: "getDataByLanguage",
        value: function (e) {
          return this.data[e];
        }
      }, {
        key: "hasLanguageSomeTranslations",
        value: function (e) {
          var t = this.getDataByLanguage(e);
          return !!(t && Object.keys(t) || []).find(function (e) {
            return t[e] && Object.keys(t[e]).length > 0;
          });
        }
      }, {
        key: "toJSON",
        value: function () {
          return this.data;
        }
      }]), r;
    }(ve),
        ze = {
      processors: {},
      addPostProcessor: function (e) {
        this.processors[e.name] = e;
      },
      handle: function (e, t, r, n, o) {
        var i = this;
        return e.forEach(function (e) {
          i.processors[e] && (t = i.processors[e].process(t, r, n, o));
        }), t;
      }
    };

    function Be(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Le(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Be(Object(r), !0).forEach(function (t) {
          se(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Be(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Fe(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = le(e);

        if (t) {
          var o = le(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return ue(this, r);
      };
    }

    var Ue = {},
        Ie = function (e) {
      ce(r, e);
      var t = Fe(r);

      function r(e) {
        var n,
            o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return te(this, r), n = t.call(this), xe && ve.call(ie(n)), Oe(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, ie(n)), n.options = o, void 0 === n.options.keySeparator && (n.options.keySeparator = "."), n.logger = he.create("translator"), n;
      }

      return oe(r, [{
        key: "changeLanguage",
        value: function (e) {
          e && (this.language = e);
        }
      }, {
        key: "exists",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            interpolation: {}
          };
          if (null == e) return !1;
          var r = this.resolve(e, t);
          return r && void 0 !== r.res;
        }
      }, {
        key: "extractFromKey",
        value: function (e, t) {
          var r = void 0 !== t.nsSeparator ? t.nsSeparator : this.options.nsSeparator;
          void 0 === r && (r = ":");
          var n = void 0 !== t.keySeparator ? t.keySeparator : this.options.keySeparator,
              o = t.ns || this.options.defaultNS || [],
              i = r && e.indexOf(r) > -1,
              a = !(this.options.userDefinedKeySeparator || t.keySeparator || this.options.userDefinedNsSeparator || t.nsSeparator || function (e, t, r) {
            t = t || "", r = r || "";
            var n = Ce.filter(function (e) {
              return t.indexOf(e) < 0 && r.indexOf(e) < 0;
            });
            if (0 === n.length) return !0;
            var o = new RegExp("(".concat(n.map(function (e) {
              return "?" === e ? "\\?" : e;
            }).join("|"), ")")),
                i = !o.test(e);

            if (!i) {
              var a = e.indexOf(r);
              a > 0 && !o.test(e.substring(0, a)) && (i = !0);
            }

            return i;
          }(e, r, n));

          if (i && !a) {
            var c = e.match(this.interpolator.nestingRegexp);
            if (c && c.length > 0) return {
              key: e,
              namespaces: o
            };
            var u = e.split(r);
            (r !== n || r === n && this.options.ns.indexOf(u[0]) > -1) && (o = u.shift()), e = u.join(n);
          }

          return "string" == typeof o && (o = [o]), {
            key: e,
            namespaces: o
          };
        }
      }, {
        key: "translate",
        value: function (e, t, n) {
          var o = this;
          if ("object" !== ee(t) && this.options.overloadTranslationOptionHandler && (t = this.options.overloadTranslationOptionHandler(arguments)), t || (t = {}), null == e) return "";
          Array.isArray(e) || (e = [String(e)]);
          var i = void 0 !== t.returnDetails ? t.returnDetails : this.options.returnDetails,
              a = void 0 !== t.keySeparator ? t.keySeparator : this.options.keySeparator,
              c = this.extractFromKey(e[e.length - 1], t),
              u = c.key,
              l = c.namespaces,
              s = l[l.length - 1],
              f = t.lng || this.language,
              p = t.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

          if (f && "cimode" === f.toLowerCase()) {
            if (p) {
              var d = t.nsSeparator || this.options.nsSeparator;
              return i ? (y.res = "".concat(s).concat(d).concat(u), y) : "".concat(s).concat(d).concat(u);
            }

            return i ? (y.res = u, y) : u;
          }

          var y = this.resolve(e, t),
              b = y && y.res,
              h = y && y.usedKey || u,
              v = y && y.exactUsedKey || u,
              m = Object.prototype.toString.apply(b),
              g = ["[object Number]", "[object Function]", "[object RegExp]"],
              O = void 0 !== t.joinArrays ? t.joinArrays : this.options.joinArrays,
              w = !this.i18nFormat || this.i18nFormat.handleAsObject,
              P = "string" != typeof b && "boolean" != typeof b && "number" != typeof b;

          if (w && b && P && g.indexOf(m) < 0 && ("string" != typeof O || "[object Array]" !== m)) {
            if (!t.returnObjects && !this.options.returnObjects) {
              this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
              var j = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(h, b, Le(Le({}, t), {}, {
                ns: l
              })) : "key '".concat(u, " (").concat(this.language, ")' returned an object instead of string.");
              return i ? (y.res = j, y) : j;
            }

            if (a) {
              var _ = "[object Array]" === m,
                  k = _ ? [] : {},
                  E = _ ? v : h;

              for (var S in b) if (Object.prototype.hasOwnProperty.call(b, S)) {
                var R = "".concat(E).concat(a).concat(S);
                k[S] = this.translate(R, Le(Le({}, t), {
                  joinArrays: !1,
                  ns: l
                })), k[S] === R && (k[S] = b[S]);
              }

              b = k;
            }
          } else if (w && "string" == typeof O && "[object Array]" === m) (b = b.join(O)) && (b = this.extendTranslation(b, e, t, n));else {
            var x = !1,
                C = !1,
                T = void 0 !== t.count && "string" != typeof t.count,
                N = r.hasDefaultValue(t),
                D = T ? this.pluralResolver.getSuffix(f, t.count, t) : "",
                M = t["defaultValue".concat(D)] || t.defaultValue;
            !this.isValidLookup(b) && N && (x = !0, b = M), this.isValidLookup(b) || (C = !0, b = u);
            var A = t.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey,
                z = A && C ? void 0 : b,
                B = N && M !== b && this.options.updateMissing;

            if (C || x || B) {
              if (this.logger.log(B ? "updateKey" : "missingKey", f, s, u, B ? M : b), a) {
                var L = this.resolve(u, Le(Le({}, t), {}, {
                  keySeparator: !1
                }));
                L && L.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
              }

              var F = [],
                  U = this.languageUtils.getFallbackCodes(this.options.fallbackLng, t.lng || this.language);
              if ("fallback" === this.options.saveMissingTo && U && U[0]) for (var I = 0; I < U.length; I++) F.push(U[I]);else "all" === this.options.saveMissingTo ? F = this.languageUtils.toResolveHierarchy(t.lng || this.language) : F.push(t.lng || this.language);

              var q = function (e, r, n) {
                var i = N && n !== b ? n : z;
                o.options.missingKeyHandler ? o.options.missingKeyHandler(e, s, r, i, B, t) : o.backendConnector && o.backendConnector.saveMissing && o.backendConnector.saveMissing(e, s, r, i, B, t), o.emit("missingKey", e, s, r, b);
              };

              this.options.saveMissing && (this.options.saveMissingPlurals && T ? F.forEach(function (e) {
                o.pluralResolver.getSuffixes(e, t).forEach(function (r) {
                  q([e], u + r, t["defaultValue".concat(r)] || M);
                });
              }) : q(F, u, M));
            }

            b = this.extendTranslation(b, e, t, y, n), C && b === u && this.options.appendNamespaceToMissingKey && (b = "".concat(s, ":").concat(u)), (C || x) && this.options.parseMissingKeyHandler && (b = "v1" !== this.options.compatibilityAPI ? this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(s, ":").concat(u) : u, x ? b : void 0) : this.options.parseMissingKeyHandler(b));
          }

          return i ? (y.res = b, y) : b;
        }
      }, {
        key: "extendTranslation",
        value: function (e, t, r, n, o) {
          var i = this;
          if (this.i18nFormat && this.i18nFormat.parse) e = this.i18nFormat.parse(e, Le(Le({}, this.options.interpolation.defaultVariables), r), n.usedLng, n.usedNS, n.usedKey, {
            resolved: n
          });else if (!r.skipInterpolation) {
            r.interpolation && this.interpolator.init(Le(Le({}, r), {
              interpolation: Le(Le({}, this.options.interpolation), r.interpolation)
            }));
            var a,
                c = "string" == typeof e && (r && r.interpolation && void 0 !== r.interpolation.skipOnVariables ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);

            if (c) {
              var u = e.match(this.interpolator.nestingRegexp);
              a = u && u.length;
            }

            var l = r.replace && "string" != typeof r.replace ? r.replace : r;

            if (this.options.interpolation.defaultVariables && (l = Le(Le({}, this.options.interpolation.defaultVariables), l)), e = this.interpolator.interpolate(e, l, r.lng || this.language, r), c) {
              var s = e.match(this.interpolator.nestingRegexp);
              a < (s && s.length) && (r.nest = !1);
            }

            !1 !== r.nest && (e = this.interpolator.nest(e, function () {
              for (var e = arguments.length, n = new Array(e), a = 0; a < e; a++) n[a] = arguments[a];

              return o && o[0] === n[0] && !r.context ? (i.logger.warn("It seems you are nesting recursively key: ".concat(n[0], " in key: ").concat(t[0])), null) : i.translate.apply(i, n.concat([t]));
            }, r)), r.interpolation && this.interpolator.reset();
          }
          var f = r.postProcess || this.options.postProcess,
              p = "string" == typeof f ? [f] : f;
          return null != e && p && p.length && !1 !== r.applyPostProcessor && (e = ze.handle(p, e, t, this.options && this.options.postProcessPassResolved ? Le({
            i18nResolved: n
          }, r) : r, this)), e;
        }
      }, {
        key: "resolve",
        value: function (e) {
          var t,
              r,
              n,
              o,
              i,
              a = this,
              c = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return "string" == typeof e && (e = [e]), e.forEach(function (e) {
            if (!a.isValidLookup(t)) {
              var u = a.extractFromKey(e, c),
                  l = u.key;
              r = l;
              var s = u.namespaces;
              a.options.fallbackNS && (s = s.concat(a.options.fallbackNS));
              var f = void 0 !== c.count && "string" != typeof c.count,
                  p = f && !c.ordinal && 0 === c.count && a.pluralResolver.shouldUseIntlApi(),
                  d = void 0 !== c.context && ("string" == typeof c.context || "number" == typeof c.context) && "" !== c.context,
                  y = c.lngs ? c.lngs : a.languageUtils.toResolveHierarchy(c.lng || a.language, c.fallbackLng);
              s.forEach(function (e) {
                a.isValidLookup(t) || (i = e, !Ue["".concat(y[0], "-").concat(e)] && a.utils && a.utils.hasLoadedNamespace && !a.utils.hasLoadedNamespace(i) && (Ue["".concat(y[0], "-").concat(e)] = !0, a.logger.warn('key "'.concat(r, '" for languages "').concat(y.join(", "), '" won\'t get resolved as namespace "').concat(i, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), y.forEach(function (r) {
                  if (!a.isValidLookup(t)) {
                    o = r;
                    var i,
                        u = [l];
                    if (a.i18nFormat && a.i18nFormat.addLookupKeys) a.i18nFormat.addLookupKeys(u, l, r, e, c);else {
                      var s;
                      f && (s = a.pluralResolver.getSuffix(r, c.count, c));
                      var y = "".concat(a.options.pluralSeparator, "zero");

                      if (f && (u.push(l + s), p && u.push(l + y)), d) {
                        var b = "".concat(l).concat(a.options.contextSeparator).concat(c.context);
                        u.push(b), f && (u.push(b + s), p && u.push(b + y));
                      }
                    }

                    for (; i = u.pop();) a.isValidLookup(t) || (n = i, t = a.getResource(r, e, i, c));
                  }
                }));
              });
            }
          }), {
            res: t,
            usedKey: r,
            exactUsedKey: n,
            usedLng: o,
            usedNS: i
          };
        }
      }, {
        key: "isValidLookup",
        value: function (e) {
          return !(void 0 === e || !this.options.returnNull && null === e || !this.options.returnEmptyString && "" === e);
        }
      }, {
        key: "getResource",
        value: function (e, t, r) {
          var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
          return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, t, r, n) : this.resourceStore.getResource(e, t, r, n);
        }
      }], [{
        key: "hasDefaultValue",
        value: function (e) {
          for (var t in e) if (Object.prototype.hasOwnProperty.call(e, t) && "defaultValue" === t.substring(0, "defaultValue".length) && void 0 !== e[t]) return !0;

          return !1;
        }
      }]), r;
    }(ve);

    function qe(e) {
      return e.charAt(0).toUpperCase() + e.slice(1);
    }

    var Ve = function () {
      function e(t) {
        te(this, e), this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = he.create("languageUtils");
      }

      return oe(e, [{
        key: "getScriptPartFromCode",
        value: function (e) {
          if (!e || e.indexOf("-") < 0) return null;
          var t = e.split("-");
          return 2 === t.length ? null : (t.pop(), "x" === t[t.length - 1].toLowerCase() ? null : this.formatLanguageCode(t.join("-")));
        }
      }, {
        key: "getLanguagePartFromCode",
        value: function (e) {
          if (!e || e.indexOf("-") < 0) return e;
          var t = e.split("-");
          return this.formatLanguageCode(t[0]);
        }
      }, {
        key: "formatLanguageCode",
        value: function (e) {
          if ("string" == typeof e && e.indexOf("-") > -1) {
            var t = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"],
                r = e.split("-");
            return this.options.lowerCaseLng ? r = r.map(function (e) {
              return e.toLowerCase();
            }) : 2 === r.length ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), t.indexOf(r[1].toLowerCase()) > -1 && (r[1] = qe(r[1].toLowerCase()))) : 3 === r.length && (r[0] = r[0].toLowerCase(), 2 === r[1].length && (r[1] = r[1].toUpperCase()), "sgn" !== r[0] && 2 === r[2].length && (r[2] = r[2].toUpperCase()), t.indexOf(r[1].toLowerCase()) > -1 && (r[1] = qe(r[1].toLowerCase())), t.indexOf(r[2].toLowerCase()) > -1 && (r[2] = qe(r[2].toLowerCase()))), r.join("-");
          }

          return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
        }
      }, {
        key: "isSupportedCode",
        value: function (e) {
          return ("languageOnly" === this.options.load || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
        }
      }, {
        key: "getBestMatchFromCodes",
        value: function (e) {
          var t,
              r = this;
          return e ? (e.forEach(function (e) {
            if (!t) {
              var n = r.formatLanguageCode(e);
              r.options.supportedLngs && !r.isSupportedCode(n) || (t = n);
            }
          }), !t && this.options.supportedLngs && e.forEach(function (e) {
            if (!t) {
              var n = r.getLanguagePartFromCode(e);
              if (r.isSupportedCode(n)) return t = n;
              t = r.options.supportedLngs.find(function (e) {
                if (0 === e.indexOf(n)) return e;
              });
            }
          }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t) : null;
        }
      }, {
        key: "getFallbackCodes",
        value: function (e, t) {
          if (!e) return [];
          if ("function" == typeof e && (e = e(t)), "string" == typeof e && (e = [e]), "[object Array]" === Object.prototype.toString.apply(e)) return e;
          if (!t) return e.default || [];
          var r = e[t];
          return r || (r = e[this.getScriptPartFromCode(t)]), r || (r = e[this.formatLanguageCode(t)]), r || (r = e[this.getLanguagePartFromCode(t)]), r || (r = e.default), r || [];
        }
      }, {
        key: "toResolveHierarchy",
        value: function (e, t) {
          var r = this,
              n = this.getFallbackCodes(t || this.options.fallbackLng || [], e),
              o = [],
              i = function (e) {
            e && (r.isSupportedCode(e) ? o.push(e) : r.logger.warn("rejecting language code not found in supportedLngs: ".concat(e)));
          };

          return "string" == typeof e && e.indexOf("-") > -1 ? ("languageOnly" !== this.options.load && i(this.formatLanguageCode(e)), "languageOnly" !== this.options.load && "currentOnly" !== this.options.load && i(this.getScriptPartFromCode(e)), "currentOnly" !== this.options.load && i(this.getLanguagePartFromCode(e))) : "string" == typeof e && i(this.formatLanguageCode(e)), n.forEach(function (e) {
            o.indexOf(e) < 0 && i(r.formatLanguageCode(e));
          }), o;
        }
      }]), e;
    }(),
        We = [{
      lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
      nr: [1, 2],
      fc: 1
    }, {
      lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
      nr: [1, 2],
      fc: 2
    }, {
      lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
      nr: [1],
      fc: 3
    }, {
      lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
      nr: [1, 2, 5],
      fc: 4
    }, {
      lngs: ["ar"],
      nr: [0, 1, 2, 3, 11, 100],
      fc: 5
    }, {
      lngs: ["cs", "sk"],
      nr: [1, 2, 5],
      fc: 6
    }, {
      lngs: ["csb", "pl"],
      nr: [1, 2, 5],
      fc: 7
    }, {
      lngs: ["cy"],
      nr: [1, 2, 3, 8],
      fc: 8
    }, {
      lngs: ["fr"],
      nr: [1, 2],
      fc: 9
    }, {
      lngs: ["ga"],
      nr: [1, 2, 3, 7, 11],
      fc: 10
    }, {
      lngs: ["gd"],
      nr: [1, 2, 3, 20],
      fc: 11
    }, {
      lngs: ["is"],
      nr: [1, 2],
      fc: 12
    }, {
      lngs: ["jv"],
      nr: [0, 1],
      fc: 13
    }, {
      lngs: ["kw"],
      nr: [1, 2, 3, 4],
      fc: 14
    }, {
      lngs: ["lt"],
      nr: [1, 2, 10],
      fc: 15
    }, {
      lngs: ["lv"],
      nr: [1, 2, 0],
      fc: 16
    }, {
      lngs: ["mk"],
      nr: [1, 2],
      fc: 17
    }, {
      lngs: ["mnk"],
      nr: [0, 1, 2],
      fc: 18
    }, {
      lngs: ["mt"],
      nr: [1, 2, 11, 20],
      fc: 19
    }, {
      lngs: ["or"],
      nr: [2, 1],
      fc: 2
    }, {
      lngs: ["ro"],
      nr: [1, 2, 20],
      fc: 20
    }, {
      lngs: ["sl"],
      nr: [5, 1, 2, 3],
      fc: 21
    }, {
      lngs: ["he", "iw"],
      nr: [1, 2, 20, 21],
      fc: 22
    }],
        Ke = {
      1: function (e) {
        return Number(e > 1);
      },
      2: function (e) {
        return Number(1 != e);
      },
      3: function (e) {
        return 0;
      },
      4: function (e) {
        return Number(e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
      },
      5: function (e) {
        return Number(0 == e ? 0 : 1 == e ? 1 : 2 == e ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5);
      },
      6: function (e) {
        return Number(1 == e ? 0 : e >= 2 && e <= 4 ? 1 : 2);
      },
      7: function (e) {
        return Number(1 == e ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
      },
      8: function (e) {
        return Number(1 == e ? 0 : 2 == e ? 1 : 8 != e && 11 != e ? 2 : 3);
      },
      9: function (e) {
        return Number(e >= 2);
      },
      10: function (e) {
        return Number(1 == e ? 0 : 2 == e ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4);
      },
      11: function (e) {
        return Number(1 == e || 11 == e ? 0 : 2 == e || 12 == e ? 1 : e > 2 && e < 20 ? 2 : 3);
      },
      12: function (e) {
        return Number(e % 10 != 1 || e % 100 == 11);
      },
      13: function (e) {
        return Number(0 !== e);
      },
      14: function (e) {
        return Number(1 == e ? 0 : 2 == e ? 1 : 3 == e ? 2 : 3);
      },
      15: function (e) {
        return Number(e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
      },
      16: function (e) {
        return Number(e % 10 == 1 && e % 100 != 11 ? 0 : 0 !== e ? 1 : 2);
      },
      17: function (e) {
        return Number(1 == e || e % 10 == 1 && e % 100 != 11 ? 0 : 1);
      },
      18: function (e) {
        return Number(0 == e ? 0 : 1 == e ? 1 : 2);
      },
      19: function (e) {
        return Number(1 == e ? 0 : 0 == e || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3);
      },
      20: function (e) {
        return Number(1 == e ? 0 : 0 == e || e % 100 > 0 && e % 100 < 20 ? 1 : 2);
      },
      21: function (e) {
        return Number(e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0);
      },
      22: function (e) {
        return Number(1 == e ? 0 : 2 == e ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3);
      }
    },
        Je = ["v1", "v2", "v3"],
        He = {
      zero: 0,
      one: 1,
      two: 2,
      few: 3,
      many: 4,
      other: 5
    };

    function $e() {
      var e = {};
      return We.forEach(function (t) {
        t.lngs.forEach(function (r) {
          e[r] = {
            numbers: t.nr,
            plurals: Ke[t.fc]
          };
        });
      }), e;
    }

    var Qe = function () {
      function e(t) {
        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        te(this, e), this.languageUtils = t, this.options = r, this.logger = he.create("pluralResolver"), this.options.compatibilityJSON && "v4" !== this.options.compatibilityJSON || "undefined" != typeof Intl && Intl.PluralRules || (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = $e();
      }

      return oe(e, [{
        key: "addRule",
        value: function (e, t) {
          this.rules[e] = t;
        }
      }, {
        key: "getRule",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (this.shouldUseIntlApi()) try {
            return new Intl.PluralRules(e, {
              type: t.ordinal ? "ordinal" : "cardinal"
            });
          } catch (e) {
            return;
          }
          return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
        }
      }, {
        key: "needsPlural",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = this.getRule(e, t);
          return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
        }
      }, {
        key: "getPluralFormsOfKey",
        value: function (e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          return this.getSuffixes(e, r).map(function (e) {
            return "".concat(t).concat(e);
          });
        }
      }, {
        key: "getSuffixes",
        value: function (e) {
          var t = this,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = this.getRule(e, r);
          return n ? this.shouldUseIntlApi() ? n.resolvedOptions().pluralCategories.sort(function (e, t) {
            return He[e] - He[t];
          }).map(function (e) {
            return "".concat(t.options.prepend).concat(e);
          }) : n.numbers.map(function (n) {
            return t.getSuffix(e, n, r);
          }) : [];
        }
      }, {
        key: "getSuffix",
        value: function (e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              n = this.getRule(e, r);
          return n ? this.shouldUseIntlApi() ? "".concat(this.options.prepend).concat(n.select(t)) : this.getSuffixRetroCompatible(n, t) : (this.logger.warn("no plural rule found for: ".concat(e)), "");
        }
      }, {
        key: "getSuffixRetroCompatible",
        value: function (e, t) {
          var r = this,
              n = e.noAbs ? e.plurals(t) : e.plurals(Math.abs(t)),
              o = e.numbers[n];
          this.options.simplifyPluralSuffix && 2 === e.numbers.length && 1 === e.numbers[0] && (2 === o ? o = "plural" : 1 === o && (o = ""));

          var i = function () {
            return r.options.prepend && o.toString() ? r.options.prepend + o.toString() : o.toString();
          };

          return "v1" === this.options.compatibilityJSON ? 1 === o ? "" : "number" == typeof o ? "_plural_".concat(o.toString()) : i() : "v2" === this.options.compatibilityJSON || this.options.simplifyPluralSuffix && 2 === e.numbers.length && 1 === e.numbers[0] ? i() : this.options.prepend && n.toString() ? this.options.prepend + n.toString() : n.toString();
        }
      }, {
        key: "shouldUseIntlApi",
        value: function () {
          return !Je.includes(this.options.compatibilityJSON);
        }
      }]), e;
    }();

    function Ge(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Ye(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Ge(Object(r), !0).forEach(function (t) {
          se(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ge(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    var Xe = function () {
      function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        te(this, e), this.logger = he.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || function (e) {
          return e;
        }, this.init(t);
      }

      return oe(e, [{
        key: "init",
        value: function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          e.interpolation || (e.interpolation = {
            escapeValue: !0
          });
          var t = e.interpolation;
          this.escape = void 0 !== t.escape ? t.escape : Re, this.escapeValue = void 0 === t.escapeValue || t.escapeValue, this.useRawValueToEscape = void 0 !== t.useRawValueToEscape && t.useRawValueToEscape, this.prefix = t.prefix ? Ee(t.prefix) : t.prefixEscaped || "{{", this.suffix = t.suffix ? Ee(t.suffix) : t.suffixEscaped || "}}", this.formatSeparator = t.formatSeparator ? t.formatSeparator : t.formatSeparator || ",", this.unescapePrefix = t.unescapeSuffix ? "" : t.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : t.unescapeSuffix || "", this.nestingPrefix = t.nestingPrefix ? Ee(t.nestingPrefix) : t.nestingPrefixEscaped || Ee("$t("), this.nestingSuffix = t.nestingSuffix ? Ee(t.nestingSuffix) : t.nestingSuffixEscaped || Ee(")"), this.nestingOptionsSeparator = t.nestingOptionsSeparator ? t.nestingOptionsSeparator : t.nestingOptionsSeparator || ",", this.maxReplaces = t.maxReplaces ? t.maxReplaces : 1e3, this.alwaysFormat = void 0 !== t.alwaysFormat && t.alwaysFormat, this.resetRegExp();
        }
      }, {
        key: "reset",
        value: function () {
          this.options && this.init(this.options);
        }
      }, {
        key: "resetRegExp",
        value: function () {
          var e = "".concat(this.prefix, "(.+?)").concat(this.suffix);
          this.regexp = new RegExp(e, "g");
          var t = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
          this.regexpUnescape = new RegExp(t, "g");
          var r = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
          this.nestingRegexp = new RegExp(r, "g");
        }
      }, {
        key: "interpolate",
        value: function (e, t, r, n) {
          var o,
              i,
              a,
              c = this,
              u = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

          function l(e) {
            return e.replace(/\$/g, "$$$$");
          }

          var s = function (e) {
            if (e.indexOf(c.formatSeparator) < 0) {
              var o = _e(t, u, e);

              return c.alwaysFormat ? c.format(o, void 0, r, Ye(Ye(Ye({}, n), t), {}, {
                interpolationkey: e
              })) : o;
            }

            var i = e.split(c.formatSeparator),
                a = i.shift().trim(),
                l = i.join(c.formatSeparator).trim();
            return c.format(_e(t, u, a), l, r, Ye(Ye(Ye({}, n), t), {}, {
              interpolationkey: a
            }));
          };

          this.resetRegExp();
          var f = n && n.missingInterpolationHandler || this.options.missingInterpolationHandler,
              p = n && n.interpolation && void 0 !== n.interpolation.skipOnVariables ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
          return [{
            regex: this.regexpUnescape,
            safeValue: function (e) {
              return l(e);
            }
          }, {
            regex: this.regexp,
            safeValue: function (e) {
              return c.escapeValue ? l(c.escape(e)) : l(e);
            }
          }].forEach(function (t) {
            for (a = 0; o = t.regex.exec(e);) {
              var r = o[1].trim();
              if (void 0 === (i = s(r))) {
                if ("function" == typeof f) {
                  var u = f(e, o, n);
                  i = "string" == typeof u ? u : "";
                } else if (n && n.hasOwnProperty(r)) i = "";else {
                  if (p) {
                    i = o[0];
                    continue;
                  }

                  c.logger.warn("missed to pass in variable ".concat(r, " for interpolating ").concat(e)), i = "";
                }
              } else "string" == typeof i || c.useRawValueToEscape || (i = ge(i));
              var l = t.safeValue(i);
              if (e = e.replace(o[0], l), p ? (t.regex.lastIndex += i.length, t.regex.lastIndex -= o[0].length) : t.regex.lastIndex = 0, ++a >= c.maxReplaces) break;
            }
          }), e;
        }
      }, {
        key: "nest",
        value: function (e, t) {
          var r,
              n,
              o = this,
              i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              a = Ye({}, i);

          function c(e, t) {
            var r = this.nestingOptionsSeparator;
            if (e.indexOf(r) < 0) return e;
            var n = e.split(new RegExp("".concat(r, "[ ]*{"))),
                o = "{".concat(n[1]);
            e = n[0];
            var i = (o = this.interpolate(o, a)).match(/'/g),
                c = o.match(/"/g);
            (i && i.length % 2 == 0 && !c || c.length % 2 != 0) && (o = o.replace(/'/g, '"'));

            try {
              a = JSON.parse(o), t && (a = Ye(Ye({}, t), a));
            } catch (t) {
              return this.logger.warn("failed parsing options string in nesting for key ".concat(e), t), "".concat(e).concat(r).concat(o);
            }

            return delete a.defaultValue, e;
          }

          for (a.applyPostProcessor = !1, delete a.defaultValue; r = this.nestingRegexp.exec(e);) {
            var u = [],
                l = !1;

            if (-1 !== r[0].indexOf(this.formatSeparator) && !/{.*}/.test(r[1])) {
              var s = r[1].split(this.formatSeparator).map(function (e) {
                return e.trim();
              });
              r[1] = s.shift(), u = s, l = !0;
            }

            if ((n = t(c.call(this, r[1].trim(), a), a)) && r[0] === e && "string" != typeof n) return n;
            "string" != typeof n && (n = ge(n)), n || (this.logger.warn("missed to resolve ".concat(r[1], " for nesting ").concat(e)), n = ""), l && (n = u.reduce(function (e, t) {
              return o.format(e, t, i.lng, Ye(Ye({}, i), {}, {
                interpolationkey: r[1].trim()
              }));
            }, n.trim())), e = e.replace(r[0], n), this.regexp.lastIndex = 0;
          }

          return e;
        }
      }]), e;
    }();

    function Ze(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function et(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Ze(Object(r), !0).forEach(function (t) {
          se(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ze(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function tt(e) {
      var t = {};
      return function (r, n, o) {
        var i = n + JSON.stringify(o),
            a = t[i];
        return a || (a = e(n, o), t[i] = a), a(r);
      };
    }

    var rt = function () {
      function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        te(this, e), this.logger = he.create("formatter"), this.options = t, this.formats = {
          number: tt(function (e, t) {
            var r = new Intl.NumberFormat(e, t);
            return function (e) {
              return r.format(e);
            };
          }),
          currency: tt(function (e, t) {
            var r = new Intl.NumberFormat(e, et(et({}, t), {}, {
              style: "currency"
            }));
            return function (e) {
              return r.format(e);
            };
          }),
          datetime: tt(function (e, t) {
            var r = new Intl.DateTimeFormat(e, et({}, t));
            return function (e) {
              return r.format(e);
            };
          }),
          relativetime: tt(function (e, t) {
            var r = new Intl.RelativeTimeFormat(e, et({}, t));
            return function (e) {
              return r.format(e, t.range || "day");
            };
          }),
          list: tt(function (e, t) {
            var r = new Intl.ListFormat(e, et({}, t));
            return function (e) {
              return r.format(e);
            };
          })
        }, this.init(t);
      }

      return oe(e, [{
        key: "init",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            interpolation: {}
          },
              r = t.interpolation;
          this.formatSeparator = r.formatSeparator ? r.formatSeparator : r.formatSeparator || ",";
        }
      }, {
        key: "add",
        value: function (e, t) {
          this.formats[e.toLowerCase().trim()] = t;
        }
      }, {
        key: "addCached",
        value: function (e, t) {
          this.formats[e.toLowerCase().trim()] = tt(t);
        }
      }, {
        key: "format",
        value: function (e, t, r, n) {
          var o = this;
          return t.split(this.formatSeparator).reduce(function (e, t) {
            var i = function (e) {
              var t = e.toLowerCase().trim(),
                  r = {};

              if (e.indexOf("(") > -1) {
                var n = e.split("(");
                t = n[0].toLowerCase().trim();
                var o = n[1].substring(0, n[1].length - 1);
                if ("currency" === t && o.indexOf(":") < 0) r.currency || (r.currency = o.trim());else if ("relativetime" === t && o.indexOf(":") < 0) r.range || (r.range = o.trim());else {
                  o.split(";").forEach(function (e) {
                    if (e) {
                      var t = pe(e.split(":")),
                          n = t[0],
                          o = t.slice(1).join(":").trim().replace(/^'+|'+$/g, "");
                      r[n.trim()] || (r[n.trim()] = o), "false" === o && (r[n.trim()] = !1), "true" === o && (r[n.trim()] = !0), isNaN(o) || (r[n.trim()] = parseInt(o, 10));
                    }
                  });
                }
              }

              return {
                formatName: t,
                formatOptions: r
              };
            }(t),
                a = i.formatName,
                c = i.formatOptions;

            if (o.formats[a]) {
              var u = e;

              try {
                var l = n && n.formatParams && n.formatParams[n.interpolationkey] || {},
                    s = l.locale || l.lng || n.locale || n.lng || r;
                u = o.formats[a](e, s, et(et(et({}, c), n), l));
              } catch (e) {
                o.logger.warn(e);
              }

              return u;
            }

            return o.logger.warn("there was no format function for ".concat(a)), e;
          }, e);
        }
      }]), e;
    }();

    function nt(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function ot(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? nt(Object(r), !0).forEach(function (t) {
          se(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : nt(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function it(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = le(e);

        if (t) {
          var o = le(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return ue(this, r);
      };
    }

    var at = function (e) {
      ce(r, e);
      var t = it(r);

      function r(e, n, o) {
        var i,
            a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
        return te(this, r), i = t.call(this), xe && ve.call(ie(i)), i.backend = e, i.store = n, i.services = o, i.languageUtils = o.languageUtils, i.options = a, i.logger = he.create("backendConnector"), i.waitingReads = [], i.maxParallelReads = a.maxParallelReads || 10, i.readingCalls = 0, i.maxRetries = a.maxRetries >= 0 ? a.maxRetries : 5, i.retryTimeout = a.retryTimeout >= 1 ? a.retryTimeout : 350, i.state = {}, i.queue = [], i.backend && i.backend.init && i.backend.init(o, a.backend, a), i;
      }

      return oe(r, [{
        key: "queueLoad",
        value: function (e, t, r, n) {
          var o = this,
              i = {},
              a = {},
              c = {},
              u = {};
          return e.forEach(function (e) {
            var n = !0;
            t.forEach(function (t) {
              var c = "".concat(e, "|").concat(t);
              !r.reload && o.store.hasResourceBundle(e, t) ? o.state[c] = 2 : o.state[c] < 0 || (1 === o.state[c] ? void 0 === a[c] && (a[c] = !0) : (o.state[c] = 1, n = !1, void 0 === a[c] && (a[c] = !0), void 0 === i[c] && (i[c] = !0), void 0 === u[t] && (u[t] = !0)));
            }), n || (c[e] = !0);
          }), (Object.keys(i).length || Object.keys(a).length) && this.queue.push({
            pending: a,
            pendingCount: Object.keys(a).length,
            loaded: {},
            errors: [],
            callback: n
          }), {
            toLoad: Object.keys(i),
            pending: Object.keys(a),
            toLoadLanguages: Object.keys(c),
            toLoadNamespaces: Object.keys(u)
          };
        }
      }, {
        key: "loaded",
        value: function (e, t, r) {
          var n = e.split("|"),
              o = n[0],
              i = n[1];
          t && this.emit("failedLoading", o, i, t), r && this.store.addResourceBundle(o, i, r), this.state[e] = t ? -1 : 2;
          var a = {};
          this.queue.forEach(function (r) {
            var n, c, u, l, s, f;
            n = r.loaded, c = i, l = we(n, [o], Object), s = l.obj, f = l.k, s[f] = s[f] || [], u && (s[f] = s[f].concat(c)), u || s[f].push(c), function (e, t) {
              void 0 !== e.pending[t] && (delete e.pending[t], e.pendingCount--);
            }(r, e), t && r.errors.push(t), 0 !== r.pendingCount || r.done || (Object.keys(r.loaded).forEach(function (e) {
              a[e] || (a[e] = {});
              var t = r.loaded[e];
              t.length && t.forEach(function (t) {
                void 0 === a[e][t] && (a[e][t] = !0);
              });
            }), r.done = !0, r.errors.length ? r.callback(r.errors) : r.callback());
          }), this.emit("loaded", a), this.queue = this.queue.filter(function (e) {
            return !e.done;
          });
        }
      }, {
        key: "read",
        value: function (e, t, r) {
          var n = this,
              o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
              i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : this.retryTimeout,
              a = arguments.length > 5 ? arguments[5] : void 0;
          return e.length ? this.readingCalls >= this.maxParallelReads ? void this.waitingReads.push({
            lng: e,
            ns: t,
            fcName: r,
            tried: o,
            wait: i,
            callback: a
          }) : (this.readingCalls++, this.backend[r](e, t, function (c, u) {
            if (n.readingCalls--, n.waitingReads.length > 0) {
              var l = n.waitingReads.shift();
              n.read(l.lng, l.ns, l.fcName, l.tried, l.wait, l.callback);
            }

            c && u && o < n.maxRetries ? setTimeout(function () {
              n.read.call(n, e, t, r, o + 1, 2 * i, a);
            }, i) : a(c, u);
          })) : a(null, {});
        }
      }, {
        key: "prepareLoading",
        value: function (e, t) {
          var r = this,
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              o = arguments.length > 3 ? arguments[3] : void 0;
          if (!this.backend) return this.logger.warn("No backend was added via i18next.use. Will not load resources."), o && o();
          "string" == typeof e && (e = this.languageUtils.toResolveHierarchy(e)), "string" == typeof t && (t = [t]);
          var i = this.queueLoad(e, t, n, o);
          if (!i.toLoad.length) return i.pending.length || o(), null;
          i.toLoad.forEach(function (e) {
            r.loadOne(e);
          });
        }
      }, {
        key: "load",
        value: function (e, t, r) {
          this.prepareLoading(e, t, {}, r);
        }
      }, {
        key: "reload",
        value: function (e, t, r) {
          this.prepareLoading(e, t, {
            reload: !0
          }, r);
        }
      }, {
        key: "loadOne",
        value: function (e) {
          var t = this,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
              n = e.split("|"),
              o = n[0],
              i = n[1];
          this.read(o, i, "read", void 0, void 0, function (n, a) {
            n && t.logger.warn("".concat(r, "loading namespace ").concat(i, " for language ").concat(o, " failed"), n), !n && a && t.logger.log("".concat(r, "loaded namespace ").concat(i, " for language ").concat(o), a), t.loaded(e, n, a);
          });
        }
      }, {
        key: "saveMissing",
        value: function (e, t, r, n, o) {
          var i = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {};
          this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t) ? this.logger.warn('did not save key "'.concat(r, '" as the namespace "').concat(t, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!") : null != r && "" !== r && (this.backend && this.backend.create && this.backend.create(e, t, r, n, null, ot(ot({}, i), {}, {
            isUpdate: o
          })), e && e[0] && this.store.addResource(e[0], t, r, n));
        }
      }]), r;
    }(ve);

    function ct() {
      return {
        debug: !1,
        initImmediate: !0,
        ns: ["translation"],
        defaultNS: ["translation"],
        fallbackLng: ["dev"],
        fallbackNS: !1,
        supportedLngs: !1,
        nonExplicitSupportedLngs: !1,
        load: "all",
        preload: !1,
        simplifyPluralSuffix: !0,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: !1,
        saveMissing: !1,
        updateMissing: !1,
        saveMissingTo: "fallback",
        saveMissingPlurals: !0,
        missingKeyHandler: !1,
        missingInterpolationHandler: !1,
        postProcess: !1,
        postProcessPassResolved: !1,
        returnNull: !0,
        returnEmptyString: !0,
        returnObjects: !1,
        joinArrays: !1,
        returnedObjectHandler: !1,
        parseMissingKeyHandler: !1,
        appendNamespaceToMissingKey: !1,
        appendNamespaceToCIMode: !1,
        overloadTranslationOptionHandler: function (e) {
          var t = {};

          if ("object" === ee(e[1]) && (t = e[1]), "string" == typeof e[1] && (t.defaultValue = e[1]), "string" == typeof e[2] && (t.tDescription = e[2]), "object" === ee(e[2]) || "object" === ee(e[3])) {
            var r = e[3] || e[2];
            Object.keys(r).forEach(function (e) {
              t[e] = r[e];
            });
          }

          return t;
        },
        interpolation: {
          escapeValue: !0,
          format: function (e, t, r, n) {
            return e;
          },
          prefix: "{{",
          suffix: "}}",
          formatSeparator: ",",
          unescapePrefix: "-",
          nestingPrefix: "$t(",
          nestingSuffix: ")",
          nestingOptionsSeparator: ",",
          maxReplaces: 1e3,
          skipOnVariables: !0
        }
      };
    }

    function ut(e) {
      return "string" == typeof e.ns && (e.ns = [e.ns]), "string" == typeof e.fallbackLng && (e.fallbackLng = [e.fallbackLng]), "string" == typeof e.fallbackNS && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e;
    }

    function lt(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function st(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? lt(Object(r), !0).forEach(function (t) {
          se(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : lt(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function ft(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = le(e);

        if (t) {
          var o = le(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return ue(this, r);
      };
    }

    function pt() {}

    function dt(e) {
      Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach(function (t) {
        "function" == typeof e[t] && (e[t] = e[t].bind(e));
      });
    }

    var yt = function (e) {
      ce(r, e);
      var t = ft(r);

      function r() {
        var e,
            n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            o = arguments.length > 1 ? arguments[1] : void 0;

        if (te(this, r), e = t.call(this), xe && ve.call(ie(e)), e.options = ut(n), e.services = {}, e.logger = he, e.modules = {
          external: []
        }, dt(ie(e)), o && !e.isInitialized && !n.isClone) {
          if (!e.options.initImmediate) return e.init(n, o), ue(e, ie(e));
          setTimeout(function () {
            e.init(n, o);
          }, 0);
        }

        return e;
      }

      return oe(r, [{
        key: "init",
        value: function () {
          var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              r = arguments.length > 1 ? arguments[1] : void 0;
          "function" == typeof t && (r = t, t = {}), !t.defaultNS && !1 !== t.defaultNS && t.ns && ("string" == typeof t.ns ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
          var n = ct();

          function o(e) {
            return e ? "function" == typeof e ? new e() : e : null;
          }

          if (this.options = st(st(st({}, n), this.options), ut(t)), "v1" !== this.options.compatibilityAPI && (this.options.interpolation = st(st({}, n.interpolation), this.options.interpolation)), void 0 !== t.keySeparator && (this.options.userDefinedKeySeparator = t.keySeparator), void 0 !== t.nsSeparator && (this.options.userDefinedNsSeparator = t.nsSeparator), !this.options.isClone) {
            var i;
            this.modules.logger ? he.init(o(this.modules.logger), this.options) : he.init(null, this.options), this.modules.formatter ? i = this.modules.formatter : "undefined" != typeof Intl && (i = rt);
            var a = new Ve(this.options);
            this.store = new Ae(this.options.resources, this.options);
            var c = this.services;
            c.logger = he, c.resourceStore = this.store, c.languageUtils = a, c.pluralResolver = new Qe(a, {
              prepend: this.options.pluralSeparator,
              compatibilityJSON: this.options.compatibilityJSON,
              simplifyPluralSuffix: this.options.simplifyPluralSuffix
            }), !i || this.options.interpolation.format && this.options.interpolation.format !== n.interpolation.format || (c.formatter = o(i), c.formatter.init(c, this.options), this.options.interpolation.format = c.formatter.format.bind(c.formatter)), c.interpolator = new Xe(this.options), c.utils = {
              hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            }, c.backendConnector = new at(o(this.modules.backend), c.resourceStore, c, this.options), c.backendConnector.on("*", function (t) {
              for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) n[o - 1] = arguments[o];

              e.emit.apply(e, [t].concat(n));
            }), this.modules.languageDetector && (c.languageDetector = o(this.modules.languageDetector), c.languageDetector.init(c, this.options.detection, this.options)), this.modules.i18nFormat && (c.i18nFormat = o(this.modules.i18nFormat), c.i18nFormat.init && c.i18nFormat.init(this)), this.translator = new Ie(this.services, this.options), this.translator.on("*", function (t) {
              for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) n[o - 1] = arguments[o];

              e.emit.apply(e, [t].concat(n));
            }), this.modules.external.forEach(function (t) {
              t.init && t.init(e);
            });
          }

          if (this.format = this.options.interpolation.format, r || (r = pt), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            var u = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            u.length > 0 && "dev" !== u[0] && (this.options.lng = u[0]);
          }

          this.services.languageDetector || this.options.lng || this.logger.warn("init: no languageDetector is used and no lng is defined");
          var l = ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"];
          l.forEach(function (t) {
            e[t] = function () {
              var r;
              return (r = e.store)[t].apply(r, arguments);
            };
          });
          var s = ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"];
          s.forEach(function (t) {
            e[t] = function () {
              var r;
              return (r = e.store)[t].apply(r, arguments), e;
            };
          });

          var f = me(),
              p = function () {
            var t = function (t, n) {
              e.isInitialized && !e.initializedStoreOnce && e.logger.warn("init: i18next is already initialized. You should call init just once!"), e.isInitialized = !0, e.options.isClone || e.logger.log("initialized", e.options), e.emit("initialized", e.options), f.resolve(n), r(t, n);
            };

            if (e.languages && "v1" !== e.options.compatibilityAPI && !e.isInitialized) return t(null, e.t.bind(e));
            e.changeLanguage(e.options.lng, t);
          };

          return this.options.resources || !this.options.initImmediate ? p() : setTimeout(p, 0), f;
        }
      }, {
        key: "loadResources",
        value: function (e) {
          var t = this,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : pt,
              n = r,
              o = "string" == typeof e ? e : this.language;

          if ("function" == typeof e && (n = e), !this.options.resources || this.options.partialBundledLanguages) {
            if (o && "cimode" === o.toLowerCase()) return n();

            var i = [],
                a = function (e) {
              e && t.services.languageUtils.toResolveHierarchy(e).forEach(function (e) {
                i.indexOf(e) < 0 && i.push(e);
              });
            };

            if (o) a(o);else {
              var c = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
              c.forEach(function (e) {
                return a(e);
              });
            }
            this.options.preload && this.options.preload.forEach(function (e) {
              return a(e);
            }), this.services.backendConnector.load(i, this.options.ns, function (e) {
              e || t.resolvedLanguage || !t.language || t.setResolvedLanguage(t.language), n(e);
            });
          } else n(null);
        }
      }, {
        key: "reloadResources",
        value: function (e, t, r) {
          var n = me();
          return e || (e = this.languages), t || (t = this.options.ns), r || (r = pt), this.services.backendConnector.reload(e, t, function (e) {
            n.resolve(), r(e);
          }), n;
        }
      }, {
        key: "use",
        value: function (e) {
          if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
          if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
          return "backend" === e.type && (this.modules.backend = e), ("logger" === e.type || e.log && e.warn && e.error) && (this.modules.logger = e), "languageDetector" === e.type && (this.modules.languageDetector = e), "i18nFormat" === e.type && (this.modules.i18nFormat = e), "postProcessor" === e.type && ze.addPostProcessor(e), "formatter" === e.type && (this.modules.formatter = e), "3rdParty" === e.type && this.modules.external.push(e), this;
        }
      }, {
        key: "setResolvedLanguage",
        value: function (e) {
          if (e && this.languages && !(["cimode", "dev"].indexOf(e) > -1)) for (var t = 0; t < this.languages.length; t++) {
            var r = this.languages[t];

            if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
              this.resolvedLanguage = r;
              break;
            }
          }
        }
      }, {
        key: "changeLanguage",
        value: function (e, t) {
          var r = this;
          this.isLanguageChangingTo = e;
          var n = me();
          this.emit("languageChanging", e);

          var o = function (e) {
            r.language = e, r.languages = r.services.languageUtils.toResolveHierarchy(e), r.resolvedLanguage = void 0, r.setResolvedLanguage(e);
          },
              i = function (i) {
            e || i || !r.services.languageDetector || (i = []);
            var a = "string" == typeof i ? i : r.services.languageUtils.getBestMatchFromCodes(i);
            a && (r.language || o(a), r.translator.language || r.translator.changeLanguage(a), r.services.languageDetector && r.services.languageDetector.cacheUserLanguage(a)), r.loadResources(a, function (e) {
              !function (e, i) {
                i ? (o(i), r.translator.changeLanguage(i), r.isLanguageChangingTo = void 0, r.emit("languageChanged", i), r.logger.log("languageChanged", i)) : r.isLanguageChangingTo = void 0, n.resolve(function () {
                  return r.t.apply(r, arguments);
                }), t && t(e, function () {
                  return r.t.apply(r, arguments);
                });
              }(e, a);
            });
          };

          return e || !this.services.languageDetector || this.services.languageDetector.async ? !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect(i) : i(e) : i(this.services.languageDetector.detect()), n;
        }
      }, {
        key: "getFixedT",
        value: function (e, t, r) {
          var n = this,
              o = function e(t, o) {
            var i;

            if ("object" !== ee(o)) {
              for (var a = arguments.length, c = new Array(a > 2 ? a - 2 : 0), u = 2; u < a; u++) c[u - 2] = arguments[u];

              i = n.options.overloadTranslationOptionHandler([t, o].concat(c));
            } else i = st({}, o);

            i.lng = i.lng || e.lng, i.lngs = i.lngs || e.lngs, i.ns = i.ns || e.ns, i.keyPrefix = i.keyPrefix || r || e.keyPrefix;
            var l = n.options.keySeparator || ".",
                s = i.keyPrefix ? "".concat(i.keyPrefix).concat(l).concat(t) : t;
            return n.t(s, i);
          };

          return "string" == typeof e ? o.lng = e : o.lngs = e, o.ns = t, o.keyPrefix = r, o;
        }
      }, {
        key: "t",
        value: function () {
          var e;
          return this.translator && (e = this.translator).translate.apply(e, arguments);
        }
      }, {
        key: "exists",
        value: function () {
          var e;
          return this.translator && (e = this.translator).exists.apply(e, arguments);
        }
      }, {
        key: "setDefaultNamespace",
        value: function (e) {
          this.options.defaultNS = e;
        }
      }, {
        key: "hasLoadedNamespace",
        value: function (e) {
          var t = this,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (!this.isInitialized) return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
          if (!this.languages || !this.languages.length) return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
          var n = this.resolvedLanguage || this.languages[0],
              o = !!this.options && this.options.fallbackLng,
              i = this.languages[this.languages.length - 1];
          if ("cimode" === n.toLowerCase()) return !0;

          var a = function (e, r) {
            var n = t.services.backendConnector.state["".concat(e, "|").concat(r)];
            return -1 === n || 2 === n;
          };

          if (r.precheck) {
            var c = r.precheck(this, a);
            if (void 0 !== c) return c;
          }

          return !!this.hasResourceBundle(n, e) || !(this.services.backendConnector.backend && (!this.options.resources || this.options.partialBundledLanguages)) || !(!a(n, e) || o && !a(i, e));
        }
      }, {
        key: "loadNamespaces",
        value: function (e, t) {
          var r = this,
              n = me();
          return this.options.ns ? ("string" == typeof e && (e = [e]), e.forEach(function (e) {
            r.options.ns.indexOf(e) < 0 && r.options.ns.push(e);
          }), this.loadResources(function (e) {
            n.resolve(), t && t(e);
          }), n) : (t && t(), Promise.resolve());
        }
      }, {
        key: "loadLanguages",
        value: function (e, t) {
          var r = me();
          "string" == typeof e && (e = [e]);
          var n = this.options.preload || [],
              o = e.filter(function (e) {
            return n.indexOf(e) < 0;
          });
          return o.length ? (this.options.preload = n.concat(o), this.loadResources(function (e) {
            r.resolve(), t && t(e);
          }), r) : (t && t(), Promise.resolve());
        }
      }, {
        key: "dir",
        value: function (e) {
          if (e || (e = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !e) return "rtl";
          return ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"].indexOf(this.services.languageUtils.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
        }
      }, {
        key: "cloneInstance",
        value: function () {
          var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : pt,
              o = st(st(st({}, this.options), t), {
            isClone: !0
          }),
              i = new r(o);
          void 0 === t.debug && void 0 === t.prefix || (i.logger = i.logger.clone(t));
          var a = ["store", "services", "language"];
          return a.forEach(function (t) {
            i[t] = e[t];
          }), i.services = st({}, this.services), i.services.utils = {
            hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
          }, i.translator = new Ie(i.services, i.options), i.translator.on("*", function (e) {
            for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];

            i.emit.apply(i, [e].concat(r));
          }), i.init(o, n), i.translator.options = i.options, i.translator.backendConnector.services.utils = {
            hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
          }, i;
        }
      }, {
        key: "toJSON",
        value: function () {
          return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
          };
        }
      }]), r;
    }(ve);

    se(yt, "createInstance", function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = arguments.length > 1 ? arguments[1] : void 0;
      return new yt(e, t);
    });
    var bt = yt.createInstance();
    bt.createInstance = yt.createInstance;
    bt.createInstance, bt.init, bt.loadResources, bt.reloadResources, bt.use, bt.changeLanguage, bt.getFixedT, bt.t, bt.exists, bt.setDefaultNamespace, bt.hasLoadedNamespace, bt.loadNamespaces, bt.loadLanguages;
    var ht = bt,
        vt = r(17),
        mt = r.n(vt),
        gt = r(18),
        Ot = r(19);

    function wt(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

        if (null != r) {
          var n,
              o,
              i,
              a,
              c = [],
              u = !0,
              l = !1;

          try {
            if (i = (r = r.call(e)).next, 0 === t) {
              if (Object(r) !== r) return;
              u = !1;
            } else for (; !(u = (n = i.call(r)).done) && (c.push(n.value), c.length !== t); u = !0);
          } catch (e) {
            l = !0, o = e;
          } finally {
            try {
              if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
            } finally {
              if (l) throw o;
            }
          }

          return c;
        }
      }(e, t) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return Pt(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === r && e.constructor && (r = e.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(e);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Pt(e, t);
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Pt(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];

      return n;
    }

    function jt(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function _t(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? jt(Object(r), !0).forEach(function (t) {
          kt(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : jt(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function kt(e, t, r) {
      return (t = function (e) {
        var t = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(e, "string");

        return "symbol" == typeof t ? t : String(t);
      }(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    var Et = {
      en: {
        translation: St(gt.en)
      },
      es: {
        translation: St(Ot.es)
      }
    };

    function St(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          r = {};
      return Object.keys(e).forEach(function (n) {
        var o = e[n],
            i = n;
        t.length > 0 && (i = "".concat(t, ".").concat(n)), "string" == typeof o ? r[i] = o : r = _t(_t({}, r), St(o, i));
      }), r;
    }

    ht.use(mt.a).use(R).init({
      resources: Et,
      languages: ["en", "es"],
      fallbackLng: "en",
      detection: {
        order: ["querystring", "path"],
        lookupFromPathIndex: 1,
        lookupQuerystring: "locale"
      },
      keySeparator: !0,
      interpolation: {
        escapeValue: !1,
        prefix: "%{",
        suffix: "}"
      }
    });

    var Rt = function () {
      var e,
          t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          r = arguments.length > 1 ? arguments[1] : void 0,
          n = r || ht,
          o = (null === (e = n.options) || void 0 === e ? void 0 : e.fallbackLng) || [],
          i = wt(o, 1),
          a = i[0],
          c = _t({}, t);

      return n.resolvedLanguage !== a && (c.locale = n.resolvedLanguage), c;
    },
        xt = r(7),
        Ct = r.n(xt);

    function Tt(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Nt(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Dt(e) {
      var t = "function" == typeof Map ? new Map() : void 0;
      return (Dt = function (e) {
        if (null === e || (r = e, -1 === Function.toString.call(r).indexOf("[native code]"))) return e;
        var r;
        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

        if (void 0 !== t) {
          if (t.has(e)) return t.get(e);
          t.set(e, n);
        }

        function n() {
          return Mt(e, arguments, Bt(this).constructor);
        }

        return n.prototype = Object.create(e.prototype, {
          constructor: {
            value: n,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), zt(n, e);
      })(e);
    }

    function Mt(e, t, r) {
      return (Mt = At() ? Reflect.construct.bind() : function (e, t, r) {
        var n = [null];
        n.push.apply(n, t);
        var o = new (Function.bind.apply(e, n))();
        return r && zt(o, r.prototype), o;
      }).apply(null, arguments);
    }

    function At() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }

    function zt(e, t) {
      return (zt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Bt(e) {
      return (Bt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Lt = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && zt(e, t);
      }(c, e);
      var t,
          r,
          n,
          o,
          i,
          a = (t = c, r = At(), function () {
        var e,
            n = Bt(t);

        if (r) {
          var o = Bt(this).constructor;
          e = Reflect.construct(n, arguments, o);
        } else e = n.apply(this, arguments);

        return Nt(this, e);
      });

      function c(e) {
        var t;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, c), (t = a.call(this, e.message || e.statusText)).status = e.status, t.statusText = e.statusText, t.errors = e.errors || [], t;
      }

      return n = c, (o = [{
        key: "formatMessage",
        value: function () {
          return [].concat(this.message || []).concat(this.errors || []).join("\n\t") || this;
        }
      }]) && Tt(n.prototype, o), i && Tt(n, i), Object.defineProperty(n, "prototype", {
        writable: !1
      }), c;
    }(Dt(Error));

    function Ft(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    var Ut = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e);
      }

      var t, r, n;
      return t = e, (r = [{
        key: "getGenericMessage",
        value: function (e) {
          return (null == e ? void 0 : e.message) || "An unexpected error occurred while fetching";
        }
      }, {
        key: "notFoundError",
        value: function (e) {
          throw new Error(this.getGenericMessage(e));
        }
      }, {
        key: "unprocessableError",
        value: function (e) {
          throw new Error(this.getGenericMessage(e));
        }
      }, {
        key: "csrf",
        value: function () {
          return document.querySelector("[name='csrf-token']").content;
        }
      }, {
        key: "handleFetchResponse",
        value: function (e) {
          if (204 !== e.status) return e.ok ? e.json() : e.json().catch(function () {
            throw new Lt({
              status: e.status,
              statusText: e.statusText
            });
          }).then(function (t) {
            throw new Lt({
              status: e.status,
              statusText: e.statusText,
              errors: t.errors
            });
          });
        }
      }, {
        key: "jsonFetch",
        value: function (e, t, r) {
          var n = this,
              o = {
            method: t || "GET",
            headers: {
              "X-CSRF-Token": this.csrf(),
              "Content-Type": "application/json",
              Accept: "application/json"
            }
          };
          return r && (o.body = JSON.stringify(r)), fetch(e, o).then(function (e) {
            return n.handleFetchResponse(e);
          });
        }
      }]) && Ft(t.prototype, r), n && Ft(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), e;
    }();

    function It(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function qt(e, t) {
      return (qt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Vt(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Kt(e);

        if (t) {
          var o = Kt(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Wt(this, r);
      };
    }

    function Wt(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Kt(e) {
      return (Kt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Jt,
        Ht,
        $t,
        Qt,
        Gt = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && qt(e, t);
      }(i, e);
      var t,
          r,
          n,
          o = Vt(i);

      function i(e) {
        var t;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, i);
        var r = e || {};
        return (t = o.call(this, e)).loadSheetPathPattern = r.loadSheetPathPattern && new Ct.a(r.loadSheetPathPattern, t.constructor.urlPatternOptions), t.i18n = r.i18n || ht, t;
      }

      return t = i, (r = [{
        key: "loadSheetPath",
        value: function (e) {
          var t,
              r = Rt({
            id: e
          }, this.i18n);
          return (null === (t = this.loadSheetPathPattern) || void 0 === t ? void 0 : t.stringify(r)) || "";
        }
      }]) && It(t.prototype, r), n && It(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(Ut);

    function Yt(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Xt(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Zt(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function er() {
      return (er = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = tr(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(this, arguments);
    }

    function tr(e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = ar(e)););

      return e;
    }

    function rr(e, t) {
      return (rr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function nr(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = ar(e);

        if (t) {
          var o = ar(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return or(this, r);
      };
    }

    function or(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return ir(e);
    }

    function ir(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function ar(e) {
      return (ar = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function cr(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    Gt.urlPatternOptions = {
      segmentNameCharset: "a-zA-Z0-9_"
    };
    var ur,
        lr = (Ht = cr((Jt = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && rr(e, t);
      }(i, e);
      var t,
          r,
          n,
          o = nr(i);

      function i() {
        var e;
        Xt(this, i);

        for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];

        return Yt(e = o.call.apply(o, [this].concat(r)), "value", Ht, ir(e)), Yt(e, "scalarError", $t, ir(e)), Yt(e, "unitsError", Qt, ir(e)), e;
      }

      return t = i, (r = [{
        key: "scalar",
        get: function () {
          return this.value.scalar;
        }
      }, {
        key: "scalarErrorText",
        get: function () {
          return this.props.scalarErrorText;
        }
      }, {
        key: "units",
        get: function () {
          return this.value.units;
        }
      }, {
        key: "unitsErrorText",
        get: function () {
          return this.props.unitsErrorText;
        }
      }, {
        key: "areUnitsValid",
        value: function () {
          return this.value.units;
        }
      }, {
        key: "initBindings",
        value: function () {
          er(ar(i.prototype), "initBindings", this).call(this), this.onUpdateUnit = this.onUpdateUnit.bind(this), this.onUpdateScalar = this.onUpdateScalar.bind(this);
        }
      }, {
        key: "isScalarValid",
        value: function () {
          return this.value.scalar > 0;
        }
      }, {
        key: "onUpdateUnit",
        value: function (e) {
          this.value.units = e, this.areUnitsValid() && this.resetUnitsError();
        }
      }, {
        key: "onUpdateScalar",
        value: function (e) {
          this.value.scalar = e, this.isScalarValid() && this.resetScalarError();
        }
      }, {
        key: "resetErrors",
        value: function () {
          this.resetScalarError(), this.resetUnitsError();
        }
      }, {
        key: "resetScalarError",
        value: function () {
          this.scalarError = "";
        }
      }, {
        key: "resetUnitsError",
        value: function () {
          this.unitsError = "";
        }
      }, {
        key: "update",
        value: function (e) {
          var t = this;
          er(ar(i.prototype), "update", this).call(this, e), Object.keys(this.props).filter(function (e) {
            return ["scalar", "units"].includes(e);
          }).forEach(function (e) {
            return t.value[e] = t.props[e];
          });
        }
      }, {
        key: "validate",
        value: function () {
          return [this.validateScalar(), this.validateUnits()].every(H.identity);
        }
      }, {
        key: "validateScalar",
        value: function () {
          return !!this.isScalarValid() || (this.scalarError = this.scalarErrorText, !1);
        }
      }, {
        key: "validateUnits",
        value: function () {
          return !!this.areUnitsValid() || (this.unitsError = this.unitsErrorText, !1);
        }
      }]) && Zt(t.prototype, r), n && Zt(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(Z)).prototype, "value", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new G.Quantity();
      }
    }), $t = cr(Jt.prototype, "scalarError", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Qt = cr(Jt.prototype, "unitsError", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), cr(Jt.prototype, "scalar", [J.computed], Object.getOwnPropertyDescriptor(Jt.prototype, "scalar"), Jt.prototype), cr(Jt.prototype, "scalarErrorText", [J.computed], Object.getOwnPropertyDescriptor(Jt.prototype, "scalarErrorText"), Jt.prototype), cr(Jt.prototype, "units", [J.computed], Object.getOwnPropertyDescriptor(Jt.prototype, "units"), Jt.prototype), cr(Jt.prototype, "unitsErrorText", [J.computed], Object.getOwnPropertyDescriptor(Jt.prototype, "unitsErrorText"), Jt.prototype), cr(Jt.prototype, "onUpdateUnit", [J.action], Object.getOwnPropertyDescriptor(Jt.prototype, "onUpdateUnit"), Jt.prototype), cr(Jt.prototype, "onUpdateScalar", [J.action], Object.getOwnPropertyDescriptor(Jt.prototype, "onUpdateScalar"), Jt.prototype), cr(Jt.prototype, "resetScalarError", [J.action], Object.getOwnPropertyDescriptor(Jt.prototype, "resetScalarError"), Jt.prototype), cr(Jt.prototype, "resetUnitsError", [J.action], Object.getOwnPropertyDescriptor(Jt.prototype, "resetUnitsError"), Jt.prototype), cr(Jt.prototype, "update", [J.action], Object.getOwnPropertyDescriptor(Jt.prototype, "update"), Jt.prototype), Jt);

    function sr(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function fr() {
      return (fr = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = pr(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(this, arguments);
    }

    function pr(e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = hr(e)););

      return e;
    }

    function dr(e, t) {
      return (dr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function yr(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = hr(e);

        if (t) {
          var o = hr(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return br(this, r);
      };
    }

    function br(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function hr(e) {
      return (hr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function vr(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var mr,
        gr = (vr((ur = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && dr(e, t);
      }(i, e);
      var t,
          r,
          n,
          o = yr(i);

      function i(e) {
        var t, r, n, a, c;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, i);
        var u = (c = o.call(this, e)).props.loadSheetPathPattern;
        return c.tankSize = new lr({
          units: "gal",
          scalarErrorText: c.t("if2.work_orders.work_orders.valid_tank_size_required"),
          unitsErrorText: c.t("if2.work_orders.work_orders.valid_units_required")
        }), c.targetRate = new lr({
          scalar: (null === (t = c.workOrder) || void 0 === t || null === (r = t.targetRate) || void 0 === r ? void 0 : r.scalar) || "",
          units: (null === (n = c.workOrder) || void 0 === n || null === (a = n.targetRate) || void 0 === a ? void 0 : a.units) || "gal/acre",
          scalarErrorText: c.t("if2.work_orders.work_orders.valid_rate_required"),
          unitsErrorText: c.t("if2.work_orders.work_orders.valid_units_required")
        }), c.api = new Gt({
          loadSheetPathPattern: u
        }), c;
      }

      return t = i, (r = [{
        key: "disableModalAnimation",
        get: function () {
          return this.props.disableModalAnimation || !1;
        }
      }, {
        key: "loadSheetPath",
        get: function () {
          return this.api.loadSheetPath(this.workOrder.serial);
        }
      }, {
        key: "loadSheetRequestPath",
        get: function () {
          return "".concat(this.loadSheetPath, "?").concat(new URLSearchParams({
            tank_size: this.tankSize.value.toJS(),
            target_rate: this.targetRate.value.toJS()
          }));
        }
      }, {
        key: "modalHeaderId",
        get: function () {
          return "".concat(this.modal.id, "-header");
        }
      }, {
        key: "t",
        get: function () {
          return this.props.t || ht.t.bind(ht);
        }
      }, {
        key: "tankSizeUnitChoices",
        get: function () {
          return ["gal", "l"].map(function (e) {
            return {
              unit: e,
              value: e,
              displayName: G.Quantity.formatUnits(e)
            };
          });
        }
      }, {
        key: "targetSprayRateUnitChoices",
        get: function () {
          var e = [];
          return [{
            system: "US",
            numerators: ["floz", "pt", "qt", "gal"],
            denominators: ["acre", "hgal"]
          }, {
            system: "Metric (SI)",
            numerators: ["ml", "l"],
            denominators: ["hectare"]
          }, {
            system: "Metric (SI)",
            numerators: ["ml"],
            denominators: ["l"]
          }, {
            system: "Hybrid (US/Metric)",
            numerators: ["ml", "l"],
            denominators: ["acre"]
          }, {
            system: "Hybrid (US/Metric)",
            numerators: ["ml"],
            denominators: ["gal", "hgal"]
          }].forEach(function (t) {
            var r = t.system,
                n = t.numerators;
            t.denominators.forEach(function (t) {
              n.forEach(function (n) {
                var o = "".concat(n, "/").concat(t);
                e.push({
                  group: r,
                  value: o,
                  displayName: G.Quantity.formatUnits(o)
                });
              });
            });
          }), e;
        }
      }, {
        key: "workOrder",
        get: function () {
          return this.props.workOrder;
        }
      }, {
        key: "formatError",
        value: function (e) {
          var t;
          return (null === (t = e.formatMessage) || void 0 === t ? void 0 : t.call(e)) || e.message || e;
        }
      }, {
        key: "initBindings",
        value: function () {
          fr(hr(i.prototype), "initBindings", this).call(this), this.modal = new Q.ModalModel({
            title: this.t("if2.work_orders.work_orders.tank_load_sheet")
          }), this.onCancel = this.onCancel.bind(this), this.onRequestLoadSheet = this.onRequestLoadSheet.bind(this), this.onShowModal = this.modal.show.bind(this.modal);
        }
      }, {
        key: "notifyError",
        value: function (e) {
          window.alert(this.formatError(e)), console.error(this.formatError(e));
        }
      }, {
        key: "onCancel",
        value: function () {
          this.modal.hide(), this.reset();
        }
      }, {
        key: "onRequestLoadSheet",
        value: function (e) {
          return this.validate() ? e : e.preventDefault();
        }
      }, {
        key: "reset",
        value: function () {
          var e, t, r, n;
          this.tankSize.update({
            scalar: "",
            units: "gal"
          }), this.targetRate.update({
            scalar: (null === (e = this.workOrder) || void 0 === e || null === (t = e.targetRate) || void 0 === t ? void 0 : t.scalar) || "",
            units: (null === (r = this.workOrder) || void 0 === r || null === (n = r.targetRate) || void 0 === n ? void 0 : n.units) || "gal/acre"
          }), this.resetErrors();
        }
      }, {
        key: "resetErrors",
        value: function () {
          this.tankSize.resetErrors(), this.targetRate.resetErrors();
        }
      }, {
        key: "validate",
        value: function () {
          return [this.tankSize.validate(), this.targetRate.validate()].every(H.identity);
        }
      }]) && sr(t.prototype, r), n && sr(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(Z)).prototype, "disableModalAnimation", [J.computed], Object.getOwnPropertyDescriptor(ur.prototype, "disableModalAnimation"), ur.prototype), vr(ur.prototype, "loadSheetPath", [J.computed], Object.getOwnPropertyDescriptor(ur.prototype, "loadSheetPath"), ur.prototype), vr(ur.prototype, "loadSheetRequestPath", [J.computed], Object.getOwnPropertyDescriptor(ur.prototype, "loadSheetRequestPath"), ur.prototype), vr(ur.prototype, "modalHeaderId", [J.computed], Object.getOwnPropertyDescriptor(ur.prototype, "modalHeaderId"), ur.prototype), vr(ur.prototype, "t", [J.computed], Object.getOwnPropertyDescriptor(ur.prototype, "t"), ur.prototype), vr(ur.prototype, "tankSizeUnitChoices", [J.computed], Object.getOwnPropertyDescriptor(ur.prototype, "tankSizeUnitChoices"), ur.prototype), vr(ur.prototype, "targetSprayRateUnitChoices", [J.computed], Object.getOwnPropertyDescriptor(ur.prototype, "targetSprayRateUnitChoices"), ur.prototype), vr(ur.prototype, "workOrder", [J.computed], Object.getOwnPropertyDescriptor(ur.prototype, "workOrder"), ur.prototype), vr(ur.prototype, "onCancel", [J.action], Object.getOwnPropertyDescriptor(ur.prototype, "onCancel"), ur.prototype), vr(ur.prototype, "onRequestLoadSheet", [J.action], Object.getOwnPropertyDescriptor(ur.prototype, "onRequestLoadSheet"), ur.prototype), vr(ur.prototype, "reset", [J.action], Object.getOwnPropertyDescriptor(ur.prototype, "reset"), ur.prototype), vr(ur.prototype, "resetErrors", [J.action], Object.getOwnPropertyDescriptor(ur.prototype, "resetErrors"), ur.prototype), ur);

    function Or(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function wr(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Pr(e, t) {
      return (Pr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function jr(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = kr(e);

        if (t) {
          var o = kr(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return _r(this, r);
      };
    }

    function _r(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function kr(e) {
      return (kr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Er,
        Sr = Object(a.observer)(mr = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Pr(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = jr(a);

      function a() {
        return Or(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.model,
              r = e.t;
          return i.a.createElement(Q.ModalBody, null, i.a.createElement("div", {
            className: "row"
          }, i.a.createElement("div", {
            className: "col py-3 px-5"
          }, i.a.createElement("div", {
            className: "mb-5"
          }, i.a.createElement("label", {
            className: "form-label"
          }, r("if2.work_orders.work_orders.tank_size")), i.a.createElement("div", {
            className: "form-row my-2"
          }, i.a.createElement(Q.UnitSelector, {
            placeholder: r("if2.work_orders.work_orders.tank_size"),
            currentUnit: t.tankSize.units || "",
            currentValue: t.tankSize.scalar || "",
            unitChoices: t.tankSizeUnitChoices,
            valueColumnClassName: "col-md-5 unit-selector-value",
            unitColumnClassName: "col-md-7 unit-selector-unit",
            onUpdateUnit: t.tankSize.onUpdateUnit,
            onUpdateValue: t.tankSize.onUpdateScalar,
            valueError: t.tankSize.scalarError,
            unitsError: t.tankSize.unitsError
          }))), i.a.createElement("div", {
            className: "mb-5"
          }, i.a.createElement("label", {
            className: "form-label"
          }, r("if2.work_orders.work_orders.target_spray_rate")), i.a.createElement("div", {
            className: "form-row my-2"
          }, i.a.createElement(Q.UnitSelector, {
            placeholder: r("if2.work_orders.work_orders.target_spray_rate"),
            currentUnit: t.targetRate.units || "",
            currentValue: t.targetRate.scalar || "",
            unitChoices: t.targetSprayRateUnitChoices,
            valueColumnClassName: "col-md-5 unit-selector-value",
            unitColumnClassName: "col-md-7 unit-selector-unit",
            onUpdateUnit: t.targetRate.onUpdateUnit,
            onUpdateValue: t.targetRate.onUpdateScalar,
            valueError: t.targetRate.scalarError,
            unitsError: t.targetRate.unitsError
          }))), i.a.createElement("div", {
            className: "row modal-input-row mt-3"
          }, i.a.createElement("div", {
            className: "col-md-8 col-lg-6 ml-auto"
          }, i.a.createElement("div", {
            className: "row no-gutters"
          }, i.a.createElement("div", {
            className: "col-sm-6 px-1"
          }, i.a.createElement("button", {
            type: "button",
            className: "btn btn-secondary",
            onClick: t.onCancel
          }, r("if2.work_orders.cancel"))), i.a.createElement("div", {
            className: "col-sm-6 px-1"
          }, i.a.createElement("a", {
            role: "button",
            className: "btn btn-success",
            href: t.loadSheetRequestPath,
            onClick: t.onRequestLoadSheet
          }, r("if2.work_orders.calculate")))))))));
        }
      }]) && wr(t.prototype, r), n && wr(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || mr,
        Rr = V()(Sr);

    function xr(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Cr(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Tr(e, t) {
      return (Tr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Nr(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Mr(e);

        if (t) {
          var o = Mr(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Dr(this, r);
      };
    }

    function Dr(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Mr(e) {
      return (Mr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Ar,
        zr = Object(a.observer)(Er = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Tr(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Nr(a);

      function a() {
        return xr(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.model,
              r = e.children;
          return i.a.createElement(Q.ModalDialog, {
            id: t.modal.id,
            ariaLabelledBy: t.modalHeaderId,
            className: "load-sheet-requestor-modal",
            dismissOnClose: !1,
            disableAnimation: t.disableModalAnimation
          }, r);
        }
      }]) && Cr(t.prototype, r), n && Cr(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Er;

    function Br(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Lr(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Fr(e, t) {
      return (Fr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Ur(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = qr(e);

        if (t) {
          var o = qr(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Ir(this, r);
      };
    }

    function Ir(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function qr(e) {
      return (qr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Vr,
        Wr = Object(a.observer)(Ar = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Fr(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Ur(a);

      function a() {
        return Br(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.model;
          return i.a.createElement(Q.ModalHeader, {
            id: e.modalHeaderId,
            title: e.modal.title,
            onClose: e.onCancel
          });
        }
      }]) && Lr(t.prototype, r), n && Lr(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Ar;

    function Kr(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Jr(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Hr(e, t) {
      return (Hr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function $r(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Gr(e);

        if (t) {
          var o = Gr(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Qr(this, r);
      };
    }

    function Qr(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Gr(e) {
      return (Gr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Yr,
        Xr = Object(a.observer)(Vr = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Hr(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = $r(a);

      function a() {
        return Kr(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.model;
          return i.a.createElement(zr, {
            model: e
          }, i.a.createElement(Wr, {
            model: e
          }), i.a.createElement(Rr, {
            model: e
          }));
        }
      }]) && Jr(t.prototype, r), n && Jr(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Vr;

    function Zr(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function en(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function tn(e, t) {
      return (tn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function rn(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = on(e);

        if (t) {
          var o = on(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return nn(this, r);
      };
    }

    function nn(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function on(e) {
      return (on = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var an,
        cn = Object(a.observer)(Yr = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && tn(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = rn(a);

      function a() {
        return Zr(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.model,
              r = e.t;
          return i.a.createElement("div", {
            className: "load-sheet-requestor"
          }, i.a.createElement("button", {
            type: "button",
            className: "btn btn-secondary",
            onClick: t.onShowModal
          }, r("if2.work_orders.work_orders.tank_load_sheet")), i.a.createElement(Xr, {
            model: t
          }));
        }
      }]) && en(t.prototype, r), n && en(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Yr,
        un = V()(cn);

    function ln(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function sn(e, t) {
      return (sn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function fn(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = dn(e);

        if (t) {
          var o = dn(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return pn(this, r);
      };
    }

    function pn(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function dn(e) {
      return (dn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var yn = Object(a.observer)(an = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && sn(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = fn(a);

      function a(e) {
        var t;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, a);
        var r = (t = o.call(this, e)).props,
            n = r.loadSheetPathPattern,
            i = r.t;
        return t.model = new gr({
          loadSheetPathPattern: n,
          workOrder: window.workOrder,
          t: i
        }), t;
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          return i.a.createElement(un, {
            model: this.model
          });
        }
      }]) && ln(t.prototype, r), n && ln(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || an,
        bn = V()(yn),
        hn = r(11);

    function vn(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function mn(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function gn(e, t) {
      return (gn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function On(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Pn(e);

        if (t) {
          var o = Pn(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return wn(this, r);
      };
    }

    function wn(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Pn(e) {
      return (Pn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var jn,
        _n = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && gn(e, t);
      }(i, e);
      var t,
          r,
          n,
          o = On(i);

      function i() {
        return mn(this, i), o.apply(this, arguments);
      }

      return t = i, r && vn(t.prototype, r), n && vn(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), t;
    }(Object(G.MixInto)(G.UpdatableBase, G.idAttributeMixin, G.serialAttributeMixin, G.nameAttributeMixin));

    function kn(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function En(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? kn(Object(r), !0).forEach(function (t) {
          Sn(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : kn(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Sn(e, t, r) {
      return (t = Cn(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Rn(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function xn(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Cn(n.key), n);
      }
    }

    function Cn(e) {
      var t = function (e, t) {
        if ("object" != typeof e || null === e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : String(t);
    }

    function Tn() {
      return (Tn = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = Nn(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(this, arguments);
    }

    function Nn(e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = zn(e)););

      return e;
    }

    function Dn(e, t) {
      return (Dn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Mn(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = zn(e);

        if (t) {
          var o = zn(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return An(this, r);
      };
    }

    function An(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function zn(e) {
      return (zn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Bn,
        Ln,
        Fn,
        Un,
        In,
        qn,
        Vn = (Bn = (jn = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Dn(e, t);
      }(i, e);
      var t,
          r,
          n,
          o = Mn(i);

      function i() {
        return Rn(this, i), o.apply(this, arguments);
      }

      return t = i, n = [{
        key: "getAttributeDefinition",
        value: function () {
          return En(En({}, Tn(zn(i), "getAttributeDefinition", this).call(this)), {}, {
            clientPath: {
              key: "clientPath",
              type: "array"
            }
          });
        }
      }], (r = [{
        key: "clientPathString",
        get: function () {
          var e = this;
          return (this.clientPath || []).filter(function (t) {
            return t.id !== e.id;
          }).map(function (e) {
            return e.name;
          }).concat(this.name || []).join(": ");
        }
      }]) && xn(t.prototype, r), n && xn(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(_n)).prototype, Ln = "clientPathString", Fn = [J.computed], Un = Object.getOwnPropertyDescriptor(jn.prototype, "clientPathString"), In = jn.prototype, qn = {}, Object.keys(Un).forEach(function (e) {
      qn[e] = Un[e];
    }), qn.enumerable = !!qn.enumerable, qn.configurable = !!qn.configurable, ("value" in qn || qn.initializer) && (qn.writable = !0), qn = Fn.slice().reverse().reduce(function (e, t) {
      return t(Bn, Ln, e) || e;
    }, qn), In && void 0 !== qn.initializer && (qn.value = qn.initializer ? qn.initializer.call(In) : void 0, qn.initializer = void 0), void 0 === qn.initializer && (Object.defineProperty(Bn, Ln, qn), qn = null), jn);

    function Wn(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Kn(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Wn(Object(r), !0).forEach(function (t) {
          Jn(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Wn(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Jn(e, t, r) {
      return (t = Qn(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Hn(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function $n(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Qn(n.key), n);
      }
    }

    function Qn(e) {
      var t = function (e, t) {
        if ("object" != typeof e || null === e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : String(t);
    }

    function Gn() {
      return (Gn = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = Yn(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(this, arguments);
    }

    function Yn(e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = to(e)););

      return e;
    }

    function Xn(e, t) {
      return (Xn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Zn(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = to(e);

        if (t) {
          var o = to(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return eo(this, r);
      };
    }

    function eo(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function to(e) {
      return (to = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var ro = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Xn(e, t);
      }(i, e);
      var t,
          r,
          n,
          o = Zn(i);

      function i() {
        return Hn(this, i), o.apply(this, arguments);
      }

      return t = i, n = [{
        key: "getAttributeDefinition",
        value: function () {
          return Kn(Kn({}, Gn(to(i), "getAttributeDefinition", this).call(this)), {}, {
            account: {
              key: "account",
              type: "model",
              modelClass: Vn
            },
            area: {
              name: "Area",
              key: "area",
              type: "model",
              modelClass: G.Quantity,
              defaultValue: new G.Quantity("")
            }
          });
        }
      }], (r = null) && $n(t.prototype, r), n && $n(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(_n);

    function no(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function oo(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? no(Object(r), !0).forEach(function (t) {
          io(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : no(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function io(e, t, r) {
      return (t = uo(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function ao(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function co(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, uo(n.key), n);
      }
    }

    function uo(e) {
      var t = function (e, t) {
        if ("object" != typeof e || null === e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : String(t);
    }

    function lo() {
      return (lo = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = so(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(this, arguments);
    }

    function so(e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = bo(e)););

      return e;
    }

    function fo(e, t) {
      return (fo = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function po(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = bo(e);

        if (t) {
          var o = bo(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return yo(this, r);
      };
    }

    function yo(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function bo(e) {
      return (bo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var ho = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && fo(e, t);
      }(i, e);
      var t,
          r,
          n,
          o = po(i);

      function i() {
        return ao(this, i), o.apply(this, arguments);
      }

      return t = i, n = [{
        key: "getAttributeDefinition",
        value: function () {
          var e = lo(bo(i), "getAttributeDefinition", this).call(this);
          return oo(oo({}, e), {}, {
            type: oo(oo({}, e.type), {}, {
              defaultValue: this.type
            }),
            workOrderId: {
              name: "Work Order ID",
              key: "workOrderId",
              type: "number"
            },
            phi: {
              name: "PHI",
              key: "phi",
              type: "model",
              modelClass: G.Quantity
            },
            rei: {
              name: "REI",
              key: "rei",
              type: "model",
              modelClass: G.Quantity
            },
            phiOverride: {
              name: "PHI Override",
              key: "phiOverride",
              type: "model",
              modelClass: G.Quantity
            },
            phiOverrideBy: {
              name: "PHI Overridden By",
              key: "phiOverrideBy",
              type: "string"
            },
            phiOverrideReason: {
              name: "PHI Override Reason",
              key: "phiOverrideReason",
              type: "string"
            },
            reiOverride: {
              name: "REI Override",
              key: "reiOverride",
              type: "model",
              modelClass: G.Quantity
            },
            reiOverrideBy: {
              name: "REI Overridden By",
              key: "reiOverrideBy",
              type: "string"
            },
            reiOverrideReason: {
              name: "REI Override Reason",
              key: "reiOverrideReason",
              type: "string"
            }
          });
        }
      }], (r = null) && co(t.prototype, r), n && co(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(G.ProductApplicationBase);

    function vo(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function mo(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function go(e, t) {
      return (go = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Oo(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Po(e);

        if (t) {
          var o = Po(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return wo(this, r);
      };
    }

    function wo(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Po(e) {
      return (Po = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    ho.type = "IF2::WorkOrders::ProductApplication";

    var jo = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && go(e, t);
      }(i, e);
      var t,
          r,
          n,
          o = Oo(i);

      function i() {
        return mo(this, i), o.apply(this, arguments);
      }

      return t = i, r && vo(t.prototype, r), n && vo(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), t;
    }(Object(G.MixInto)(G.UpdatableBase, G.idAttributeMixin, G.nameAttributeMixin));

    function _o(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function ko(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Eo(e, t) {
      return (Eo = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function So(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = xo(e);

        if (t) {
          var o = xo(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Ro(this, r);
      };
    }

    function Ro(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function xo(e) {
      return (xo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Co = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Eo(e, t);
      }(i, e);
      var t,
          r,
          n,
          o = So(i);

      function i() {
        return ko(this, i), o.apply(this, arguments);
      }

      return t = i, r && _o(t.prototype, r), n && _o(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), t;
    }(_n);

    function To(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function No(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? To(Object(r), !0).forEach(function (t) {
          Do(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : To(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Do(e, t, r) {
      return (t = zo(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Mo(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Ao(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, zo(n.key), n);
      }
    }

    function zo(e) {
      var t = function (e, t) {
        if ("object" != typeof e || null === e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : String(t);
    }

    function Bo() {
      return (Bo = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = Lo(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(this, arguments);
    }

    function Lo(e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = qo(e)););

      return e;
    }

    function Fo(e, t) {
      return (Fo = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Uo(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = qo(e);

        if (t) {
          var o = qo(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Io(this, r);
      };
    }

    function Io(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function qo(e) {
      return (qo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Vo,
        Wo,
        Ko = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Fo(e, t);
      }(i, e);
      var t,
          r,
          n,
          o = Uo(i);

      function i() {
        return Mo(this, i), o.apply(this, arguments);
      }

      return t = i, n = [{
        key: "getAttributeDefinition",
        value: function () {
          return No(No({}, Bo(qo(i), "getAttributeDefinition", this).call(this)), {}, {
            date: {
              key: "date",
              type: "string"
            },
            documentNumber: {
              key: "documentNumber",
              type: "string"
            },
            writtenBy: {
              key: "writtenBy",
              type: "model",
              modelClass: Co
            }
          });
        }
      }], (r = null) && Ao(t.prototype, r), n && Ao(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(jo);

    function Jo(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Ho(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Jo(Object(r), !0).forEach(function (t) {
          $o(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Jo(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function $o(e, t, r) {
      return (t = Yo(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Qo(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Go(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Yo(n.key), n);
      }
    }

    function Yo(e) {
      var t = function (e, t) {
        if ("object" != typeof e || null === e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : String(t);
    }

    function Xo() {
      return (Xo = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = Zo(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(this, arguments);
    }

    function Zo(e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = ni(e)););

      return e;
    }

    function ei(e, t) {
      return (ei = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function ti(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = ni(e);

        if (t) {
          var o = ni(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return ri(this, r);
      };
    }

    function ri(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function ni(e) {
      return (ni = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function oi(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var ii = ((Wo = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ei(e, t);
      }(i, e);
      var t,
          r,
          n,
          o = ti(i);

      function i() {
        return Qo(this, i), o.apply(this, arguments);
      }

      return t = i, n = [{
        key: "getAttributeDefinition",
        value: function () {
          var e = Xo(ni(i), "getAttributeDefinition", this).call(this);
          return Ho(Ho({}, e), {}, {
            type: Ho(Ho({}, e.type), {}, {
              defaultValue: this.type
            }),
            startDate: {
              key: "startDate",
              type: "string"
            },
            status: {
              key: "status",
              type: "string"
            },
            notes: {
              key: "notes",
              type: "string"
            },
            targetRate: {
              key: "targetRate",
              type: "model",
              modelClass: G.Quantity
            },
            targetCoverage: {
              key: "targetCoverage",
              type: "number"
            },
            organic: {
              key: "organic",
              type: "boolean"
            },
            cropNames: {
              name: "Crop Names",
              key: "cropNames",
              type: "array"
            },
            fields: {
              key: "fields",
              type: "modelCollection",
              modelClass: ro
            },
            productApplications: {
              key: "productApplications",
              type: "modelCollection",
              modelClass: ho
            },
            recommendation: {
              key: "recommendation",
              type: "model",
              modelClass: Ko
            },
            account: {
              key: "account",
              type: "model",
              modelClass: Vn
            },
            maxPhi: {
              key: "maxPhi",
              type: "model",
              modelClass: G.Quantity
            },
            maxRei: {
              key: "maxRei",
              type: "model",
              modelClass: G.Quantity
            },
            orderedBy: {
              key: "orderedBy",
              type: "model",
              modelClass: Co
            }
          });
        }
      }], (r = [{
        key: "findProductApplication",
        value: function (e) {
          return this.productApplications.find(function (t) {
            return t.id === e;
          });
        }
      }, {
        key: "moveProductApplication",
        value: function (e, t, r) {
          var n = this.findProductApplication(e);

          if (n) {
            var o = this.productApplications.findIndex(function (e) {
              return e.position === t;
            }),
                i = this.productApplications.findIndex(function (e) {
              return e.position === r;
            });
            this.productApplications.splice(o, 1), this.productApplications.splice(i, 0, n), this.updateProductApplicationPositions();
          }
        }
      }, {
        key: "removeProductApplication",
        value: function (e) {
          var t = this.productApplications.findIndex(function (t) {
            return t.id === e;
          });
          t < 0 || (this.productApplications.splice(t, 1), this.updateProductApplicationPositions());
        }
      }, {
        key: "updateProductApplicationPositions",
        value: function () {
          this.productApplications.forEach(function (e, t) {
            e.position !== t && e.update({
              position: t
            });
          });
        }
      }, {
        key: "updateProductApplication",
        value: function (e) {
          return Object(G.push)(this.productApplications, ho.from.bind(ho), e), this.updateProductApplicationPositions(), this.productApplications;
        }
      }]) && Go(t.prototype, r), n && Go(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(Object(G.MixInto)(G.UpdatableBase, G.idAttributeMixin, G.serialAttributeMixin, G.nameAttributeMixin, G.timestampAttributesMixin, G.typeAttributeMixin, G.applicationMethodAttributeMixin))).type = "IF2::WorkOrders::WorkOrder", oi((Vo = Wo).prototype, "moveProductApplication", [J.action], Object.getOwnPropertyDescriptor(Vo.prototype, "moveProductApplication"), Vo.prototype), oi(Vo.prototype, "removeProductApplication", [J.action], Object.getOwnPropertyDescriptor(Vo.prototype, "removeProductApplication"), Vo.prototype), oi(Vo.prototype, "updateProductApplicationPositions", [J.action], Object.getOwnPropertyDescriptor(Vo.prototype, "updateProductApplicationPositions"), Vo.prototype), oi(Vo.prototype, "updateProductApplication", [J.action], Object.getOwnPropertyDescriptor(Vo.prototype, "updateProductApplication"), Vo.prototype), Vo),
        ai = r(23);
    var ci,
        ui,
        li,
        si = (ci = new ai.SchemaValidator(), (ui = r(35)).keys().forEach(function (e) {
      ci.addSchema(ui(e));
    }), ci);

    function fi(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function pi(e, t) {
      return (pi = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function di(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = bi(e);

        if (t) {
          var o = bi(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return yi(this, r);
      };
    }

    function yi(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function bi(e) {
      return (bi = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var hi,
        vi = Object(a.observer)(li = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && pi(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = di(a);

      function a(e) {
        var t;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, a), t = o.call(this, e);
        var r = e.workOrder;

        try {
          t.workOrder = new ii(function (e) {
            return si.sanitizeData("https://schemas.miriamtech.com/if2/work_orders/work_order", e);
          }(r));
        } catch (e) {
          if (!(e instanceof hn.ValidatorResultError)) throw e;
          var n = e.errors.map(function (e) {
            return e.stack;
          });
          throw new Error("Invalid work order supplied: ".concat(n.join(", ")));
        }

        return window.workOrder = t.workOrder, t;
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          return i.a.createElement(i.a.Fragment, null);
        }
      }]) && fi(t.prototype, r), n && fi(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || li,
        mi = r(13),
        gi = r(14),
        Oi = r.n(gi),
        wi = r(8);

    function Pi(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function ji(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Pi(Object(r), !0).forEach(function (t) {
          _i(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Pi(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function _i(e, t, r) {
      return (t = Si(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function ki(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Ei(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Si(n.key), n);
      }
    }

    function Si(e) {
      var t = function (e, t) {
        if ("object" != typeof e || null === e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : String(t);
    }

    function Ri() {
      return (Ri = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = xi(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(this, arguments);
    }

    function xi(e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Di(e)););

      return e;
    }

    function Ci(e, t) {
      return (Ci = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Ti(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Di(e);

        if (t) {
          var o = Di(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Ni(this, r);
      };
    }

    function Ni(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Di(e) {
      return (Di = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Mi(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var Ai,
        zi,
        Bi = (Mi((hi = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Ci(e, t);
      }(i, e);
      var t,
          r,
          n,
          o = Ti(i);

      function i() {
        return ki(this, i), o.apply(this, arguments);
      }

      return t = i, n = [{
        key: "getAttributeDefinition",
        value: function () {
          return ji(ji({}, Ri(Di(i), "getAttributeDefinition", this).call(this)), {}, {
            account: {
              key: "account",
              type: "model",
              modelClass: Vn
            }
          });
        }
      }], (r = [{
        key: "clientPathFieldName",
        get: function () {
          return this.name;
        }
      }, {
        key: "cropName",
        get: function () {
          var e;
          return (null === (e = this.crop) || void 0 === e ? void 0 : e.name) || "";
        }
      }, {
        key: "varietyNames",
        get: function () {
          var e;
          return (null === (e = this.varieties) || void 0 === e ? void 0 : e.map(function (e) {
            return e.name;
          })) || [];
        }
      }]) && Ei(t.prototype, r), n && Ei(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(wi.Field)).prototype, "clientPathFieldName", [J.computed], Object.getOwnPropertyDescriptor(hi.prototype, "clientPathFieldName"), hi.prototype), Mi(hi.prototype, "cropName", [J.computed], Object.getOwnPropertyDescriptor(hi.prototype, "cropName"), hi.prototype), Mi(hi.prototype, "varietyNames", [J.computed], Object.getOwnPropertyDescriptor(hi.prototype, "varietyNames"), hi.prototype), hi);

    function Li(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Fi(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var Ui,
        Ii = ((zi = function () {
      function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.props = t || {}, this.initialize();
      }

      var t, r, n;
      return t = e, (r = [{
        key: "fields",
        get: function () {
          var e = this.props.fields;
          return Oi()((e || []).map(this.constructor.makeField), ["name"], ["asc"]);
        }
      }, {
        key: "showEditControls",
        get: function () {
          return this.props.showEditControls;
        }
      }, {
        key: "workOrder",
        get: function () {
          return this.props.workOrder;
        }
      }, {
        key: "workOrderFieldPathPattern",
        get: function () {
          var e = this.props.workOrderFieldPathPattern;
          return e && new Ct.a(e, this.constructor.urlPatternOptions);
        }
      }, {
        key: "workOrderFieldsPathPattern",
        get: function () {
          var e = this.props.workOrderFieldsPathPattern;
          return e && new Ct.a(e, this.constructor.urlPatternOptions);
        }
      }, {
        key: "workOrderFieldsPath",
        get: function () {
          var e,
              t = Rt({
            work_order_id: this.workOrder.serial
          }, this.i18n);
          return (null === (e = this.workOrderFieldsPathPattern) || void 0 === e ? void 0 : e.stringify(t)) || "";
        }
      }, {
        key: "initBindings",
        value: function () {}
      }, {
        key: "initialize",
        value: function (e) {
          this.update(e), this.initBindings(), this.i18n = this.props.i18n;
        }
      }, {
        key: "update",
        value: function (e) {
          var t = this;
          Object.keys(e || {}).forEach(function (r) {
            t.props[r] = e[r];
          });
        }
      }, {
        key: "workOrderFieldPath",
        value: function (e) {
          var t,
              r = Rt({
            id: e,
            work_order_id: this.workOrder.serial
          }, this.i18n);
          return (null === (t = this.workOrderFieldPathPattern) || void 0 === t ? void 0 : t.stringify(r)) || "";
        }
      }]) && Li(t.prototype, r), n && Li(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), e;
    }()).makeField = Object(mi.createTransformer)(function (e) {
      var t;

      try {
        t = new Bi(Object(wi.sanitizeField)(e));
      } catch (e) {
        if (!(e instanceof hn.ValidatorResultError)) throw e;
        var r = e.errors.map(function (e) {
          return e.stack;
        });
        throw new Error("Invalid field supplied: ".concat(r.join(", ")));
      }

      return t;
    }), zi.urlPatternOptions = {
      segmentNameCharset: "a-zA-Z0-9_"
    }, Fi((Ai = zi).prototype, "fields", [J.computed], Object.getOwnPropertyDescriptor(Ai.prototype, "fields"), Ai.prototype), Fi(Ai.prototype, "showEditControls", [J.computed], Object.getOwnPropertyDescriptor(Ai.prototype, "showEditControls"), Ai.prototype), Fi(Ai.prototype, "workOrder", [J.computed], Object.getOwnPropertyDescriptor(Ai.prototype, "workOrder"), Ai.prototype), Fi(Ai.prototype, "workOrderFieldPathPattern", [J.computed], Object.getOwnPropertyDescriptor(Ai.prototype, "workOrderFieldPathPattern"), Ai.prototype), Fi(Ai.prototype, "workOrderFieldsPathPattern", [J.computed], Object.getOwnPropertyDescriptor(Ai.prototype, "workOrderFieldsPathPattern"), Ai.prototype), Fi(Ai.prototype, "workOrderFieldsPath", [J.computed], Object.getOwnPropertyDescriptor(Ai.prototype, "workOrderFieldsPath"), Ai.prototype), Fi(Ai.prototype, "initialize", [J.action], Object.getOwnPropertyDescriptor(Ai.prototype, "initialize"), Ai.prototype), Fi(Ai.prototype, "update", [J.action], Object.getOwnPropertyDescriptor(Ai.prototype, "update"), Ai.prototype), Ai);

    function qi(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Vi(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Wi(e, t) {
      return (Wi = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Ki(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Hi(e);

        if (t) {
          var o = Hi(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Ji(this, r);
      };
    }

    function Ji(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Hi(e) {
      return (Hi = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var $i,
        Qi = Object(a.observer)(Ui = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Wi(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Ki(a);

      function a() {
        return qi(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.t;
          return i.a.createElement("thead", {
            className: "thead-light"
          }, i.a.createElement("tr", null, i.a.createElement("th", {
            scope: "col",
            colSpan: "2"
          }, e("if2.work_orders.field")), i.a.createElement("th", {
            scope: "col"
          }, e("if2.work_orders.crop")), i.a.createElement("th", {
            scope: "col",
            "aria-label": "Organic Indicator"
          }), i.a.createElement("th", {
            scope: "col"
          }, e("if2.work_orders.variety")), i.a.createElement("th", {
            scope: "col"
          }, e("if2.work_orders.acres")), i.a.createElement("th", {
            scope: "col",
            "aria-label": "Actions"
          })));
        }
      }]) && Vi(t.prototype, r), n && Vi(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Ui,
        Gi = V()(Qi);

    function Yi(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Xi(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Zi(e, t) {
      return (Zi = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function ea(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = ra(e);

        if (t) {
          var o = ra(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return ta(this, r);
      };
    }

    function ta(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function ra(e) {
      return (ra = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var na,
        oa = Object(a.observer)($i = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Zi(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = ea(a);

      function a() {
        return Yi(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "countyName",
        value: function (e) {
          return e ? e.match(/county/i) ? e : "".concat(e, " County") : null;
        }
      }, {
        key: "render",
        value: function () {
          var e,
              t = this.props,
              r = t.field,
              n = t.model,
              o = t.t;
          return i.a.createElement("tr", {
            key: r.id
          }, i.a.createElement("td", null, r.clientPathFieldName, i.a.createElement("div", {
            className: "d-flex flex-row"
          }, i.a.createElement("div", {
            className: "gps px-1"
          }, r.gps), i.a.createElement("div", {
            className: "county px-1"
          }, r.countyName))), i.a.createElement("td", null), i.a.createElement("td", null, r.cropName), i.a.createElement("td", null, r.organic ? i.a.createElement("div", {
            className: "organic"
          }) : null), i.a.createElement("td", null, r.varietyNames.join(", ")), i.a.createElement("td", null, (null === (e = r.area) || void 0 === e ? void 0 : e.displayValue) || ""), n.showEditControls ? i.a.createElement("td", {
            className: "actions"
          }, i.a.createElement("a", {
            href: n.workOrderFieldPath(r.serial),
            className: "text-danger",
            "data-method": "delete",
            "data-confirm": o("if2.work_orders.work_orders.confirm_remove_field"),
            rel: "nofollow"
          }, i.a.createElement("i", {
            className: "fas fa-trash-alt"
          }))) : null);
        }
      }]) && Xi(t.prototype, r), n && Xi(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || $i,
        ia = V()(oa);

    function aa(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function ca(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function ua(e, t) {
      return (ua = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function la(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = fa(e);

        if (t) {
          var o = fa(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return sa(this, r);
      };
    }

    function sa(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function fa(e) {
      return (fa = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var pa,
        da = Object(a.observer)(na = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ua(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = la(a);

      function a() {
        return aa(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.model;
          return i.a.createElement("tbody", null, e.fields.map(function (t) {
            return i.a.createElement(ia, {
              key: t.id,
              field: t,
              model: e
            });
          }));
        }
      }]) && ca(t.prototype, r), n && ca(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || na;

    function ya(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function ba(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function ha(e, t) {
      return (ha = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function va(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = ga(e);

        if (t) {
          var o = ga(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return ma(this, r);
      };
    }

    function ma(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function ga(e) {
      return (ga = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Oa,
        wa = Object(a.observer)(pa = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ha(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = va(a);

      function a() {
        return ya(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e,
              t = this.props,
              r = t.model,
              n = t.t;
          return null !== (e = r.fields) && void 0 !== e && e.length ? i.a.createElement("table", {
            className: "table table-striped table-sm"
          }, i.a.createElement(Gi, null), i.a.createElement(da, {
            model: r
          })) : i.a.createElement(i.a.Fragment, null, i.a.createElement("p", {
            className: "unspecified"
          }, n("if2.work_orders.work_orders.fields_editor.no_fields_have_been_added")), r.showEditControls ? i.a.createElement("p", null, i.a.createElement("a", {
            href: r.workOrderFieldsPath,
            className: "icon icon-add"
          }, n("if2.work_orders.work_orders.fields_editor.add_fields"))) : "");
        }
      }]) && ba(t.prototype, r), n && ba(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || pa,
        Pa = V()(wa);

    function ja(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function _a(e, t) {
      return (_a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function ka(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Sa(e);

        if (t) {
          var o = Sa(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Ea(this, r);
      };
    }

    function Ea(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Sa(e) {
      return (Sa = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Ra,
        xa,
        Ca,
        Ta,
        Na = Object(a.observer)(Oa = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && _a(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = ka(a);

      function a(e) {
        var t;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, a);
        var r = (t = o.call(this, e)).props,
            n = r.showEditControls,
            i = r.fields,
            c = r.workOrderFieldPathPattern,
            u = r.workOrderFieldsPathPattern,
            l = r.t;
        return t.model = new Ii({
          workOrder: window.workOrder,
          workOrderFieldPathPattern: c,
          workOrderFieldsPathPattern: u,
          fields: i,
          showEditControls: n
        }), t.cardModel = new Q.CardModel({
          title: l("if2.work_orders.fields")
        }), t.onOpen = t.cardModel.open.bind(t.cardModel), t.onClose = t.cardModel.close.bind(t.cardModel), t;
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.t;
          return i.a.createElement("div", {
            className: "work-orders-fields"
          }, i.a.createElement(Q.Card, null, i.a.createElement(Q.CardHeader, {
            isOpen: this.cardModel.isOpen,
            title: this.cardModel.title,
            onOpen: this.onOpen,
            onClose: this.onClose,
            hasToggle: this.cardModel.hasToggle
          }, this.model.showEditControls ? i.a.createElement("span", {
            className: "fields-actions pl-2"
          }, i.a.createElement("a", {
            href: this.model.workOrderFieldsPath,
            className: "icon",
            title: e("if2.work_orders.work_orders.change_fields")
          }, i.a.createElement("i", {
            className: "fas fa-edit"
          }))) : null), i.a.createElement(Q.CardBody, {
            isOpen: this.cardModel.isOpen
          }, i.a.createElement(Pa, {
            model: this.model
          }))));
        }
      }]) && ja(t.prototype, r), n && ja(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Oa,
        Da = V()(Na);

    function Ma(e) {
      var t = e.i18n,
          r = e.defaultNS,
          n = e.children,
          i = Object(o.useMemo)(function () {
        return {
          i18n: t,
          defaultNS: r
        };
      }, [t, r]);
      return Object(o.createElement)(_.Provider, {
        value: i
      }, n);
    }

    function Aa(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function za(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Ba(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function La(e, t) {
      return (La = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Fa(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = qa(e);

        if (t) {
          var o = qa(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Ua(this, r);
      };
    }

    function Ua(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return Ia(e);
    }

    function Ia(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function qa(e) {
      return (qa = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Va(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var Wa,
        Ka,
        Ja = ((Ta = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && La(e, t);
      }(i, e);
      var t,
          r,
          n,
          o = Fa(i);

      function i() {
        var e;
        za(this, i);

        for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];

        return Aa(e = o.call.apply(o, [this].concat(r)), "isSubmitPending", xa, Ia(e)), Aa(e, "onSubmit", Ca, Ia(e)), e;
      }

      return t = i, (r = [{
        key: "workOrder",
        get: function () {
          return this.props.workOrder;
        }
      }, {
        key: "workOrderPath",
        get: function () {
          var e,
              t = this.props.i18n,
              r = Rt({
            id: this.workOrder.serial
          }, t);
          return (null === (e = this.workOrderPathPattern) || void 0 === e ? void 0 : e.stringify(r)) || "";
        }
      }, {
        key: "workOrderFieldsPath",
        get: function () {
          var e,
              t = this.props.i18n,
              r = Rt({
            work_order_id: this.workOrder.serial
          }, t);
          return (null === (e = this.workOrderFieldsPathPattern) || void 0 === e ? void 0 : e.stringify(r)) || "";
        }
      }, {
        key: "workOrderFieldsPathPattern",
        get: function () {
          var e = this.props.workOrderFieldsPathPattern;
          return e && new Ct.a(e, this.constructor.urlPatternOptions);
        }
      }, {
        key: "workOrderPathPattern",
        get: function () {
          var e = this.props.workOrderPathPattern;
          return e && new Ct.a(e, this.constructor.urlPatternOptions);
        }
      }, {
        key: "authenticityToken",
        get: function () {
          return this.props.authenticityToken;
        }
      }, {
        key: "formFieldName",
        get: function () {
          return this.props.formFieldName;
        }
      }, {
        key: "confirmCrops",
        value: function () {
          var e = this.unlistedCrops.length > 1 ? this.t("confirm_continue_will_add_crop_plural") : this.t("confirm_continue_will_add_crop_singular");
          return window.confirm("".concat(Object(G.listString)(this.unlistedCrops), " ").concat(e));
        }
      }, {
        key: "confirmOrganicStatus",
        value: function () {
          return window.confirm(this.t("confirm_continue_conventional_added_to_organic"));
        }
      }]) && Ba(t.prototype, r), n && Ba(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(wi.FieldSelectModel)).urlPatternOptions = {
      segmentNameCharset: "a-zA-Z0-9_"
    }, xa = Va((Ra = Ta).prototype, "isSubmitPending", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Va(Ra.prototype, "workOrder", [J.computed], Object.getOwnPropertyDescriptor(Ra.prototype, "workOrder"), Ra.prototype), Va(Ra.prototype, "workOrderPath", [J.computed], Object.getOwnPropertyDescriptor(Ra.prototype, "workOrderPath"), Ra.prototype), Va(Ra.prototype, "workOrderFieldsPath", [J.computed], Object.getOwnPropertyDescriptor(Ra.prototype, "workOrderFieldsPath"), Ra.prototype), Va(Ra.prototype, "workOrderFieldsPathPattern", [J.computed], Object.getOwnPropertyDescriptor(Ra.prototype, "workOrderFieldsPathPattern"), Ra.prototype), Va(Ra.prototype, "workOrderPathPattern", [J.computed], Object.getOwnPropertyDescriptor(Ra.prototype, "workOrderPathPattern"), Ra.prototype), Va(Ra.prototype, "authenticityToken", [J.computed], Object.getOwnPropertyDescriptor(Ra.prototype, "authenticityToken"), Ra.prototype), Va(Ra.prototype, "formFieldName", [J.computed], Object.getOwnPropertyDescriptor(Ra.prototype, "formFieldName"), Ra.prototype), Ca = Va(Ra.prototype, "onSubmit", [J.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.isSubmitPending = !0;
          var r = !0,
              n = !0;
          e.shouldConfirmOrganicStatus() && (r = e.confirmOrganicStatus()), e.shouldConfirmCrops() && (n = e.confirmCrops()), r && n || (e.isSubmitPending = !1, t.preventDefault());
        };
      }
    }), Ra);

    function Ha(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function $a(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Qa(e, t) {
      return (Qa = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Ga(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Xa(e);

        if (t) {
          var o = Xa(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Ya(this, r);
      };
    }

    function Ya(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Xa(e) {
      return (Xa = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Za,
        ec = Object(a.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null);
    }((Ka = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Qa(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Ga(a);

      function a() {
        return Ha(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "clientPath",
        get: function () {
          var e,
              t,
              r = this.props.rowModel;
          return (null == r || null === (e = r.field) || void 0 === e || null === (t = e.account) || void 0 === t ? void 0 : t.clientPath) || [];
        }
      }, {
        key: "render",
        value: function () {
          var e,
              t,
              r,
              n,
              o = this.props.rowModel;
          return i.a.createElement("td", {
            className: "name-col"
          }, i.a.createElement("ul", {
            className: "client-path"
          }, this.clientPath.map(function (e) {
            return i.a.createElement("li", {
              key: e.id,
              className: "client-path-segment"
            }, e.name);
          }), i.a.createElement("li", {
            key: null == o || null === (e = o.field) || void 0 === e || null === (t = e.account) || void 0 === t ? void 0 : t.id,
            className: "client-path-segment"
          }, null == o || null === (r = o.field) || void 0 === r || null === (n = r.account) || void 0 === n ? void 0 : n.name)), i.a.createElement("div", {
            className: "field-name"
          }, null == o ? void 0 : o.field.name));
        }
      }]) && $a(t.prototype, r), n && $a(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)).prototype, "clientPath", [J.computed], Object.getOwnPropertyDescriptor(Ka.prototype, "clientPath"), Ka.prototype), Wa = Ka)) || Wa,
        tc = V()(ec);

    function rc(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function nc(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function oc(e, t) {
      return (oc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function ic(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = cc(e);

        if (t) {
          var o = cc(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return ac(this, r);
      };
    }

    function ac(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function cc(e) {
      return (cc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var uc,
        lc = Object(a.observer)(Za = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && oc(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = ic(a);

      function a() {
        return rc(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.fieldSelectModel,
              r = e.t;
          return i.a.createElement("form", {
            className: "form-buttons",
            action: t.workOrderFieldsPath,
            acceptCharset: "UTF-8",
            method: "post",
            onSubmit: t.onSubmit
          }, i.a.createElement("input", {
            type: "hidden",
            name: "_method",
            value: "patch"
          }), i.a.createElement("input", {
            type: "hidden",
            name: "authenticity_token",
            value: t.authenticityToken
          }), 0 === t.checkedFields.length ? i.a.createElement("input", {
            type: "hidden",
            name: t.formFieldName,
            value: ""
          }) : null, t.checkedFields.map(function (e) {
            return i.a.createElement("input", {
              key: e.id,
              type: "hidden",
              name: t.formFieldName,
              value: e.id
            });
          }), i.a.createElement("a", {
            type: "button",
            className: "btn btn-secondary form-button mx-2",
            href: t.workOrderPath
          }, r("if2.work_orders.cancel")), i.a.createElement("input", {
            type: "submit",
            name: "commit",
            value: r("if2.work_orders.save"),
            disabled: t.isSubmitPending,
            className: "btn btn-success form-button mx-2"
          }));
        }
      }]) && nc(t.prototype, r), n && nc(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Za,
        sc = V()(lc);

    function fc(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function pc(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function dc(e, t) {
      return (dc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function yc(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = hc(e);

        if (t) {
          var o = hc(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return bc(this, r);
      };
    }

    function bc(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function hc(e) {
      return (hc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var vc,
        mc,
        gc = Object(a.observer)(uc = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && dc(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = yc(a);

      function a() {
        return fc(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.fieldSelectModel,
              r = e.t;
          return i.a.createElement("div", {
            className: "work-order-fields-editor"
          }, i.a.createElement("label", {
            className: "search-label mb-0"
          }, "Search Fieldbase"), i.a.createElement(wi.FieldSelectControls, {
            fieldSelectModel: t
          }), i.a.createElement(wi.FieldSelectionSummary, {
            model: t
          }), i.a.createElement(Q.Card, null, i.a.createElement(Q.CardHeader, {
            title: r("if2.work_orders.fields")
          }), i.a.createElement(Q.CardBody, {
            isOpen: !0
          }, i.a.createElement(wi.FieldSelectList, {
            fieldSelectModel: t,
            FieldNameColumnComponent: tc
          }), i.a.createElement("div", {
            className: "row"
          }, i.a.createElement("div", {
            className: "col"
          }), i.a.createElement("div", {
            className: "col-md-auto"
          }, i.a.createElement(sc, {
            fieldSelectModel: t
          }))))));
        }
      }]) && pc(t.prototype, r), n && pc(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || uc,
        Oc = V()(gc);

    function wc(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Pc(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? wc(Object(r), !0).forEach(function (t) {
          jc(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : wc(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function jc(e, t, r) {
      return (t = kc(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function _c(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, kc(n.key), n);
      }
    }

    function kc(e) {
      var t = function (e, t) {
        if ("object" != typeof e || null === e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : String(t);
    }

    function Ec(e, t) {
      return (Ec = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Sc(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = xc(e);

        if (t) {
          var o = xc(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Rc(this, r);
      };
    }

    function Rc(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function xc(e) {
      return (xc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Cc,
        Tc = Object(a.observer)(((mc = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Ec(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Sc(a);

      function a(e) {
        var t;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, a);
        var r = (t = o.call(this, e)).props,
            n = r.availableFields,
            i = r.workOrderPathPattern,
            c = r.workOrderFieldsPathPattern,
            u = r.t,
            l = (n || []).map(function (e) {
          var t;

          try {
            t = new Bi(Object(wi.sanitizeField)(e));
          } catch (e) {
            if (!(e instanceof hn.ValidatorResultError)) throw e;
            var r = e.errors.map(function (e) {
              return e.stack;
            });
            throw new Error("Invalid field supplied: ".concat(r.join(", ")));
          }

          return t;
        }),
            s = window.workOrder;
        return t.model = new Ja(Pc(Pc({}, t.props), {}, {
          workOrder: s,
          workOrderPathPattern: i,
          workOrderFieldsPathPattern: c,
          fields: l,
          checkedFields: s.fields.map(function (e) {
            return e.id;
          }),
          cropNames: s.cropNames,
          isOrganic: Boolean(s.organic),
          t: u
        })), t;
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          return i.a.createElement(Oc, {
            fieldSelectModel: this.model
          });
        }
      }]) && _c(t.prototype, r), n && _c(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)).defaultProps = {
      availableFields: [],
      fieldIds: []
    }, vc = mc)) || vc,
        Nc = V()(Tc);

    function Dc(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Mc(e, t) {
      return (Mc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Ac(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Bc(e);

        if (t) {
          var o = Bc(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return zc(this, r);
      };
    }

    function zc(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Bc(e) {
      return (Bc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Lc,
        Fc,
        Uc,
        Ic,
        qc,
        Vc,
        Wc,
        Kc,
        Jc,
        Hc,
        $c = Object(a.observer)(Cc = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Mc(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Ac(a);

      function a(e) {
        var t;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, a), t = o.call(this, e), wi.i18n.addResourceBundle("en", "translation", ht.getResourceBundle("en", "translation", !0, !0)), wi.i18n.addResourceBundle("es", "translation", ht.getResourceBundle("es", "translation", !0, !0)), t;
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          return i.a.createElement(Ma, {
            i18n: wi.i18n
          }, i.a.createElement(Nc, Object.assign({}, this.props, {
            includeVarieties: !0
          })));
        }
      }]) && Dc(t.prototype, r), n && Dc(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Cc,
        Qc = r(6);

    function Gc(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Yc(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Xc(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var Zc = ((Hc = function () {
      function e(t) {
        var r = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), Gc(this, "isFilteringOrganic", Fc, this), Gc(this, "isPending", Uc, this), Gc(this, "products", Ic, this), Gc(this, "_productMap", qc, this), Gc(this, "searchTerm", Vc, this), Gc(this, "showInactive", Wc, this), Gc(this, "filterOrganic", Kc, this), Gc(this, "stopFilteringOrganic", Jc, this), this.products = ((t || {}).products || []).map(function (e) {
          return new G.Product(e);
        }), this.products.forEach(function (e) {
          return r._productMap.set(e.id, e);
        });
      }

      var t, r, n;
      return t = e, n = [{
        key: "extractIndexToOffset",
        value: function (e, t, r) {
          return e.slice(0, t) + e.slice(t + r, e.length);
        }
      }], (r = [{
        key: "filteredProducts",
        get: function () {
          var e = this.products.concat();
          return this.searchTerm && this.searchTerm.split(" ").forEach(function (t) {
            e = e.filter(function (e) {
              return e.searchText.includes(t);
            });
          }), this.showInactive || (e = e.filter(function (e) {
            return e.isActive;
          })), this.isFilteringOrganic && (e = e.filter(function (e) {
            return e.isOrganic;
          })), e;
        }
      }, {
        key: "filteredSortedProducts",
        get: function () {
          return this.searchTerm ? this.filteredProducts.sort(this.constructor.sortBySearchText(this.searchTerm, this.constructor.sortActiveIngredientSearchText)) : this.filteredProducts.sort(G.sortByName);
        }
      }, {
        key: "find",
        value: function (e) {
          return this._productMap.get(e);
        }
      }]) && Yc(t.prototype, r), n && Yc(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), e;
    }()).sortActiveIngredientSearchText = function (e) {
      return function (t, r) {
        var n = t.activeIngredients.map(function (e) {
          return e.name.toLowerCase();
        }),
            o = r.activeIngredients.map(function (e) {
          return e.name.toLowerCase();
        }),
            i = n.join(" "),
            a = o.join(" "),
            c = i.indexOf(e),
            u = a.indexOf(e);
        if (c < u) return -1 === c ? 1 : -1;
        if (u < c) return -1 === u ? -1 : 1;

        if (c === u) {
          if (-1 === c || -1 === u) return Object(G.sortByName)(t, r);
          var l = Hc.extractIndexToOffset(i, c, e.length),
              s = Hc.extractIndexToOffset(a, u, e.length);
          return Object(G.naturalSort)(l, s);
        }

        return 0;
      };
    }, Hc.sortBySearchText = function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
      return function (r, n) {
        var o = r.name.toLowerCase().indexOf(e),
            i = n.name.toLowerCase().indexOf(e);
        if (o < i) return -1 === o ? 1 : -1;
        if (i < o) return -1 === i ? -1 : 1;

        if (o === i) {
          if ((-1 === o || -1 === i) && t) return t(e)(r, n);
          var a = Hc.extractIndexToOffset(r.name, o, e.length),
              c = Hc.extractIndexToOffset(n.name, i, e.length);
          return Object(G.naturalSort)(a, c);
        }

        return 0;
      };
    }, Fc = Xc((Lc = Hc).prototype, "isFilteringOrganic", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Uc = Xc(Lc.prototype, "isPending", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Ic = Xc(Lc.prototype, "products", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), qc = Xc(Lc.prototype, "_productMap", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new Map();
      }
    }), Vc = Xc(Lc.prototype, "searchTerm", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Wc = Xc(Lc.prototype, "showInactive", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Xc(Lc.prototype, "filteredProducts", [J.computed], Object.getOwnPropertyDescriptor(Lc.prototype, "filteredProducts"), Lc.prototype), Xc(Lc.prototype, "filteredSortedProducts", [J.computed], Object.getOwnPropertyDescriptor(Lc.prototype, "filteredSortedProducts"), Lc.prototype), Kc = Xc(Lc.prototype, "filterOrganic", [J.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isFilteringOrganic = !0;
        };
      }
    }), Jc = Xc(Lc.prototype, "stopFilteringOrganic", [J.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isFilteringOrganic = !1;
        };
      }
    }), Lc);

    function eu(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function tu(e, t) {
      return (tu = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function ru(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = ou(e);

        if (t) {
          var o = ou(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return nu(this, r);
      };
    }

    function nu(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function ou(e) {
      return (ou = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var iu = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && tu(e, t);
      }(i, e);
      var t,
          r,
          n,
          o = ru(i);

      function i(e) {
        var t;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, i);
        var r = e || {};
        return (t = o.call(this, e)).apiProductApplicationPathPattern = r.apiProductApplicationPathPattern && new Ct.a(r.apiProductApplicationPathPattern, t.constructor.urlPatternOptions), t.apiProductApplicationsPositionsPathPattern = r.apiProductApplicationsPositionsPathPattern && new Ct.a(r.apiProductApplicationsPositionsPathPattern, t.constructor.urlPatternOptions), t.apiWorkOrderProductApplicationsPathPattern = r.apiWorkOrderProductApplicationsPathPattern && new Ct.a(r.apiWorkOrderProductApplicationsPathPattern, t.constructor.urlPatternOptions), t.i18n = r.i18n, t;
      }

      return t = i, (r = [{
        key: "apiProductApplicationPath",
        value: function (e) {
          var t,
              r = Rt({
            id: e
          }, this.i18n);
          return (null === (t = this.apiProductApplicationPathPattern) || void 0 === t ? void 0 : t.stringify(r)) || "";
        }
      }, {
        key: "apiProductApplicationsPositionsPath",
        value: function () {
          var e,
              t = Rt({}, this.i18n);
          return (null === (e = this.apiProductApplicationsPositionsPathPattern) || void 0 === e ? void 0 : e.stringify(t)) || "";
        }
      }, {
        key: "apiWorkOrderProductApplicationsPath",
        value: function (e) {
          var t,
              r = Rt({
            work_order_id: e.serial
          }, this.i18n);
          return (null === (t = this.apiWorkOrderProductApplicationsPathPattern) || void 0 === t ? void 0 : t.stringify(r)) || "";
        }
      }, {
        key: "create",
        value: function (e) {
          var t = this,
              r = e.workOrder,
              n = e.body,
              o = this.csrf();
          return fetch(this.apiWorkOrderProductApplicationsPath(r), {
            method: "POST",
            headers: {
              "X-CSRF-Token": o,
              "Content-Type": "application/json",
              Accept: "application/json"
            },
            body: JSON.stringify(n)
          }).then(function (e) {
            return t.handleFetchResponse(e);
          });
        }
      }, {
        key: "delete",
        value: function (e) {
          var t = this,
              r = this.csrf();
          return fetch(this.apiProductApplicationPath(e), {
            method: "DELETE",
            headers: {
              "X-CSRF-Token": r,
              "Content-Type": "application/json",
              Accept: "application/json"
            }
          }).then(function (e) {
            return t.handleFetchResponse(e);
          });
        }
      }, {
        key: "update",
        value: function (e) {
          var t = this,
              r = this.csrf();
          return fetch(this.apiProductApplicationPath(e.serial), {
            method: "PATCH",
            headers: {
              "X-CSRF-Token": r,
              "Content-Type": "application/json",
              Accept: "application/json"
            },
            body: JSON.stringify(e.toJS())
          }).then(function (e) {
            return t.handleFetchResponse(e);
          });
        }
      }, {
        key: "updatePositions",
        value: function (e, t) {
          var r = this,
              n = this.csrf();
          return fetch(this.apiProductApplicationsPositionsPath(), {
            method: "PATCH",
            headers: {
              "X-CSRF-Token": n,
              "Content-Type": "application/json",
              Accept: "application/json"
            },
            body: JSON.stringify({
              positions: e,
              work_order_id: t
            })
          }).then(function (e) {
            return r.handleFetchResponse(e);
          });
        }
      }]) && eu(t.prototype, r), n && eu(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(Ut);

    function au(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function cu(e, t) {
      return (cu = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function uu(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = su(e);

        if (t) {
          var o = su(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return lu(this, r);
      };
    }

    function lu(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function su(e) {
      return (su = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    iu.urlPatternOptions = {
      segmentNameCharset: "a-zA-Z0-9_"
    };

    var fu,
        pu,
        du,
        yu,
        bu,
        hu,
        vu,
        mu,
        gu,
        Ou,
        wu = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && cu(e, t);
      }(i, e);
      var t,
          r,
          n,
          o = uu(i);

      function i(e) {
        var t;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, i), (t = o.call(this, e)).patch = function (e) {
          return t.jsonFetch(t.patchPath, "PATCH", {
            work_order: e
          });
        };
        var r = e || {};
        return t.recommendationPathPattern = r.recommendationPathPattern && new Ct.a(r.recommendationPathPattern), t.workOrderPathPattern = r.workOrderPathPattern && new Ct.a(r.workOrderPathPattern), t.workOrdersQueryPathPattern = r.workOrdersQueryPathPattern && new Ct.a(r.workOrdersQueryPathPattern), t.newWorkOrderPath = r.newWorkOrderPath, t.bulkReiPostersPathPattern = r.bulkReiPostersPathPattern && new Ct.a(r.bulkReiPostersPathPattern, t.constructor.UrlPatternOptions), t.queryAllSerialsPath = r.queryAllSerialsPath, t.patchPath = r.patchPath, t.i18n = r.i18n, t;
      }

      return t = i, (r = [{
        key: "workOrderPath",
        value: function (e) {
          var t,
              r = ["number", "string"].includes(typeof e) ? e : e.serial,
              n = Rt({
            id: r
          }, this.i18n);
          return (null === (t = this.workOrderPathPattern) || void 0 === t ? void 0 : t.stringify(n)) || "";
        }
      }, {
        key: "workOrdersQueryPath",
        value: function () {
          var e,
              t = Rt({}, this.i18n);
          return (null === (e = this.workOrdersQueryPathPattern) || void 0 === e ? void 0 : e.stringify(t)) || "";
        }
      }, {
        key: "bulkReiPostersPath",
        value: function (e) {
          var t,
              r = Rt({
            ids: e
          }, this.i18n);
          return (null === (t = this.bulkReiPostersPathPattern) || void 0 === t ? void 0 : t.stringify(r)) || "";
        }
      }, {
        key: "fetch",
        value: function (e) {
          function t(t) {
            return e.apply(this, arguments);
          }

          return t.toString = function () {
            return e.toString();
          }, t;
        }(function (e) {
          var t = this,
              r = this.csrf();
          return fetch(this.workOrderPath(e), {
            method: "GET",
            headers: {
              "X-CSRF-Token": r,
              "Content-Type": "application/json",
              Accept: "application/json"
            }
          }).then(function (e) {
            return t.handleFetchResponse(e);
          });
        })
      }, {
        key: "query",
        value: function (e) {
          var t = this,
              r = e || {},
              n = this.csrf();
          return fetch(this.workOrdersQueryPath(), {
            method: "POST",
            headers: {
              "X-CSRF-Token": n,
              "Content-Type": "application/json",
              Accept: "application/json"
            },
            body: JSON.stringify(r)
          }).then(function (e) {
            return t.handleFetchResponse(e);
          });
        }
      }, {
        key: "queryAllSerials",
        value: function (e) {
          return this.jsonFetch(this.queryAllSerialsPath, "POST", e);
        }
      }, {
        key: "recommendationPath",
        value: function (e) {
          var t,
              r,
              n = Rt({
            id: (null === (t = e.recommendation) || void 0 === t ? void 0 : t.id) || ""
          }, this.i18n);
          return (null === (r = this.recommendationPathPattern) || void 0 === r ? void 0 : r.stringify(n)) || "";
        }
      }]) && au(t.prototype, r), n && au(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(Ut);

    function Pu(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function ju(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Pu(Object(r), !0).forEach(function (t) {
          _u(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Pu(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function _u(e, t, r) {
      return (t = Su(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function ku(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Eu(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Su(n.key), n);
      }
    }

    function Su(e) {
      var t = function (e, t) {
        if ("object" != typeof e || null === e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : String(t);
    }

    function Ru() {
      return (Ru = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = xu(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(this, arguments);
    }

    function xu(e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Mu(e)););

      return e;
    }

    function Cu(e, t) {
      return (Cu = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Tu(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Mu(e);

        if (t) {
          var o = Mu(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Nu(this, r);
      };
    }

    function Nu(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return Du(e);
    }

    function Du(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function Mu(e) {
      return (Mu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Au(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    wu.UrlPatternOptions = {
      segmentNameCharset: "a-zA-Z0-9_"
    };
    var zu,
        Bu = ((Ou = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Cu(e, t);
      }(i, e);
      var t,
          r,
          n,
          o = Tu(i);

      function i(e) {
        var t, r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, i), ku(r = o.call(this, e), "currentProductApplication", pu, Du(r)), ku(r, "isEditing", du, Du(r)), ku(r, "isSaving", yu, Du(r)), ku(r, "isRemoving", bu, Du(r)), ku(r, "moveIsPending", hu, Du(r)), r.phiModalId = "phi-editor-modal", r.phiUnits = ["d"], ku(r, "productApplicationOverride", vu, Du(r)), r.reiModalId = "rei-editor-modal", r.reiUnits = ["Dry", "h", "d"], ku(r, "savedProductApplication", mu, Du(r)), ku(r, "shouldFocusOverrideModal", gu, Du(r));
        var n = r.props,
            a = n.apiProductApplicationPathPattern,
            c = n.apiProductApplicationsPositionsPathPattern,
            u = n.workOrderPathPattern,
            l = n.apiWorkOrderProductApplicationsPathPattern;
        return r.api = r.props.api || new iu({
          apiProductApplicationPathPattern: a,
          apiProductApplicationsPositionsPathPattern: c,
          apiWorkOrderProductApplicationsPathPattern: l
        }), r.workOrdersApi = r.props.workOrdersApi || new wu({
          workOrderPathPattern: u
        }), r.currentProductApplication = new ho({
          id: null,
          position: r.productApplications.length,
          work_order_id: null === (t = r.workOrder) || void 0 === t ? void 0 : t.serial
        }), r.errorMessagesModel = new Qc.ProductApplicationErrorMessagesModel(r.currentProductApplication), r;
      }

      return t = i, (r = [{
        key: "maxPhi",
        get: function () {
          var e;
          return null === (e = this.workOrder) || void 0 === e ? void 0 : e.maxPhi;
        }
      }, {
        key: "maxRei",
        get: function () {
          var e;
          return null === (e = this.workOrder) || void 0 === e ? void 0 : e.maxRei;
        }
      }, {
        key: "nameOfUser",
        get: function () {
          return this.props.nameOfUser || "";
        }
      }, {
        key: "productApplications",
        get: function () {
          var e;
          return (null === (e = this.workOrder) || void 0 === e ? void 0 : e.productApplications) || [];
        }
      }, {
        key: "showEditControls",
        get: function () {
          return this.props.showEditControls;
        }
      }, {
        key: "showNewRowEditor",
        get: function () {
          return !this.isEditing && this.showEditControls;
        }
      }, {
        key: "workOrder",
        get: function () {
          return this.props.workOrder;
        }
      }, {
        key: "dispose",
        value: function () {
          Ru(Mu(i.prototype), "dispose", this).call(this), this.productApplicationsDisposer();
        }
      }, {
        key: "formatError",
        value: function (e) {
          var t;
          return (null === (t = e.formatMessage) || void 0 === t ? void 0 : t.call(e)) || e.message || e;
        }
      }, {
        key: "initBindings",
        value: function () {
          var e = this.props.cardTitle;
          Ru(Mu(i.prototype), "initBindings", this).call(this), this.cardModel = new Q.CardModel({
            title: e
          }), this.onCancel = this.onCancel.bind(this), this.onCloseCard = this.cardModel.close.bind(this), this.onDidFocusOverrideModal = this.onDidFocusOverrideModal.bind(this), this.onDropRow = this.onDropRow.bind(this), this.onEdit = this.onEdit.bind(this), this.onMoveRow = this.onMoveRow.bind(this), this.onOpenCard = this.cardModel.open.bind(this), this.onOverridePhi = this.onOverridePhi.bind(this), this.onOverrideRei = this.onOverrideRei.bind(this), this.onRemove = this.onRemove.bind(this), this.onSave = this.onSave.bind(this), this.onSavePhiOverride = this.onSavePhiOverride.bind(this), this.onSaveReiOverride = this.onSaveReiOverride.bind(this);
        }
      }, {
        key: "initialize",
        value: function (e) {
          var t = this;
          Ru(Mu(i.prototype), "initialize", this).call(this, e);
          var r = this.props.products;
          this.productSelectorModel = new Zc({
            products: r
          }), this.productApplicationsDisposer = Object(J.reaction)(function () {
            var e;
            return null === (e = t.workOrder) || void 0 === e ? void 0 : e.productApplications;
          }, function (e) {
            return e && t.updateProductApplicationProducts(e);
          }, {
            fireImmediately: !0
          });
        }
      }, {
        key: "notifyError",
        value: function (e) {
          window.alert(this.formatError(e)), console.error(this.formatError(e));
        }
      }, {
        key: "onCancel",
        value: function (e) {
          var t,
              r = this,
              n = (e || {}).skipRestore;
          this.savedProductApplication && !n && Object.keys(this.currentProductApplication).forEach(function (e) {
            r.currentProductApplication[e] = "position" === e ? r.currentProductApplication[e] : r.savedProductApplication[e];
          }), this.currentProductApplication = new ho({
            position: this.productApplications.length,
            work_order_id: null === (t = this.workOrder) || void 0 === t ? void 0 : t.serial
          }), this.errorMessagesModel.reset(), this.savedProductApplication = null, this.productSelectorModel.searchTerm = "", this.isEditing = !1;
        }
      }, {
        key: "onDidFocusOverrideModal",
        value: function () {
          this.shouldFocusOverrideModal = !1;
        }
      }, {
        key: "onDropRow",
        value: function (e) {
          this.onMoveRow(this.currentProductApplication.position, e);
        }
      }, {
        key: "onEdit",
        value: function (e) {
          this.isEditing && this.onCancel(), this.isEditing = !0, this.errorMessagesModel.reset(), this.currentProductApplication = e, this.savedProductApplication = new ho(e.toJS());
        }
      }, {
        key: "onMoveRow",
        value: function (e, t) {
          var r = this;
          this.moveIsPending = !0, this.workOrder.moveProductApplication(this.currentProductApplication.id, e, t);
          var n = this.workOrder.productApplications.reduce(function (e, t) {
            return e[t.serial] = t.position, e;
          }, {});
          return this.api.updatePositions(n, this.workOrder.serial).then(function () {
            return r.reloadWorkOrder();
          }).catch(function (e) {
            return r.notifyError(e);
          }).finally(function () {
            return Object(J.runInAction)(function () {
              r.moveIsPending = !1;
            });
          });
        }
      }, {
        key: "onOverridePhi",
        value: function (e) {
          this.productApplicationOverride = e, $("#".concat(this.phiModalId)).modal("show"), this.shouldFocusOverrideModal = !0;
        }
      }, {
        key: "onOverrideRei",
        value: function (e) {
          this.productApplicationOverride = e, $("#".concat(this.reiModalId)).modal("show"), this.shouldFocusOverrideModal = !0;
        }
      }, {
        key: "onRemove",
        value: function (e) {
          var t = this;
          return this.isRemoving = !0, this.api.delete(e.serial).then(function () {
            return t.reloadWorkOrder();
          }).catch(function (e) {
            return t.notifyError(e);
          }).finally(function () {
            return Object(J.runInAction)(function () {
              return t.isRemoving = !1;
            });
          });
        }
      }, {
        key: "onSave",
        value: function (e) {
          var t = this;
          return this.errorMessagesModel.validationErrors(e, this.productApplications), this.errorMessagesModel.isValid ? (this.isSaving = !0, Promise.resolve().then(function () {
            return t.isEditing ? t.api.update(e) : t.api.create({
              workOrder: t.workOrder,
              body: {
                product_application: e.toJS()
              }
            });
          }).then(function () {
            return t.reloadWorkOrder();
          }).then(function () {
            return t.onCancel({
              skipRestore: !0
            }), !0;
          }).catch(function (e) {
            return t.notifyError(e), !1;
          }).finally(function () {
            return Object(J.runInAction)(function () {
              t.isSaving = !1;
            });
          })) : Promise.resolve(!1);
        }
      }, {
        key: "onSavePhiOverride",
        value: function (e) {
          var t = this;
          this.isSaving = !0;
          var r = e.phiOverride,
              n = e.phiOverrideReason,
              o = e.productApplication;
          return $("#".concat(this.phiModalId)).modal("hide"), this.api.update(new ho(ju(ju({}, o.toJS()), {}, {
            phiOverride: r || null,
            phiOverrideBy: r && n ? this.nameOfUser : "",
            phiOverrideReason: n
          }))).then(function () {
            return t.reloadWorkOrder();
          }).catch(function (e) {
            return t.notifyError(e);
          }).finally(function () {
            return Object(J.runInAction)(function () {
              t.isSaving = !1;
            });
          });
        }
      }, {
        key: "onSaveReiOverride",
        value: function (e) {
          var t = this;
          this.isSaving = !0;
          var r = e.reiOverride,
              n = e.reiOverrideReason,
              o = e.productApplication;
          return $("#".concat(this.reiModalId)).modal("hide"), this.api.update(new ho(ju(ju({}, o.toJS()), {}, {
            reiOverride: r || null,
            reiOverrideBy: r && n ? this.nameOfUser : "",
            reiOverrideReason: n
          }))).then(function () {
            return t.reloadWorkOrder();
          }).catch(function (e) {
            return t.notifyError(e);
          }).finally(function () {
            return Object(J.runInAction)(function () {
              t.isSaving = !1;
            });
          });
        }
      }, {
        key: "reloadWorkOrder",
        value: function () {
          var e = this;
          return this.workOrdersApi.fetch(this.workOrder.serial).then(function (t) {
            return e.workOrder.update(t), e.workOrder;
          });
        }
      }, {
        key: "updateProductApplicationProducts",
        value: function (e) {
          var t = this;
          (e || []).forEach(function (e) {
            var r;

            if (null != e && null !== (r = e.product) && void 0 !== r && r.id) {
              var n = t.productSelectorModel.find(e.product.id);
              n && e.product.update(n.toJS());
            }
          });
        }
      }]) && Eu(t.prototype, r), n && Eu(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(Z)).urlPatternOptions = {
      segmentNameCharset: "a-zA-Z0-9_"
    }, pu = Au((fu = Ou).prototype, "currentProductApplication", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), du = Au(fu.prototype, "isEditing", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), yu = Au(fu.prototype, "isSaving", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), bu = Au(fu.prototype, "isRemoving", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), hu = Au(fu.prototype, "moveIsPending", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), vu = Au(fu.prototype, "productApplicationOverride", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new ho();
      }
    }), mu = Au(fu.prototype, "savedProductApplication", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), gu = Au(fu.prototype, "shouldFocusOverrideModal", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Au(fu.prototype, "maxPhi", [J.computed], Object.getOwnPropertyDescriptor(fu.prototype, "maxPhi"), fu.prototype), Au(fu.prototype, "maxRei", [J.computed], Object.getOwnPropertyDescriptor(fu.prototype, "maxRei"), fu.prototype), Au(fu.prototype, "nameOfUser", [J.computed], Object.getOwnPropertyDescriptor(fu.prototype, "nameOfUser"), fu.prototype), Au(fu.prototype, "productApplications", [J.computed], Object.getOwnPropertyDescriptor(fu.prototype, "productApplications"), fu.prototype), Au(fu.prototype, "showEditControls", [J.computed], Object.getOwnPropertyDescriptor(fu.prototype, "showEditControls"), fu.prototype), Au(fu.prototype, "showNewRowEditor", [J.computed], Object.getOwnPropertyDescriptor(fu.prototype, "showNewRowEditor"), fu.prototype), Au(fu.prototype, "workOrder", [J.computed], Object.getOwnPropertyDescriptor(fu.prototype, "workOrder"), fu.prototype), Au(fu.prototype, "initBindings", [J.action], Object.getOwnPropertyDescriptor(fu.prototype, "initBindings"), fu.prototype), Au(fu.prototype, "initialize", [J.action], Object.getOwnPropertyDescriptor(fu.prototype, "initialize"), fu.prototype), Au(fu.prototype, "onCancel", [J.action], Object.getOwnPropertyDescriptor(fu.prototype, "onCancel"), fu.prototype), Au(fu.prototype, "onDidFocusOverrideModal", [J.action], Object.getOwnPropertyDescriptor(fu.prototype, "onDidFocusOverrideModal"), fu.prototype), Au(fu.prototype, "onDropRow", [J.action], Object.getOwnPropertyDescriptor(fu.prototype, "onDropRow"), fu.prototype), Au(fu.prototype, "onEdit", [J.action], Object.getOwnPropertyDescriptor(fu.prototype, "onEdit"), fu.prototype), Au(fu.prototype, "onMoveRow", [J.action], Object.getOwnPropertyDescriptor(fu.prototype, "onMoveRow"), fu.prototype), Au(fu.prototype, "onOverridePhi", [J.action], Object.getOwnPropertyDescriptor(fu.prototype, "onOverridePhi"), fu.prototype), Au(fu.prototype, "onOverrideRei", [J.action], Object.getOwnPropertyDescriptor(fu.prototype, "onOverrideRei"), fu.prototype), Au(fu.prototype, "onRemove", [J.action], Object.getOwnPropertyDescriptor(fu.prototype, "onRemove"), fu.prototype), Au(fu.prototype, "onSave", [J.action], Object.getOwnPropertyDescriptor(fu.prototype, "onSave"), fu.prototype), Au(fu.prototype, "onSavePhiOverride", [J.action], Object.getOwnPropertyDescriptor(fu.prototype, "onSavePhiOverride"), fu.prototype), Au(fu.prototype, "onSaveReiOverride", [J.action], Object.getOwnPropertyDescriptor(fu.prototype, "onSaveReiOverride"), fu.prototype), Au(fu.prototype, "reloadWorkOrder", [J.action], Object.getOwnPropertyDescriptor(fu.prototype, "reloadWorkOrder"), fu.prototype), Au(fu.prototype, "updateProductApplicationProducts", [J.action], Object.getOwnPropertyDescriptor(fu.prototype, "updateProductApplicationProducts"), fu.prototype), fu);

    function Lu(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Fu(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Uu(e, t) {
      return (Uu = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Iu(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Vu(e);

        if (t) {
          var o = Vu(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return qu(this, r);
      };
    }

    function qu(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Vu(e) {
      return (Vu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Wu,
        Ku = Object(a.observer)(zu = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Uu(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Iu(a);

      function a() {
        return Lu(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.model;
          return i.a.createElement(i.a.Fragment, null, i.a.createElement(Qc.OverrideModal, {
            id: e.phiModalId,
            displayName: "PHI",
            productApplication: e.productApplicationOverride,
            shouldFocusModal: e.shouldFocusOverrideModal,
            unitChoices: e.phiUnits,
            originalKey: "phi",
            overrideKey: "phiOverride",
            overrideReasonKey: "phiOverrideReason",
            onDidFocusModal: e.onDidFocusOverrideModal,
            onSave: e.onSavePhiOverride
          }), i.a.createElement(Qc.OverrideModal, {
            id: e.reiModalId,
            displayName: "REI",
            productApplication: e.productApplicationOverride,
            shouldFocusModal: e.shouldFocusOverrideModal,
            unitChoices: e.reiUnits,
            originalKey: "rei",
            overrideKey: "reiOverride",
            overrideReasonKey: "reiOverrideReason",
            onDidFocusModal: e.onDidFocusOverrideModal,
            onSave: e.onSaveReiOverride
          }));
        }
      }]) && Fu(t.prototype, r), n && Fu(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || zu;

    function Ju(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Hu(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function $u(e, t) {
      return ($u = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Qu(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Yu(e);

        if (t) {
          var o = Yu(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Gu(this, r);
      };
    }

    function Gu(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Yu(e) {
      return (Yu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Xu,
        Zu,
        el = Object(a.observer)(Wu = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && $u(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Qu(a);

      function a() {
        return Ju(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.t;
          return i.a.createElement("thead", {
            "data-testid": "products-table-head"
          }, i.a.createElement("tr", null, i.a.createElement("th", {
            scope: "col"
          }, e("if2.work_orders.product")), i.a.createElement("th", {
            scope: "col"
          }, e("if2.work_orders.work_orders.products_editor.reg_number_short")), i.a.createElement("th", {
            scope: "col"
          }, e("if2.work_orders.rate")), i.a.createElement("th", {
            scope: "col"
          }, e("if2.work_orders.work_orders.products_editor.target_reason")), i.a.createElement("th", {
            scope: "col"
          }, "PHI"), i.a.createElement("th", {
            scope: "col"
          }, "REI"), i.a.createElement("th", {
            scope: "col",
            "aria-label": "Actions",
            className: "actions"
          })));
        }
      }]) && Hu(t.prototype, r), n && Hu(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Wu,
        tl = V()(el);

    function rl(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function nl(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function ol() {
      return (ol = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = il(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(this, arguments);
    }

    function il(e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = ll(e)););

      return e;
    }

    function al(e, t) {
      return (al = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function cl(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = ll(e);

        if (t) {
          var o = ll(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return ul(this, r);
      };
    }

    function ul(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function ll(e) {
      return (ll = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function sl(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var fl,
        pl,
        dl = ((Zu = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && al(e, t);
      }(i, e);
      var t,
          r,
          n,
          o = cl(i);

      function i() {
        return rl(this, i), o.apply(this, arguments);
      }

      return t = i, (r = [{
        key: "model",
        get: function () {
          return this.props.model;
        }
      }, {
        key: "rowModel",
        get: function () {
          return this.props.rowModel;
        }
      }, {
        key: "isPending",
        get: function () {
          return this.model.moveIsPending || this.model.isSaving;
        }
      }, {
        key: "initBindings",
        value: function () {
          ol(ll(i.prototype), "initBindings", this).call(this), this.onCancel = this.onCancel.bind(this), this.onDragRowStart = this.onDragRowStart.bind(this), this.onInputKeyDown = this.onInputKeyDown.bind(this), this.onSave = this.onSave.bind(this), this.onSelectProduct = this.onSelectProduct.bind(this);
        }
      }, {
        key: "onSave",
        value: function (e) {
          var t = this;
          if (e && e.preventDefault(), !this.isPending) return this.model.onSave(this.rowModel.productApplication).then(function (e) {
            return e ? t.focusProductSelector() : null;
          });
        }
      }, {
        key: "onCancel",
        value: function (e) {
          var t = this;
          e && e.preventDefault();
          var r = this.props,
              n = r.model,
              o = r.rowModel,
              i = n.isEditing;
          return n.onCancel(), i || o.clearProduct(), new Promise(function (e) {
            return setTimeout(function () {
              return e(t.focusProductSelector());
            }, 20);
          });
        }
      }, {
        key: "onInputKeyDown",
        value: function (e) {
          "Enter" === e.key && this.onSave(e);
        }
      }, {
        key: "onSelectProduct",
        value: function (e, t) {
          this.props.rowModel.onSelectProduct(e), t || this.focusUnitSelector();
        }
      }, {
        key: "onDragRowStart",
        value: function (e) {
          e.dataTransfer.effectAllowed = "move";
        }
      }, {
        key: "focusProductSelector",
        value: function () {
          $(".product-application-row-editor .product-selector input").focus();
        }
      }, {
        key: "focusUnitSelector",
        value: function () {
          $(".product-application-row-editor .unit-selector-value input").focus();
        }
      }, {
        key: "validationMsg",
        value: function (e) {
          return e && [this.constructor.translationPrefix].concat(e).join(".") || "";
        }
      }]) && nl(t.prototype, r), n && nl(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(Z)).translationPrefix = "if2.work_orders.work_orders.products_editor", sl((Xu = Zu).prototype, "model", [J.computed], Object.getOwnPropertyDescriptor(Xu.prototype, "model"), Xu.prototype), sl(Xu.prototype, "rowModel", [J.computed], Object.getOwnPropertyDescriptor(Xu.prototype, "rowModel"), Xu.prototype), sl(Xu.prototype, "isPending", [J.computed], Object.getOwnPropertyDescriptor(Xu.prototype, "isPending"), Xu.prototype), sl(Xu.prototype, "onSave", [J.action], Object.getOwnPropertyDescriptor(Xu.prototype, "onSave"), Xu.prototype), sl(Xu.prototype, "onCancel", [J.action], Object.getOwnPropertyDescriptor(Xu.prototype, "onCancel"), Xu.prototype), sl(Xu.prototype, "onInputKeyDown", [J.action], Object.getOwnPropertyDescriptor(Xu.prototype, "onInputKeyDown"), Xu.prototype), sl(Xu.prototype, "onSelectProduct", [J.action], Object.getOwnPropertyDescriptor(Xu.prototype, "onSelectProduct"), Xu.prototype), sl(Xu.prototype, "onDragRowStart", [J.action], Object.getOwnPropertyDescriptor(Xu.prototype, "onDragRowStart"), Xu.prototype), Xu);

    function yl(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function bl(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function hl(e, t) {
      return (hl = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function vl(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = gl(e);

        if (t) {
          var o = gl(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return ml(this, r);
      };
    }

    function ml(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function gl(e) {
      return (gl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Ol,
        wl,
        Pl = Object(a.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null);
    }((pl = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && hl(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = vl(a);

      function a() {
        return yl(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "errorMessage",
        get: function () {
          var e,
              t,
              r = this.props,
              n = r.editorModel,
              o = r.t;
          return o(n.validationMsg(null === (e = n.model.errorMessagesModel.errorMessages) || void 0 === e ? void 0 : e.product)) || o(n.validationMsg(null === (t = n.model.errorMessagesModel.errorMessages) || void 0 === t ? void 0 : t.productAlreadyApplied)) || "";
        }
      }, {
        key: "render",
        value: function () {
          var e,
              t = this.props,
              r = t.isDraggable,
              n = t.editorModel;
          return i.a.createElement("td", {
            "data-testid": "row-editor-product-cell",
            colSpan: "2"
          }, i.a.createElement("div", {
            className: "d-flex align-items-center"
          }, r ? i.a.createElement("i", {
            className: "editor-row-grip fas fa-grip-vertical pl-2 pr-3 text-secondary"
          }) : n.model.moveIsPending ? i.a.createElement(Q.Spinner, null) : null, i.a.createElement(Qc.ProductSelector, {
            errorMessage: this.errorMessage,
            productsStore: n.model.productSelectorModel,
            currentProduct: null === (e = n.model.currentProductApplication) || void 0 === e ? void 0 : e.product,
            onSelectProduct: n.onSelectProduct
          })));
        }
      }]) && bl(t.prototype, r), n && bl(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)).prototype, "errorMessage", [J.computed], Object.getOwnPropertyDescriptor(pl.prototype, "errorMessage"), pl.prototype), fl = pl)) || fl,
        jl = V()(Pl);

    function _l(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function kl(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function El(e, t) {
      return (El = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Sl(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = xl(e);

        if (t) {
          var o = xl(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Rl(this, r);
      };
    }

    function Rl(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function xl(e) {
      return (xl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Cl(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var Tl,
        Nl = Object(a.observer)((Cl((wl = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && El(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Sl(a);

      function a() {
        return _l(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "valueError",
        get: function () {
          var e,
              t = this.props,
              r = t.editorModel;
          return (0, t.t)(r.validationMsg(null === (e = r.model.errorMessagesModel.errorMessages) || void 0 === e ? void 0 : e.rateValue)) || "";
        }
      }, {
        key: "unitsError",
        get: function () {
          var e,
              t = this.props,
              r = t.editorModel;
          return (0, t.t)(r.validationMsg(null === (e = r.model.errorMessagesModel.errorMessages) || void 0 === e ? void 0 : e.rateUnit)) || "";
        }
      }, {
        key: "render",
        value: function () {
          var e,
              t,
              r = this.props,
              n = r.editorModel,
              o = r.t;
          return i.a.createElement("td", {
            "data-testid": "row-editor-units-cell"
          }, i.a.createElement("div", {
            className: "form-row my-2"
          }, i.a.createElement(Q.UnitSelector, {
            placeholder: o("if2.work_orders.rate"),
            currentUnit: (null === (e = n.rowModel.productApplication.rate) || void 0 === e ? void 0 : e.units) || "",
            currentValue: (null === (t = n.rowModel.productApplication.rate) || void 0 === t ? void 0 : t.scalar) || "",
            unitChoices: n.rowModel.rateUnitChoices,
            valueColumnClassName: "col-md-5 unit-selector-value",
            unitColumnClassName: "col-md-7 unit-selector-unit",
            onValueKeyDown: n.onInputKeyDown,
            onUpdateUnit: n.rowModel.onUpdateRateUnit,
            onUpdateValue: n.rowModel.onUpdateRateValue,
            valueError: this.valueError,
            unitsError: this.unitsError
          })));
        }
      }]) && kl(t.prototype, r), n && kl(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)).prototype, "valueError", [J.computed], Object.getOwnPropertyDescriptor(wl.prototype, "valueError"), wl.prototype), Cl(wl.prototype, "unitsError", [J.computed], Object.getOwnPropertyDescriptor(wl.prototype, "unitsError"), wl.prototype), Ol = wl)) || Ol,
        Dl = V()(Nl);

    function Ml(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Al(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function zl(e, t) {
      return (zl = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Bl(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Fl(e);

        if (t) {
          var o = Fl(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Ll(this, r);
      };
    }

    function Ll(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Fl(e) {
      return (Fl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Ul,
        Il = Object(a.observer)(Tl = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && zl(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Bl(a);

      function a() {
        return Ml(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e,
              t = this.props,
              r = t.editorModel,
              n = t.t;
          return i.a.createElement("td", {
            "data-testid": "row-editor-target-cell",
            colSpan: "3"
          }, i.a.createElement("div", {
            className: "my-2"
          }, i.a.createElement("input", {
            className: "form-control",
            placeholder: n("if2.work_orders.work_orders.products_editor.target_reason"),
            value: (null === (e = r.rowModel.productApplication) || void 0 === e ? void 0 : e.target) || "",
            onChange: r.rowModel.onChangeTarget,
            onKeyDown: r.onInputKeyDown
          })));
        }
      }]) && Al(t.prototype, r), n && Al(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Tl,
        ql = V()(Il);

    function Vl(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Wl(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Kl(e, t) {
      return (Kl = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Jl(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = $l(e);

        if (t) {
          var o = $l(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Hl(this, r);
      };
    }

    function Hl(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function $l(e) {
      return ($l = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Ql,
        Gl = Object(a.observer)(Ul = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Kl(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Jl(a);

      function a() {
        return Vl(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.editorModel,
              r = e.t;
          return i.a.createElement("td", {
            "data-testid": "row-editor-actions-cell",
            className: "actions"
          }, i.a.createElement("a", {
            href: "#",
            role: "button",
            className: "".concat(t.isPending ? "disabled " : "").concat(t.model.isEditing ? "text-success" : "icon-link"),
            onClick: t.onSave,
            "aria-disabled": t.isPending
          }, i.a.createElement("span", {
            className: "sr-only sr-only-focusable"
          }, r("if2.work_orders.save")), i.a.createElement("i", {
            "aria-hidden": "true",
            className: "fas ".concat(t.model.isEditing ? "fa-save" : "fa-plus-circle")
          })), i.a.createElement("a", {
            href: "#",
            role: "button",
            name: "cancel",
            className: "".concat(t.isPending ? "disabled " : "", "text-secondary"),
            onClick: t.onCancel,
            "aria-disabled": t.isPending
          }, i.a.createElement("span", {
            className: "sr-only sr-only-focusable"
          }, r("if2.work_orders.cancel")), i.a.createElement("i", {
            "aria-hidden": "true",
            className: "fas fa-times-circle"
          })));
        }
      }]) && Wl(t.prototype, r), n && Wl(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Ul,
        Yl = V()(Gl);

    function Xl(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Zl(e, t) {
      return (Zl = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function es(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = rs(e);

        if (t) {
          var o = rs(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return ts(this, r);
      };
    }

    function ts(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function rs(e) {
      return (rs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var ns,
        os = Object(a.observer)(Ql = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Zl(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = es(a);

      function a(e) {
        var t;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, a);
        var r = (t = o.call(this, e)).props,
            n = r.model,
            i = r.rowModel;
        return t.editorModel = new dl({
          model: n,
          rowModel: i
        }), t;
      }

      return t = a, (r = [{
        key: "componentDidMount",
        value: function () {
          this.editorModel.model.isEditing && this.editorModel.focusProductSelector();
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.isDraggable,
              r = e.className;
          return i.a.createElement("tr", {
            "data-testid": "product-application-row-editor",
            className: "".concat(r, " product-application-row-editor"),
            draggable: t,
            onDragStart: this.editorModel.onDragRowStart
          }, i.a.createElement(jl, {
            isDraggable: t,
            editorModel: this.editorModel
          }), i.a.createElement(Dl, {
            editorModel: this.editorModel
          }), i.a.createElement(ql, {
            editorModel: this.editorModel
          }), i.a.createElement(Yl, {
            editorModel: this.editorModel
          }));
        }
      }]) && Xl(t.prototype, r), n && Xl(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Ql;

    function is(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function as(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function cs(e, t) {
      return (cs = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function us(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = ss(e);

        if (t) {
          var o = ss(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return ls(this, r);
      };
    }

    function ls(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function ss(e) {
      return (ss = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var fs,
        ps = Object(a.observer)(ns = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && cs(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = us(a);

      function a() {
        return is(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.activeIngredient;
          return i.a.createElement("div", {
            className: "active-ingredient"
          }, e.name);
        }
      }]) && as(t.prototype, r), n && as(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || ns;

    function ds(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function ys(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function bs(e, t) {
      return (bs = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function hs(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = ms(e);

        if (t) {
          var o = ms(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return vs(this, r);
      };
    }

    function vs(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function ms(e) {
      return (ms = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var gs,
        Os = Object(a.observer)(fs = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && bs(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = hs(a);

      function a() {
        return ds(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.rowModel;
          return i.a.createElement(i.a.Fragment, null, e.activeIngredients.map(function (e) {
            return i.a.createElement(ps, {
              key: e.id,
              activeIngredient: e
            });
          }));
        }
      }]) && ys(t.prototype, r), n && ys(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || fs;

    function ws(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Ps(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function js(e, t) {
      return (js = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function _s(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Es(e);

        if (t) {
          var o = Es(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return ks(this, r);
      };
    }

    function ks(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Es(e) {
      return (Es = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Ss,
        Rs = Object(a.observer)(gs = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && js(e, t);
      }(a, e);

      var t,
          r,
          n,
          o = _s(a);

      function a() {
        return ws(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e,
              t = this.props.rowModel;
          return null !== (e = t.product) && void 0 !== e && e.hasNutrientAnalysis ? i.a.createElement("div", {
            className: "nutrient-analysis"
          }, t.product.nutrientAnalysisLabel) : null;
        }
      }]) && Ps(t.prototype, r), n && Ps(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || gs;

    function xs(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Cs(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Ts(e, t) {
      return (Ts = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Ns(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Ms(e);

        if (t) {
          var o = Ms(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Ds(this, r);
      };
    }

    function Ds(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Ms(e) {
      return (Ms = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var As,
        zs = Object(a.observer)(Ss = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Ts(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Ns(a);

      function a() {
        return xs(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e,
              t = this.props.rowModel;
          return null !== (e = t.product) && void 0 !== e && e.organicListings ? i.a.createElement("div", {
            className: "product-reference"
          }, t.product.organicListings.map(function (e) {
            return e.reference;
          }).join("\n")) : null;
        }
      }]) && Cs(t.prototype, r), n && Cs(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Ss;

    function Bs(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Ls(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Fs(e, t) {
      return (Fs = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Us(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = qs(e);

        if (t) {
          var o = qs(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Is(this, r);
      };
    }

    function Is(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function qs(e) {
      return (qs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Vs,
        Ws = Object(a.observer)(As = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Fs(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Us(a);

      function a() {
        return Bs(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e,
              t = this.props,
              r = t.model,
              n = t.rowModel;
          return i.a.createElement(Qc.OverrideEditor, {
            isComplete: null === (e = r.workOrder) || void 0 === e ? void 0 : e.isComplete,
            productApplication: n.productApplication,
            onOverride: r.onOverridePhi,
            originalKey: "phi",
            overrideKey: "phiOverride",
            overrideReasonKey: "phiOverrideReason",
            overrideByKey: "phiOverrideBy",
            showEditControls: r.showEditControls
          });
        }
      }]) && Ls(t.prototype, r), n && Ls(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || As;

    function Ks(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Js(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Hs(e, t) {
      return (Hs = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function $s(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Gs(e);

        if (t) {
          var o = Gs(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Qs(this, r);
      };
    }

    function Qs(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Gs(e) {
      return (Gs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Ys,
        Xs = Object(a.observer)(Vs = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Hs(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = $s(a);

      function a() {
        return Ks(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e,
              t = this.props,
              r = t.model,
              n = t.rowModel,
              o = t.t;
          return i.a.createElement(Qc.OverrideEditor, {
            isComplete: null === (e = r.workOrder) || void 0 === e ? void 0 : e.isComplete,
            productApplication: n.productApplication,
            onOverride: r.onOverrideRei,
            originalKey: "rei",
            overrideKey: "reiOverride",
            overrideReasonKey: "reiOverrideReason",
            overrideByKey: "reiOverrideBy",
            valueMissingText: o("if2.work_orders.unspecified"),
            valueMissingClass: "text-danger font-italic",
            showEditControls: r.showEditControls
          });
        }
      }]) && Js(t.prototype, r), n && Js(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Vs,
        Zs = V()(Xs);

    function ef(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function tf(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function rf(e, t) {
      return (rf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function nf(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = af(e);

        if (t) {
          var o = af(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return of(this, r);
      };
    }

    function of(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function af(e) {
      return (af = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var cf,
        uf,
        lf = Object(a.observer)(Ys = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && rf(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = nf(a);

      function a() {
        return ef(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e,
              t,
              r,
              n,
              o,
              a = this.props,
              c = a.model,
              u = a.rowModel;
          return i.a.createElement("tr", {
            "data-testid": "products-table-row-view",
            className: u.isDropTarget ? "table-primary" : "",
            onDragOver: u.onDragOver,
            onDragLeave: u.onDragExit,
            onDrop: u.onDrop
          }, i.a.createElement("td", null, null === (e = u.product) || void 0 === e ? void 0 : e.name, i.a.createElement(Os, {
            rowModel: u
          }), i.a.createElement(Rs, {
            rowModel: u
          })), i.a.createElement("td", {
            className: "product-reg-num"
          }, null === (t = u.product) || void 0 === t ? void 0 : t.registrationNumber, i.a.createElement(zs, {
            rowModel: u
          })), i.a.createElement("td", null, null === (r = u.productApplication) || void 0 === r || null === (n = r.rate) || void 0 === n ? void 0 : n.displayValue), i.a.createElement("td", null, null === (o = u.productApplication) || void 0 === o ? void 0 : o.target), i.a.createElement("td", null, i.a.createElement(Ws, {
            model: c,
            rowModel: u
          })), i.a.createElement("td", null, i.a.createElement(Zs, {
            model: c,
            rowModel: u
          })), i.a.createElement("td", {
            className: "actions"
          }, c.showEditControls ? i.a.createElement(i.a.Fragment, null, i.a.createElement("a", {
            href: "#",
            className: "icon-link",
            onClick: u.onEdit
          }, i.a.createElement("i", {
            className: "fas fa-edit"
          })), i.a.createElement("a", {
            href: "#",
            className: "text-danger",
            onClick: u.onRemove
          }, i.a.createElement("i", {
            className: "fas fa-trash-alt"
          }))) : null));
        }
      }]) && tf(t.prototype, r), n && tf(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Ys;

    function sf(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function ff(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function pf(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function df() {
      return (df = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = yf(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(this, arguments);
    }

    function yf(e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = gf(e)););

      return e;
    }

    function bf(e, t) {
      return (bf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function hf(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = gf(e);

        if (t) {
          var o = gf(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return vf(this, r);
      };
    }

    function vf(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return mf(e);
    }

    function mf(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function gf(e) {
      return (gf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Of(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var wf,
        Pf = (uf = Of((cf = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && bf(e, t);
      }(i, e);
      var t,
          r,
          n,
          o = hf(i);

      function i() {
        var e;
        ff(this, i);

        for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];

        return sf(e = o.call.apply(o, [this].concat(r)), "isDropTarget", uf, mf(e)), e;
      }

      return t = i, (r = [{
        key: "activeIngredients",
        get: function () {
          var e;
          return (null === (e = this.product) || void 0 === e ? void 0 : e.activeIngredients) || [];
        }
      }, {
        key: "product",
        get: function () {
          var e = this.props.productApplication;
          return null == e ? void 0 : e.product;
        }
      }, {
        key: "productApplication",
        get: function () {
          return this.props.productApplication;
        }
      }, {
        key: "rateUnitChoices",
        get: function () {
          var e;
          return (null === (e = this.product) || void 0 === e ? void 0 : e.rateUnitChoices) || [];
        }
      }, {
        key: "clearProduct",
        value: function () {
          this.productApplication && (this.productApplication.product = null);
        }
      }, {
        key: "initBindings",
        value: function () {
          df(gf(i.prototype), "initBindings", this).call(this), this.onChangeTarget = this.onChangeTarget.bind(this), this.onDragOver = this.onDragOver.bind(this), this.onDragExit = this.onDragExit.bind(this), this.onDrop = this.onDrop.bind(this), this.onEdit = this.onEdit.bind(this), this.onRemove = this.onRemove.bind(this), this.onSelectProduct = this.onSelectProduct.bind(this), this.onUpdateRateUnit = this.onUpdateRateUnit.bind(this), this.onUpdateRateValue = this.onUpdateRateValue.bind(this);
        }
      }, {
        key: "onChangeTarget",
        value: function (e) {
          this.props.productApplication.update({
            target: e.target.value
          });
        }
      }, {
        key: "onDragOver",
        value: function (e) {
          e.preventDefault(), this.isDropTarget = !0;
        }
      }, {
        key: "onDragExit",
        value: function () {
          this.isDropTarget = !1;
        }
      }, {
        key: "onDrop",
        value: function () {
          var e = this.props,
              t = e.productApplication,
              r = e.onDropRow;
          this.isDropTarget = !1, r(t.position);
        }
      }, {
        key: "onEdit",
        value: function (e) {
          e.preventDefault();
          var t = this.props,
              r = t.onEdit;
          r(t.productApplication);
        }
      }, {
        key: "onRemove",
        value: function (e) {
          e.preventDefault();
          var t = this.props,
              r = t.onRemove;
          r(t.productApplication);
        }
      }, {
        key: "onSelectProduct",
        value: function (e) {
          var t,
              r = this.props,
              n = r.productApplication,
              o = r.errorMessagesModel;
          return n.product = e, null != n && null !== (t = n.rate) && void 0 !== t && t.units && !this.rateUnitChoices.find(function (e) {
            return e.value === n.rate.units;
          }) && (n.rate.units = ""), new Promise(function (e) {
            return setTimeout(function () {
              return e(o.resetProduct());
            }, 100);
          });
        }
      }, {
        key: "onUpdateRateUnit",
        value: function (e) {
          var t = this.props,
              r = t.productApplication,
              n = t.errorMessagesModel;
          return r.rate || (r.rate = new G.Quantity()), r.rate.units = e, new Promise(function (e) {
            return setTimeout(function () {
              return e(n.resetRateUnit());
            }, 100);
          });
        }
      }, {
        key: "onUpdateRateValue",
        value: function (e) {
          var t = this.props,
              r = t.productApplication,
              n = t.errorMessagesModel;
          return r.rate || (r.rate = new G.Quantity()), r.rate.scalar = e, new Promise(function (e) {
            return setTimeout(function () {
              return e(n.resetRateValue());
            }, 100);
          });
        }
      }]) && pf(t.prototype, r), n && pf(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(Z)).prototype, "isDropTarget", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Of(cf.prototype, "activeIngredients", [J.computed], Object.getOwnPropertyDescriptor(cf.prototype, "activeIngredients"), cf.prototype), Of(cf.prototype, "product", [J.computed], Object.getOwnPropertyDescriptor(cf.prototype, "product"), cf.prototype), Of(cf.prototype, "productApplication", [J.computed], Object.getOwnPropertyDescriptor(cf.prototype, "productApplication"), cf.prototype), Of(cf.prototype, "rateUnitChoices", [J.computed], Object.getOwnPropertyDescriptor(cf.prototype, "rateUnitChoices"), cf.prototype), Of(cf.prototype, "clearProduct", [J.action], Object.getOwnPropertyDescriptor(cf.prototype, "clearProduct"), cf.prototype), Of(cf.prototype, "onChangeTarget", [J.action], Object.getOwnPropertyDescriptor(cf.prototype, "onChangeTarget"), cf.prototype), Of(cf.prototype, "onDragOver", [J.action], Object.getOwnPropertyDescriptor(cf.prototype, "onDragOver"), cf.prototype), Of(cf.prototype, "onDragExit", [J.action], Object.getOwnPropertyDescriptor(cf.prototype, "onDragExit"), cf.prototype), Of(cf.prototype, "onDrop", [J.action], Object.getOwnPropertyDescriptor(cf.prototype, "onDrop"), cf.prototype), Of(cf.prototype, "onEdit", [J.action], Object.getOwnPropertyDescriptor(cf.prototype, "onEdit"), cf.prototype), Of(cf.prototype, "onRemove", [J.action], Object.getOwnPropertyDescriptor(cf.prototype, "onRemove"), cf.prototype), Of(cf.prototype, "onSelectProduct", [J.action], Object.getOwnPropertyDescriptor(cf.prototype, "onSelectProduct"), cf.prototype), Of(cf.prototype, "onUpdateRateUnit", [J.action], Object.getOwnPropertyDescriptor(cf.prototype, "onUpdateRateUnit"), cf.prototype), Of(cf.prototype, "onUpdateRateValue", [J.action], Object.getOwnPropertyDescriptor(cf.prototype, "onUpdateRateValue"), cf.prototype), cf);

    function jf(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function _f(e, t) {
      return (_f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function kf(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Sf(e);

        if (t) {
          var o = Sf(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Ef(this, r);
      };
    }

    function Ef(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Sf(e) {
      return (Sf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Rf,
        xf = Object(a.observer)(wf = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && _f(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = kf(a);

      function a(e) {
        var t;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, a);
        var r = (t = o.call(this, e)).props,
            n = r.productApplication,
            i = r.model;
        return t.rowModel = new Pf({
          productApplication: n,
          errorMessagesModel: i.errorMessagesModel,
          onDropRow: i.onDropRow,
          onEdit: i.onEdit,
          onRemove: i.onRemove
        }), t;
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e,
              t = this.props,
              r = t.productApplication,
              n = t.model;
          return n.isEditing && r.id === (null === (e = n.currentProductApplication) || void 0 === e ? void 0 : e.id) ? i.a.createElement(os, {
            model: n,
            rowModel: this.rowModel,
            isDraggable: !n.moveIsPending
          }) : i.a.createElement(lf, {
            model: n,
            rowModel: this.rowModel
          });
        }
      }]) && jf(t.prototype, r), n && jf(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || wf;

    function Cf(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Tf(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Nf(e, t) {
      return (Nf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Df(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Af(e);

        if (t) {
          var o = Af(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Mf(this, r);
      };
    }

    function Mf(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Af(e) {
      return (Af = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var zf,
        Bf = Object(a.observer)(Rf = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Nf(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Df(a);

      function a() {
        return Cf(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.model;
          return i.a.createElement(i.a.Fragment, null, e.productApplications.map(function (t) {
            return i.a.createElement(xf, {
              key: t.id,
              productApplication: t,
              model: e
            });
          }));
        }
      }]) && Tf(t.prototype, r), n && Tf(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Rf;

    function Lf(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Ff(e, t) {
      return (Ff = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Uf(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = qf(e);

        if (t) {
          var o = qf(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return If(this, r);
      };
    }

    function If(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function qf(e) {
      return (qf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Vf,
        Wf = Object(a.observer)(zf = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Ff(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Uf(a);

      function a(e) {
        var t;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, a);
        var r = (t = o.call(this, e)).props.model;
        return t.rowModel = new Pf({
          productApplication: r.currentProductApplication,
          errorMessagesModel: r.errorMessagesModel,
          onDropRow: r.onDropRow,
          onEdit: r.onEdit,
          onRemove: r.onRemove
        }), t;
      }

      return t = a, (r = [{
        key: "componentDidMount",
        value: function () {
          var e = this;
          this.disposeProductApplicationReaction = Object(J.reaction)(function () {
            return e.props.model.currentProductApplication;
          }, function (t) {
            return e.rowModel.update({
              productApplication: t
            });
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.disposeProductApplicationReaction();
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.model;
          return i.a.createElement(os, {
            model: e,
            rowModel: this.rowModel,
            className: "new-product-application-row",
            isDraggable: !1
          });
        }
      }]) && Lf(t.prototype, r), n && Lf(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || zf;

    function Kf(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Jf(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Hf(e, t) {
      return (Hf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function $f(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Gf(e);

        if (t) {
          var o = Gf(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Qf(this, r);
      };
    }

    function Qf(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Gf(e) {
      return (Gf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Yf,
        Xf = Object(a.observer)(Vf = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Hf(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = $f(a);

      function a() {
        return Kf(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.model;
          return e.showNewRowEditor ? i.a.createElement(Wf, {
            model: e
          }) : null;
        }
      }]) && Jf(t.prototype, r), n && Jf(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Vf;

    function Zf(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function ep(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function tp(e, t) {
      return (tp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function rp(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = op(e);

        if (t) {
          var o = op(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return np(this, r);
      };
    }

    function np(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function op(e) {
      return (op = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var ip,
        ap = Object(a.observer)(Yf = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && tp(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = rp(a);

      function a() {
        return Zf(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e,
              t,
              r = this.props,
              n = r.model,
              o = r.t;
          return i.a.createElement("tr", {
            "data-testid": "product-applications-table-footer-row"
          }, i.a.createElement("td", {
            colSpan: "4",
            className: "text-right font-weight-bold text-uppercase"
          }, o("if2.work_orders.max"), ":"), i.a.createElement("td", {
            className: "text-nowrap"
          }, null === (e = n.maxPhi) || void 0 === e ? void 0 : e.displayValue), i.a.createElement("td", {
            className: "text-nowrap"
          }, null === (t = n.maxRei) || void 0 === t ? void 0 : t.displayValue), i.a.createElement("td", null));
        }
      }]) && ep(t.prototype, r), n && ep(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Yf,
        cp = V()(ap);

    function up(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function lp(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function sp(e, t) {
      return (sp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function fp(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = dp(e);

        if (t) {
          var o = dp(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return pp(this, r);
      };
    }

    function pp(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function dp(e) {
      return (dp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var yp,
        bp = Object(a.observer)(ip = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && sp(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = fp(a);

      function a() {
        return up(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.model;
          return i.a.createElement("tbody", {
            "data-testid": "products-table-body"
          }, i.a.createElement(Bf, {
            model: e
          }), i.a.createElement(Xf, {
            model: e
          }), i.a.createElement(cp, {
            model: e
          }));
        }
      }]) && lp(t.prototype, r), n && lp(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || ip;

    function hp(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function vp(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function mp(e, t) {
      return (mp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function gp(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = wp(e);

        if (t) {
          var o = wp(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Op(this, r);
      };
    }

    function Op(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function wp(e) {
      return (wp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Pp,
        jp = Object(a.observer)(yp = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && mp(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = gp(a);

      function a() {
        return hp(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.model;
          return i.a.createElement("table", {
            className: "table table-striped table-sm",
            "data-testid": "products-table"
          }, i.a.createElement(tl, null), i.a.createElement(bp, {
            model: e
          }));
        }
      }]) && vp(t.prototype, r), n && vp(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || yp;

    function _p(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function kp(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Ep(e, t) {
      return (Ep = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Sp(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = xp(e);

        if (t) {
          var o = xp(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Rp(this, r);
      };
    }

    function Rp(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function xp(e) {
      return (xp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Cp,
        Tp = Object(a.observer)(Pp = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Ep(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Sp(a);

      function a() {
        return _p(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e,
              t = this.props,
              r = t.model,
              n = t.t;
          return null !== (e = r.productApplications) && void 0 !== e && e.length ? null : i.a.createElement("p", {
            className: "unspecified"
          }, n("if2.work_orders.work_orders.products_editor.no_products_have_been_added"));
        }
      }]) && kp(t.prototype, r), n && kp(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Pp,
        Np = V()(Tp);

    function Dp(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Mp(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Ap(e, t) {
      return (Ap = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function zp(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Lp(e);

        if (t) {
          var o = Lp(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Bp(this, r);
      };
    }

    function Bp(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Lp(e) {
      return (Lp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Fp,
        Up = Object(a.observer)(Cp = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Ap(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = zp(a);

      function a() {
        return Dp(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.model;
          return i.a.createElement("div", {
            className: "product-applications-editor",
            "data-testid": "product-applications-editor"
          }, i.a.createElement(Np, {
            model: e
          }), i.a.createElement(jp, {
            model: e
          }), i.a.createElement(Ku, {
            model: e
          }));
        }
      }]) && Mp(t.prototype, r), n && Mp(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Cp;

    function Ip(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function qp(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Vp(e, t) {
      return (Vp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Wp(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Jp(e);

        if (t) {
          var o = Jp(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Kp(this, r);
      };
    }

    function Kp(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Jp(e) {
      return (Jp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Hp,
        $p = Object(a.observer)(Fp = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Vp(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Wp(a);

      function a() {
        return Ip(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.model;
          return i.a.createElement(Q.Card, {
            className: "products-card"
          }, i.a.createElement(Q.CardHeader, {
            isOpen: e.cardModel.isOpen,
            title: e.cardModel.title,
            onOpen: e.onOpenCard,
            onClose: e.onCloseCard,
            hasToggle: e.cardModel.hasToggle
          }), i.a.createElement(Q.CardBody, {
            isOpen: e.cardModel.isOpen
          }, i.a.createElement(Up, {
            model: e
          })));
        }
      }]) && qp(t.prototype, r), n && qp(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Fp;

    function Qp(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Gp(e, t) {
      return (Gp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Yp(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Zp(e);

        if (t) {
          var o = Zp(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Xp(this, r);
      };
    }

    function Xp(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Zp(e) {
      return (Zp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var ed,
        td = Object(a.observer)(Hp = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Gp(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Yp(a);

      function a(e) {
        var t;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, a);
        var r = (t = o.call(this, e)).props,
            n = r.showEditControls,
            i = r.products,
            c = r.nameOfUser,
            u = r.apiProductApplicationPathPattern,
            l = r.apiProductApplicationsPositionsPathPattern,
            s = r.workOrderPathPattern,
            f = r.apiWorkOrderProductApplicationsPathPattern,
            p = r.t;
        return t.model = new Bu({
          workOrder: window.workOrder,
          products: i,
          nameOfUser: c,
          apiProductApplicationPathPattern: u,
          apiProductApplicationsPositionsPathPattern: l,
          workOrderPathPattern: s,
          apiWorkOrderProductApplicationsPathPattern: f,
          showEditControls: n,
          cardTitle: p("if2.work_orders.products_to_apply")
        }), t;
      }

      return t = a, (r = [{
        key: "componentWillUnmount",
        value: function () {
          this.model.dispose();
        }
      }, {
        key: "render",
        value: function () {
          return i.a.createElement("div", {
            className: "work-orders-products"
          }, i.a.createElement($p, {
            model: this.model
          }));
        }
      }]) && Qp(t.prototype, r), n && Qp(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Hp,
        rd = V()(td);

    function nd(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function od(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function id(e, t) {
      return (id = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function ad(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = ud(e);

        if (t) {
          var o = ud(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return cd(this, r);
      };
    }

    function cd(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function ud(e) {
      return (ud = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var ld,
        sd,
        fd,
        pd = Object(a.observer)(ed = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && id(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = ad(a);

      function a() {
        return nd(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.t,
              r = e.model;
          return i.a.createElement("thead", {
            className: "wo-table-head"
          }, i.a.createElement("tr", null, r.includeCheckboxes ? i.a.createElement("th", {
            className: "align-middle",
            "aria-label": "Select All",
            scope: "col"
          }, i.a.createElement(Qc.CheckAllDropdown, {
            isChecked: r.queryService.currentPageChecked,
            someChecked: r.someChecked,
            onUncheckAll: r.onUncheckAll,
            onUncheckPage: r.onUncheckPage,
            onSelectAll: r.onSelectAll,
            onSelectPage: r.onSelectPage
          })) : null, i.a.createElement("th", {
            scope: "col"
          }, t("if2.work_orders.name"), i.a.createElement("br", null), t("if2.work_orders.date")), i.a.createElement("th", {
            scope: "col"
          }, t("if2.work_orders.ordered_by")), i.a.createElement("th", {
            scope: "col"
          }, t("if2.work_orders.account")), i.a.createElement("th", {
            scope: "col"
          }, t("if2.work_orders.crop")), i.a.createElement("th", {
            scope: "col"
          }, t("if2.work_orders.status")), i.a.createElement("th", {
            scope: "col"
          }, t("if2.work_orders.recommendation")), i.a.createElement("th", {
            "aria-label": "Actions",
            scope: "col",
            className: "actions"
          })));
        }
      }]) && od(t.prototype, r), n && od(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || ed,
        dd = V()(pd);

    function yd(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function bd(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function hd(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function vd(e, t) {
      return (vd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function md(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = wd(e);

        if (t) {
          var o = wd(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return gd(this, r);
      };
    }

    function gd(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return Od(e);
    }

    function Od(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function wd(e) {
      return (wd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Pd,
        jd = Object(a.observer)((sd = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && vd(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = md(a);

      function a() {
        var e;
        bd(this, a);

        for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];

        return yd(e = o.call.apply(o, [this].concat(r)), "stopPropagation", fd, Od(e)), e;
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.workOrder,
              r = e.dashboardModel;
          return i.a.createElement("td", {
            className: "text-nowrap"
          }, i.a.createElement("a", {
            href: r.workOrderPath(t),
            onClick: this.stopPropagation
          }, t.name), i.a.createElement("br", null), i.a.createElement("a", {
            className: "unobtrusive",
            href: r.workOrderPath(t),
            onClick: this.stopPropagation
          }, t.startDate));
        }
      }]) && hd(t.prototype, r), n && hd(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component), fd = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }(sd.prototype, "stopPropagation", [J.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return function (e) {
          return e.stopPropagation();
        };
      }
    }), ld = sd)) || ld;

    function _d(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function kd(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Ed(e, t) {
      return (Ed = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Sd(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = xd(e);

        if (t) {
          var o = xd(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Rd(this, r);
      };
    }

    function Rd(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function xd(e) {
      return (xd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Cd,
        Td = Object(a.observer)(Pd = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Ed(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Sd(a);

      function a() {
        return _d(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.workOrder;
          return i.a.createElement("td", null, e.orderedBy.name);
        }
      }]) && kd(t.prototype, r), n && kd(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Pd;

    function Nd(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Dd(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Md(e, t) {
      return (Md = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Ad(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Bd(e);

        if (t) {
          var o = Bd(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return zd(this, r);
      };
    }

    function zd(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Bd(e) {
      return (Bd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Ld,
        Fd = Object(a.observer)(Cd = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Md(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Ad(a);

      function a() {
        return Nd(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.workOrder;
          return i.a.createElement("td", null, e.account.clientPathString);
        }
      }]) && Dd(t.prototype, r), n && Dd(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Cd;

    function Ud(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Id(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function qd(e, t) {
      return (qd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Vd(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Kd(e);

        if (t) {
          var o = Kd(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Wd(this, r);
      };
    }

    function Wd(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Kd(e) {
      return (Kd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Jd,
        Hd = Object(a.observer)(Ld = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && qd(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Vd(a);

      function a() {
        return Ud(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.workOrder;
          return i.a.createElement("td", null, e.cropNames.join(", "));
        }
      }]) && Id(t.prototype, r), n && Id(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Ld;

    function $d(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Qd(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Gd(e, t) {
      return (Gd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Yd(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Zd(e);

        if (t) {
          var o = Zd(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Xd(this, r);
      };
    }

    function Xd(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Zd(e) {
      return (Zd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var ey,
        ty,
        ry,
        ny = Object(a.observer)(Jd = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Gd(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Yd(a);

      function a() {
        return $d(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.workOrder;
          return i.a.createElement("td", null, e.status);
        }
      }]) && Qd(t.prototype, r), n && Qd(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Jd;

    function oy(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function iy(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function ay(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function cy(e, t) {
      return (cy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function uy(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = fy(e);

        if (t) {
          var o = fy(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return ly(this, r);
      };
    }

    function ly(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return sy(e);
    }

    function sy(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function fy(e) {
      return (fy = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var py,
        dy,
        yy,
        by,
        hy,
        vy = Object(a.observer)((ty = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && cy(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = uy(a);

      function a() {
        var e;
        iy(this, a);

        for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];

        return oy(e = o.call.apply(o, [this].concat(r)), "stopPropagation", ry, sy(e)), e;
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e,
              t = this.props,
              r = t.workOrder,
              n = t.dashboardModel;
          return i.a.createElement("td", {
            className: "text-nowrap"
          }, i.a.createElement("a", {
            href: n.recommendationPath(r),
            onClick: this.stopPropagation
          }, (null === (e = r.recommendation) || void 0 === e ? void 0 : e.documentNumber) || ""));
        }
      }]) && ay(t.prototype, r), n && ay(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component), ry = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }(ty.prototype, "stopPropagation", [J.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return function (e) {
          return e.stopPropagation();
        };
      }
    }), ey = ty)) || ey;

    function my(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function gy(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Oy(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function wy(e, t) {
      return (wy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Py(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = ky(e);

        if (t) {
          var o = ky(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return jy(this, r);
      };
    }

    function jy(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return _y(e);
    }

    function _y(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function ky(e) {
      return (ky = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Ey(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var Sy,
        Ry = Object(a.observer)((dy = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && wy(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Py(a);

      function a() {
        var e;
        gy(this, a);

        for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];

        return my(e = o.call.apply(o, [this].concat(r)), "isExpanded", yy, _y(e)), my(e, "toggleExpanded", by, _y(e)), my(e, "onToggleChecked", hy, _y(e)), e;
      }

      return t = a, (r = [{
        key: "classNamesTop",
        get: function () {
          var e = this.props.isLight;
          return ["wo-row"].concat(e ? [] : "dark").join(" ");
        }
      }, {
        key: "classNamesBottom",
        get: function () {
          var e = this.props.isLight;
          return ["wo-row bottom"].concat(e ? [] : "dark");
        }
      }, {
        key: "isChecked",
        get: function () {
          var e = this.props,
              t = e.dashboardModel,
              r = e.workOrder;
          return t.isChecked(r.serial);
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.workOrder,
              r = e.dashboardModel;
          return i.a.createElement(i.a.Fragment, null, i.a.createElement("tr", {
            id: t.id,
            "aria-label": "Work Order Row",
            className: this.classNamesTop,
            onClick: this.toggleExpanded
          }, r.includeCheckboxes ? i.a.createElement("td", {
            className: "px-3 align-middle"
          }, i.a.createElement(Q.Checkbox, {
            onChange: this.onToggleChecked,
            isChecked: this.isChecked
          })) : null, i.a.createElement(jd, {
            workOrder: t,
            dashboardModel: r
          }), i.a.createElement(Td, {
            workOrder: t
          }), i.a.createElement(Fd, {
            workOrder: t
          }), i.a.createElement(Hd, {
            workOrder: t
          }), i.a.createElement(ny, {
            workOrder: t
          }), i.a.createElement(vy, {
            workOrder: t,
            dashboardModel: r
          }), i.a.createElement("td", {
            className: "actions"
          })), this.isExpanded ? i.a.createElement("tr", {
            className: this.classNamesBottom,
            height: "100%",
            onClick: this.toggleExpanded
          }, i.a.createElement("td", null)) : null, i.a.createElement("tr", null));
        }
      }]) && Oy(t.prototype, r), n && Oy(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component), yy = Ey(dy.prototype, "isExpanded", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Ey(dy.prototype, "classNamesTop", [J.computed], Object.getOwnPropertyDescriptor(dy.prototype, "classNamesTop"), dy.prototype), Ey(dy.prototype, "classNamesBottom", [J.computed], Object.getOwnPropertyDescriptor(dy.prototype, "classNamesBottom"), dy.prototype), Ey(dy.prototype, "isChecked", [J.computed], Object.getOwnPropertyDescriptor(dy.prototype, "isChecked"), dy.prototype), by = Ey(dy.prototype, "toggleExpanded", [J.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isExpanded = !e.isExpanded;
        };
      }
    }), hy = Ey(dy.prototype, "onToggleChecked", [J.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.dashboardModel,
              n = t.workOrder;
          r.toggleChecked(n.serial);
        };
      }
    }), py = dy)) || py;

    function xy(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Cy(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Ty(e, t) {
      return (Ty = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Ny(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = My(e);

        if (t) {
          var o = My(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Dy(this, r);
      };
    }

    function Dy(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function My(e) {
      return (My = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Ay,
        zy = Object(a.observer)(Sy = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Ty(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Ny(a);

      function a() {
        return xy(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.model;
          return i.a.createElement("tbody", {
            className: "wo-table-body"
          }, e.workOrders.map(function (t, r) {
            return i.a.createElement(Ry, {
              key: t.id,
              isLight: r % 2 == 0,
              workOrder: t,
              dashboardModel: e
            });
          }));
        }
      }]) && Cy(t.prototype, r), n && Cy(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Sy;

    function By(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Ly(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Fy(e, t) {
      return (Fy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Uy(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = qy(e);

        if (t) {
          var o = qy(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Iy(this, r);
      };
    }

    function Iy(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function qy(e) {
      return (qy = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Vy,
        Wy = Object(a.observer)(Ay = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Fy(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Uy(a);

      function a() {
        return By(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.model;
          return i.a.createElement("table", {
            className: "table table-sm table-manually-striped wo-table"
          }, i.a.createElement(dd, {
            model: e
          }), i.a.createElement(zy, {
            model: e
          }));
        }
      }]) && Ly(t.prototype, r), n && Ly(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Ay;

    function Ky(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Jy(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Hy(e, t) {
      return (Hy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function $y(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Gy(e);

        if (t) {
          var o = Gy(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Qy(this, r);
      };
    }

    function Qy(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Gy(e) {
      return (Gy = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Yy,
        Xy,
        Zy,
        eb,
        tb,
        rb = Object(a.observer)(Vy = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Hy(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = $y(a);

      function a() {
        return Ky(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.model;
          return i.a.createElement("div", {
            className: "work-orders-list",
            "aria-label": "Work Orders List"
          }, e.queryService.queryIsPending ? i.a.createElement("div", {
            className: "query-spinner"
          }, i.a.createElement(Q.Spinner, null)) : null, i.a.createElement(Wy, {
            model: e
          }));
        }
      }]) && Jy(t.prototype, r), n && Jy(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Vy,
        nb = r(24),
        ob = r.n(nb);

    function ib(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function ab(e, t, r) {
      return (t = lb(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function cb(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function ub(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, lb(n.key), n);
      }
    }

    function lb(e) {
      var t = function (e, t) {
        if ("object" != typeof e || null === e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : String(t);
    }

    function sb(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var fb,
        pb,
        db,
        yb,
        bb,
        hb,
        vb,
        mb,
        gb,
        Ob = (Xy = sb((Yy = function () {
      function e(t) {
        if (function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), cb(this, "limit", Xy, this), cb(this, "offset", Zy, this), cb(this, "pendingRequests", eb, this), cb(this, "totalResults", tb, this), this.api = (t || {}).api, !this.api) throw new Error("No api provided to FTSQueryService");
      }

      var t, r, n;
      return t = e, (r = [{
        key: "currentPage",
        get: function () {
          var e = this;
          return this.pages.find(function (t) {
            return t.number === e.currentPageNumber;
          });
        }
      }, {
        key: "currentPageChecked",
        get: function () {
          return this.currentPage && this.currentPage.isChecked;
        }
      }, {
        key: "currentPageNumber",
        get: function () {
          return this.limit ? Math.floor(this.offset / this.limit) + 1 : 1;
        }
      }, {
        key: "numPages",
        get: function () {
          return this.totalResults <= 1 || !this.limit ? 1 : Math.ceil(this.totalResults / this.limit);
        }
      }, {
        key: "pages",
        get: function () {
          return Object(H.range)(1, this.numPages + 1).map(function (e) {
            return new Qc.ResultsPage({
              number: e
            });
          });
        }
      }, {
        key: "queryIsPending",
        get: function () {
          return this.pendingRequests > 0;
        }
      }, {
        key: "query",
        value: function (e) {
          var t = this;
          return this.pendingRequests += 1, this.api.query(function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = null != arguments[t] ? arguments[t] : {};
              t % 2 ? ib(Object(r), !0).forEach(function (t) {
                ab(e, t, r[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ib(Object(r)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
              });
            }

            return e;
          }({
            limit: this.limit,
            offset: this.offset
          }, e || {})).then(function (e) {
            return Object(J.runInAction)(function () {
              t.offset = e.offset, t.totalResults = e.totalResults;
            }), e;
          }).finally(function () {
            return Object(J.runInAction)(function () {
              t.pendingRequests -= 1, t.pendingRequests <= 0 && (t.pendingRequests = 0);
            });
          });
        }
      }]) && ub(t.prototype, r), n && ub(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), e;
    }()).prototype, "limit", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 20;
      }
    }), Zy = sb(Yy.prototype, "offset", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), eb = sb(Yy.prototype, "pendingRequests", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), tb = sb(Yy.prototype, "totalResults", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), sb(Yy.prototype, "currentPage", [J.computed], Object.getOwnPropertyDescriptor(Yy.prototype, "currentPage"), Yy.prototype), sb(Yy.prototype, "currentPageChecked", [J.computed], Object.getOwnPropertyDescriptor(Yy.prototype, "currentPageChecked"), Yy.prototype), sb(Yy.prototype, "currentPageNumber", [J.computed], Object.getOwnPropertyDescriptor(Yy.prototype, "currentPageNumber"), Yy.prototype), sb(Yy.prototype, "numPages", [J.computed], Object.getOwnPropertyDescriptor(Yy.prototype, "numPages"), Yy.prototype), sb(Yy.prototype, "pages", [J.computed], Object.getOwnPropertyDescriptor(Yy.prototype, "pages"), Yy.prototype), sb(Yy.prototype, "queryIsPending", [J.computed], Object.getOwnPropertyDescriptor(Yy.prototype, "queryIsPending"), Yy.prototype), sb(Yy.prototype, "query", [J.action], Object.getOwnPropertyDescriptor(Yy.prototype, "query"), Yy.prototype), Yy);

    function wb() {
      /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
      wb = function () {
        return e;
      };

      var e = {},
          t = Object.prototype,
          r = t.hasOwnProperty,
          n = Object.defineProperty || function (e, t, r) {
        e[t] = r.value;
      },
          o = "function" == typeof Symbol ? Symbol : {},
          i = o.iterator || "@@iterator",
          a = o.asyncIterator || "@@asyncIterator",
          c = o.toStringTag || "@@toStringTag";

      function u(e, t, r) {
        return Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }

      try {
        u({}, "");
      } catch (e) {
        u = function (e, t, r) {
          return e[t] = r;
        };
      }

      function l(e, t, r, o) {
        var i = t && t.prototype instanceof p ? t : p,
            a = Object.create(i.prototype),
            c = new k(o || []);
        return n(a, "_invoke", {
          value: w(e, r, c)
        }), a;
      }

      function s(e, t, r) {
        try {
          return {
            type: "normal",
            arg: e.call(t, r)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }

      e.wrap = l;
      var f = {};

      function p() {}

      function d() {}

      function y() {}

      var b = {};
      u(b, i, function () {
        return this;
      });
      var h = Object.getPrototypeOf,
          v = h && h(h(E([])));
      v && v !== t && r.call(v, i) && (b = v);
      var m = y.prototype = p.prototype = Object.create(b);

      function g(e) {
        ["next", "throw", "return"].forEach(function (t) {
          u(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }

      function O(e, t) {
        var o;
        n(this, "_invoke", {
          value: function (n, i) {
            function a() {
              return new t(function (o, a) {
                !function n(o, i, a, c) {
                  var u = s(e[o], e, i);

                  if ("throw" !== u.type) {
                    var l = u.arg,
                        f = l.value;
                    return f && "object" == typeof f && r.call(f, "__await") ? t.resolve(f.__await).then(function (e) {
                      n("next", e, a, c);
                    }, function (e) {
                      n("throw", e, a, c);
                    }) : t.resolve(f).then(function (e) {
                      l.value = e, a(l);
                    }, function (e) {
                      return n("throw", e, a, c);
                    });
                  }

                  c(u.arg);
                }(n, i, o, a);
              });
            }

            return o = o ? o.then(a, a) : a();
          }
        });
      }

      function w(e, t, r) {
        var n = "suspendedStart";
        return function (o, i) {
          if ("executing" === n) throw new Error("Generator is already running");

          if ("completed" === n) {
            if ("throw" === o) throw i;
            return S();
          }

          for (r.method = o, r.arg = i;;) {
            var a = r.delegate;

            if (a) {
              var c = P(a, r);

              if (c) {
                if (c === f) continue;
                return c;
              }
            }

            if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
              if ("suspendedStart" === n) throw n = "completed", r.arg;
              r.dispatchException(r.arg);
            } else "return" === r.method && r.abrupt("return", r.arg);
            n = "executing";
            var u = s(e, t, r);

            if ("normal" === u.type) {
              if (n = r.done ? "completed" : "suspendedYield", u.arg === f) continue;
              return {
                value: u.arg,
                done: r.done
              };
            }

            "throw" === u.type && (n = "completed", r.method = "throw", r.arg = u.arg);
          }
        };
      }

      function P(e, t) {
        var r = t.method,
            n = e.iterator[r];
        if (void 0 === n) return t.delegate = null, "throw" === r && e.iterator.return && (t.method = "return", t.arg = void 0, P(e, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), f;
        var o = s(n, e.iterator, t.arg);
        if ("throw" === o.type) return t.method = "throw", t.arg = o.arg, t.delegate = null, f;
        var i = o.arg;
        return i ? i.done ? (t[e.resultName] = i.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, f) : i : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, f);
      }

      function j(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function _(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function k(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(j, this), this.reset(!0);
      }

      function E(e) {
        if (e) {
          var t = e[i];
          if (t) return t.call(e);
          if ("function" == typeof e.next) return e;

          if (!isNaN(e.length)) {
            var n = -1,
                o = function t() {
              for (; ++n < e.length;) if (r.call(e, n)) return t.value = e[n], t.done = !1, t;

              return t.value = void 0, t.done = !0, t;
            };

            return o.next = o;
          }
        }

        return {
          next: S
        };
      }

      function S() {
        return {
          value: void 0,
          done: !0
        };
      }

      return d.prototype = y, n(m, "constructor", {
        value: y,
        configurable: !0
      }), n(y, "constructor", {
        value: d,
        configurable: !0
      }), d.displayName = u(y, c, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === d || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, y) : (e.__proto__ = y, u(e, c, "GeneratorFunction")), e.prototype = Object.create(m), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, g(O.prototype), u(O.prototype, a, function () {
        return this;
      }), e.AsyncIterator = O, e.async = function (t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new O(l(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, g(m), u(m, c, "Generator"), u(m, i, function () {
        return this;
      }), u(m, "toString", function () {
        return "[object Generator]";
      }), e.keys = function (e) {
        var t = Object(e),
            r = [];

        for (var n in t) r.push(n);

        return r.reverse(), function e() {
          for (; r.length;) {
            var n = r.pop();
            if (n in t) return e.value = n, e.done = !1, e;
          }

          return e.done = !0, e;
        };
      }, e.values = E, k.prototype = {
        constructor: k,
        reset: function (e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(_), !e) for (var t in this) "t" === t.charAt(0) && r.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
        },
        stop: function () {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function (e) {
          if (this.done) throw e;
          var t = this;

          function n(r, n) {
            return a.type = "throw", a.arg = e, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
          }

          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var i = this.tryEntries[o],
                a = i.completion;
            if ("root" === i.tryLoc) return n("end");

            if (i.tryLoc <= this.prev) {
              var c = r.call(i, "catchLoc"),
                  u = r.call(i, "finallyLoc");

              if (c && u) {
                if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                if (this.prev < i.finallyLoc) return n(i.finallyLoc);
              } else if (c) {
                if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
              } else {
                if (!u) throw new Error("try statement without catch or finally");
                if (this.prev < i.finallyLoc) return n(i.finallyLoc);
              }
            }
          }
        },
        abrupt: function (e, t) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var o = this.tryEntries[n];

            if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }

          i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, f) : this.complete(a);
        },
        complete: function (e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), f;
        },
        finish: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), _(r), f;
          }
        },
        catch: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];

            if (r.tryLoc === e) {
              var n = r.completion;

              if ("throw" === n.type) {
                var o = n.arg;

                _(r);
              }

              return o;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function (e, t, r) {
          return this.delegate = {
            iterator: E(e),
            resultName: t,
            nextLoc: r
          }, "next" === this.method && (this.arg = void 0), f;
        }
      }, e;
    }

    function Pb(e, t, r, n, o, i, a) {
      try {
        var c = e[i](a),
            u = c.value;
      } catch (e) {
        return void r(e);
      }

      c.done ? t(u) : Promise.resolve(u).then(n, o);
    }

    function jb(e) {
      return function () {
        var t = this,
            r = arguments;
        return new Promise(function (n, o) {
          var i = e.apply(t, r);

          function a(e) {
            Pb(i, n, o, a, c, "next", e);
          }

          function c(e) {
            Pb(i, n, o, a, c, "throw", e);
          }

          a(void 0);
        });
      };
    }

    function _b(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function kb(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? _b(Object(r), !0).forEach(function (t) {
          Eb(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : _b(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Eb(e, t, r) {
      return (t = xb(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Sb(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Rb(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, xb(n.key), n);
      }
    }

    function xb(e) {
      var t = function (e, t) {
        if ("object" != typeof e || null === e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : String(t);
    }

    function Cb(e, t) {
      return (Cb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Tb(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Mb(e);

        if (t) {
          var o = Mb(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Nb(this, r);
      };
    }

    function Nb(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return Db(e);
    }

    function Db(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function Mb(e) {
      return (Mb = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Ab(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var zb,
        Bb = ((gb = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Cb(e, t);
      }(i, e);
      var t,
          r,
          n,
          o = Tb(i);

      function i(e) {
        var t;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, i), (t = o.call(this)).searchModel = new Q.SearchBoxModel(), Sb(t, "queryResults", pb, Db(t)), Sb(t, "props", db, Db(t)), Sb(t, "fetchingAllSerials", yb, Db(t)), t.includeCheckboxes = !0, Sb(t, "onUncheckAll", bb, Db(t)), Sb(t, "onUncheckPage", hb, Db(t)), Sb(t, "onSelectAll", vb, Db(t)), Sb(t, "onSelectPage", mb, Db(t)), t.props = e || {}, t.api = t.props.api || new wu(t.props), t.queryService = t.props.queryService || new Ob({
          api: t.api
        }), t.initialize(), t;
      }

      return t = i, (r = [{
        key: "someChecked",
        get: function () {
          return this.checked.length > 0;
        }
      }, {
        key: "workOrders",
        get: function () {
          return Oi()((this.queryResults || []).map(this.constructor.makeWorkOrder), ["startDate", "createdAt", "name"], ["desc", "desc", "asc"]);
        }
      }, {
        key: "accountIds",
        get: function () {
          return this.props.accountIds || [];
        }
      }, {
        key: "filters",
        get: function () {
          return [];
        }
      }, {
        key: "formatError",
        value: function (e) {
          var t;
          return (null === (t = e.formatMessage) || void 0 === t ? void 0 : t.call(e)) || e.message || e;
        }
      }, {
        key: "goToPage",
        value: function (e) {
          return this.queryPage(e);
        }
      }, {
        key: "initBindings",
        value: function () {
          this.goToPage = this.goToPage.bind(this), this.onSearch = this.onSearch.bind(this), this.onClearSearch = this.onClearSearch.bind(this), this.runRawQuery = this.runRawQuery.bind(this);
        }
      }, {
        key: "initialize",
        value: function (e) {
          this.update(e), this.initBindings(), this.runQuery = ob()(this.runRawQuery, 700);
        }
      }, {
        key: "notifyError",
        value: function (e) {
          window.alert(this.formatError(e)), console.error(this.formatError(e));
        }
      }, {
        key: "onClearSearch",
        value: function () {
          this.onSearch({
            target: {
              value: ""
            }
          });
        }
      }, {
        key: "onSearch",
        value: function (e) {
          return this.searchModel.onChangeText(e), this.runQuery();
        }
      }, {
        key: "query",
        value: function (e) {
          var t = this;
          return this.queryService.query(kb({
            accounts: this.accountIds,
            search: this.searchModel.text,
            filters: this.filters
          }, e || {})).then(function (e) {
            return Object(J.runInAction)(function () {
              return t.queryResults = (null == e ? void 0 : e.workOrders) || [];
            });
          }).catch(function (e) {
            return t.notifyError(e);
          });
        }
      }, {
        key: "queryPage",
        value: function (e, t) {
          return this.query(kb(kb({}, t || {}), {}, {
            offset: e * this.queryService.limit - this.queryService.limit
          }));
        }
      }, {
        key: "recommendationPath",
        value: function (e) {
          return this.api.recommendationPath(e);
        }
      }, {
        key: "runRawQuery",
        value: function () {
          return this.query();
        }
      }, {
        key: "update",
        value: function (e) {
          var t = this;
          Object.keys(e || {}).forEach(function (r) {
            t.props[r] = e[r];
          });
        }
      }, {
        key: "workOrderPath",
        value: function (e) {
          return this.api.workOrderPath(e);
        }
      }]) && Rb(t.prototype, r), n && Rb(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(Object(G.Mix)(G.checkableCollectionMixin))).makeWorkOrder = Object(mi.createTransformer)(function (e) {
      return new ii(e);
    }), pb = Ab((fb = gb).prototype, "queryResults", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), db = Ab(fb.prototype, "props", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), yb = Ab(fb.prototype, "fetchingAllSerials", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Ab(fb.prototype, "someChecked", [J.computed], Object.getOwnPropertyDescriptor(fb.prototype, "someChecked"), fb.prototype), Ab(fb.prototype, "workOrders", [J.computed], Object.getOwnPropertyDescriptor(fb.prototype, "workOrders"), fb.prototype), Ab(fb.prototype, "accountIds", [J.computed], Object.getOwnPropertyDescriptor(fb.prototype, "accountIds"), fb.prototype), Ab(fb.prototype, "filters", [J.computed], Object.getOwnPropertyDescriptor(fb.prototype, "filters"), fb.prototype), Ab(fb.prototype, "goToPage", [J.action], Object.getOwnPropertyDescriptor(fb.prototype, "goToPage"), fb.prototype), Ab(fb.prototype, "initialize", [J.action], Object.getOwnPropertyDescriptor(fb.prototype, "initialize"), fb.prototype), bb = Ab(fb.prototype, "onUncheckAll", [J.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.queryService.pages.forEach(function (e) {
            e.isChecked = !1;
          }), e.unCheckAll();
        };
      }
    }), hb = Ab(fb.prototype, "onUncheckPage", [J.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.queryService.currentPage.isChecked = !1, e.unCheckMany(e.workOrders.map(function (e) {
            return e.serial;
          }));
        };
      }
    }), vb = Ab(fb.prototype, "onSelectAll", [J.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return jb(wb().mark(function t() {
          var r, n;
          return wb().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return e.fetchingAllSerials = !0, e.queryService.pages.forEach(function (e) {
                  e.isChecked = !0;
                }), t.prev = 2, t.next = 5, e.api.queryAllSerials({
                  accounts: e.accountIds
                });

              case 5:
                r = t.sent, n = r.serials, e.checkMany(n), t.next = 13;
                break;

              case 10:
                t.prev = 10, t.t0 = t.catch(2), e.notifyError(t.t0);

              case 13:
                return t.prev = 13, e.fetchingAllSerials = !1, t.finish(13);

              case 16:
              case "end":
                return t.stop();
            }
          }, t, null, [[2, 10, 13, 16]]);
        }));
      }
    }), mb = Ab(fb.prototype, "onSelectPage", [J.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.queryService.currentPage.isChecked = !0, e.checkMany(e.workOrders.map(function (e) {
            return e.serial;
          }));
        };
      }
    }), Ab(fb.prototype, "update", [J.action], Object.getOwnPropertyDescriptor(fb.prototype, "update"), fb.prototype), fb),
        Lb = r(25),
        Fb = r.n(Lb),
        Ub = r(26);

    function Ib(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function qb(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Vb(e, t) {
      return (Vb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Wb(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Jb(e);

        if (t) {
          var o = Jb(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Kb(this, r);
      };
    }

    function Kb(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Jb(e) {
      return (Jb = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Hb(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var $b,
        Qb,
        Gb = (Hb((zb = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Vb(e, t);
      }(i, e);
      var t,
          r,
          n,
          o = Wb(i);

      function i() {
        return Ib(this, i), o.apply(this, arguments);
      }

      return t = i, (r = [{
        key: "disableReiButton",
        get: function () {
          return 0 === this.props.dashboardModel.checked.length;
        }
      }, {
        key: "reiPosterButtonClassNames",
        get: function () {
          return ["btn", "btn-outline-work-orders", "mr-1"].concat(this.disableReiButton ? "disable-btn" : []).join(" ");
        }
      }, {
        key: "badgeContent",
        get: function () {
          return this.props.dashboardModel.numFilters || "+";
        }
      }, {
        key: "bulkReiPostersPath",
        get: function () {
          var e = this.props.dashboardModel;
          return this.disableReiButton ? "#" : "".concat(e.api.bulkReiPostersPath(e.checked.join("-")), ".pdf");
        }
      }, {
        key: "checked",
        get: function () {
          return this.props.dashboardModel.checked;
        }
      }, {
        key: "dashboardModel",
        get: function () {
          return this.props.dashboardModel;
        }
      }]) && qb(t.prototype, r), n && qb(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(Z)).prototype, "disableReiButton", [J.computed], Object.getOwnPropertyDescriptor(zb.prototype, "disableReiButton"), zb.prototype), Hb(zb.prototype, "reiPosterButtonClassNames", [J.computed], Object.getOwnPropertyDescriptor(zb.prototype, "reiPosterButtonClassNames"), zb.prototype), Hb(zb.prototype, "badgeContent", [J.computed], Object.getOwnPropertyDescriptor(zb.prototype, "badgeContent"), zb.prototype), Hb(zb.prototype, "bulkReiPostersPath", [J.computed], Object.getOwnPropertyDescriptor(zb.prototype, "bulkReiPostersPath"), zb.prototype), Hb(zb.prototype, "checked", [J.computed], Object.getOwnPropertyDescriptor(zb.prototype, "checked"), zb.prototype), Hb(zb.prototype, "dashboardModel", [J.computed], Object.getOwnPropertyDescriptor(zb.prototype, "dashboardModel"), zb.prototype), zb);

    function Yb(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Xb(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Yb(Object(r), !0).forEach(function (t) {
          Zb(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Yb(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Zb(e, t, r) {
      return (t = th(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function eh(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, th(n.key), n);
      }
    }

    function th(e) {
      var t = function (e, t) {
        if ("object" != typeof e || null === e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : String(t);
    }

    function rh(e, t) {
      return (rh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function nh(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = ih(e);

        if (t) {
          var o = ih(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return oh(this, r);
      };
    }

    function oh(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function ih(e) {
      return (ih = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var ah,
        ch = Object(a.observer)(((Qb = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && rh(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = nh(a);

      function a(e) {
        var t;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, a);
        var r = (t = o.call(this, e)).props.model;
        return t.model = new Gb({
          dashboardModel: r
        }), t;
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.model,
              n = t.bulkActionComponents,
              o = t.t,
              a = t.icon;
          return i.a.createElement("div", {
            className: "row no-gutters align-items-stretch mb-2 "
          }, i.a.createElement("div", {
            className: "col-md-7"
          }, i.a.createElement("div", {
            className: "title-icon-container work-order-title"
          }, i.a.createElement(Ub.ReactSVG, {
            src: a,
            className: "title-icon work-order-color"
          }), i.a.createElement("div", null, i.a.createElement("div", {
            className: "title-type work-order-color"
          }, "work orders"), i.a.createElement("div", {
            className: "button-list"
          }, i.a.createElement("a", {
            role: "button",
            href: this.model.bulkReiPostersPath,
            className: this.model.reiPosterButtonClassNames
          }, o("if2.work_orders.rei_poster")), n.map(function (t) {
            var r = t.name,
                n = function (e) {
              var t = "Unable to load component '".concat(e, "' from ReactRailsUJS");

              try {
                var r = Fb.a.getConstructor(e);
                if (r) return r;
              } catch (e) {
                throw new Error("".concat(t, ": ").concat(e));
              }

              throw new Error(t);
            }(r),
                o = Xb(Xb({}, t.props), {}, {
              key: r,
              selectedIds: e.model.checked
            });

            return i.a.createElement(n, o);
          }), i.a.createElement("a", {
            role: "button",
            href: r.api.newWorkOrderPath,
            className: "btn btn-work-orders mx-1"
          }, o("if2.work_orders.new_work_order")))))), i.a.createElement("div", {
            className: "col-md-1 d-flex justify-content-end pr-2 filter-btn-col"
          }, i.a.createElement("div", {
            className: "d-flex align-content-center wo-control-filter-btn"
          })), i.a.createElement("div", {
            className: "col-md-4 search-col float-right align-with-page-title "
          }, i.a.createElement(Q.SearchBox, {
            placeholder: o("if2.work_orders.work_orders.search_work_orders"),
            onChange: r.onSearch,
            searchText: r.searchModel.text,
            onClearSearch: r.onClearSearch
          })));
        }
      }]) && eh(t.prototype, r), n && eh(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)).defaultProps = {
      bulkActionComponents: []
    }, $b = Qb)) || $b,
        uh = V()(ch);

    function lh(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function sh(e, t) {
      return (sh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function fh(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = dh(e);

        if (t) {
          var o = dh(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return ph(this, r);
      };
    }

    function ph(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function dh(e) {
      return (dh = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var yh,
        bh,
        hh,
        vh = Object(a.observer)(ah = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && sh(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = fh(a);

      function a(e) {
        var t;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, a);
        var r = (t = o.call(this, e)).props,
            n = r.accountIds,
            i = r.workOrders,
            c = r.workOrdersPath,
            u = r.workOrderPathPattern,
            l = r.workOrdersQueryPathPattern,
            s = r.recommendationsPath,
            f = r.recommendationPathPattern,
            p = r.newWorkOrderPath,
            d = r.queryAllSerialsPath,
            y = r.bulkReiPostersPathPattern;
        return t.model = new Bb({
          accountIds: n,
          workOrders: i,
          workOrdersPath: c,
          recommendationsPath: s,
          workOrderPathPattern: u,
          workOrdersQueryPathPattern: l,
          recommendationPathPattern: f,
          newWorkOrderPath: p,
          queryAllSerialsPath: d,
          bulkReiPostersPathPattern: y
        }), t;
      }

      return t = a, (r = [{
        key: "componentDidMount",
        value: function () {
          this.model.runQuery();
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.bulkActionComponents,
              r = e.icon;
          return i.a.createElement("div", {
            className: "work-orders-dashboard"
          }, i.a.createElement(uh, {
            model: this.model,
            icon: r,
            bulkActionComponents: t
          }), i.a.createElement("div", {
            className: "status-feedback"
          }, i.a.createElement("div", {
            className: "checked-status"
          }, this.model.fetchingAllSerials ? i.a.createElement(Q.Spinner, null) : null, i.a.createElement("span", null, this.model.checked.length), " ", i.a.createElement("span", null, 1 === this.model.checked.length ? "Work Order" : "Work Orders"), " ", "Selected")), i.a.createElement(rb, {
            model: this.model
          }), i.a.createElement("div", {
            className: "text-center"
          }, i.a.createElement(Qc.PaginationNav, {
            className: "justify-content-center",
            currentPageNumber: this.model.queryService.currentPageNumber,
            pages: this.model.queryService.pages,
            onGoToPage: this.model.goToPage
          })));
        }
      }]) && lh(t.prototype, r), n && lh(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || ah;

    function mh(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function gh(e, t) {
      return (gh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Oh(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = jh(e);

        if (t) {
          var o = jh(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return wh(this, r);
      };
    }

    function wh(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return Ph(e);
    }

    function Ph(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function jh(e) {
      return (jh = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var _h,
        kh,
        Eh,
        Sh,
        Rh,
        xh,
        Ch,
        Th,
        Nh = Object(a.observer)((bh = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && gh(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Oh(a);

      function a(e) {
        var t;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, a), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(t = o.call(this, e), "unexpectedErrorMessage", hh, Ph(t)), t.handleClickName = function (e) {
          var r = t.props,
              n = r.createSprayRecordApiPath,
              o = r.sprayRecordShowPath,
              i = document.querySelector("[name='csrf-token']").content;
          fetch(n, {
            method: "POST",
            headers: {
              "X-CSRF-Token": i,
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              account_id: e
            })
          }).then(function (e) {
            return e.json();
          }).then(function (e) {
            return window.location.pathname = o.replace(":id", e.sprayRecord.serial);
          }).catch(function (e) {
            console.log(e), t.unexpectedErrorMessage = "An unexpected error occurred when creating the spray record";
          });
        }, t.formRef = i.a.createRef(), t;
      }

      return t = a, (r = [{
        key: "componentDidMount",
        value: function () {
          var e = this.props.treeModel,
              t = "".concat(window.location.pathname, ":expandedAccounts"),
              r = JSON.parse(sessionStorage.getItem(t)) || [];
          e.openAccounts(r), this.disposeLocalStoreCache = Object(J.autorun)(function () {
            sessionStorage.setItem(t, JSON.stringify(e.expanded));
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.disposeLocalStoreCache();
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.handleToggleExpand,
              r = e.treeModel;
          return i.a.createElement(i.a.Fragment, null, this.unexpectedErrorMessage ? i.a.createElement("div", {
            className: "alert alert-danger"
          }, this.unexpectedErrorMessage) : "", i.a.createElement(Qc.AccountTreeNav, {
            items: r.roots,
            model: r,
            ControlsComponent: Qc.AccountNodeControls,
            ContentComponent: Q.TreeNodeContent,
            actions: {
              handleToggleExpand: t,
              handleClickNodeContent: this.handleClickName
            }
          }));
        }
      }]) && mh(t.prototype, r), n && mh(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component), hh = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }(bh.prototype, "unexpectedErrorMessage", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return null;
      }
    }), yh = bh)) || yh,
        Dh = Object(Qc.withAccountNav)(Nh),
        Mh = r(27);

    function Ah(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function zh(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Bh(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var Lh,
        Fh = (kh = Bh((_h = function () {
      function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), Ah(this, "memento", kh, this), Ah(this, "text", Eh, this), Ah(this, "isSaving", Sh, this), Ah(this, "saveMemento", Rh, this), Ah(this, "restoreMemento", xh, this), Ah(this, "onChangeText", Ch, this), Ah(this, "saveText", Th, this), this.id = (null == t ? void 0 : t.id) || Object(Mh.v4)(), this.memento = (null == t ? void 0 : t.memento) || (null == t ? void 0 : t.text) || "", this.text = (null == t ? void 0 : t.text) || "", this.onSave = (null == t ? void 0 : t.onSave) || function () {};
      }

      var t, r, n;
      return t = e, (r = [{
        key: "isDirty",
        get: function () {
          return this.memento === this.text;
        }
      }]) && zh(t.prototype, r), n && zh(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), e;
    }()).prototype, "memento", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Eh = Bh(_h.prototype, "text", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Sh = Bh(_h.prototype, "isSaving", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Bh(_h.prototype, "isDirty", [J.computed], Object.getOwnPropertyDescriptor(_h.prototype, "isDirty"), _h.prototype), Rh = Bh(_h.prototype, "saveMemento", [J.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.memento = e.text;
        };
      }
    }), xh = Bh(_h.prototype, "restoreMemento", [J.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.text = e.memento;
        };
      }
    }), Ch = Bh(_h.prototype, "onChangeText", [J.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.text = t.target.value;
        };
      }
    }), Th = Bh(_h.prototype, "saveText", [J.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isSaving = !0, e.saveMemento();

          try {
            return e.onSave(e.text);
          } finally {
            e.isSaving = !1;
          }
        };
      }
    }), _h);

    function Uh(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Ih(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function qh(e, t) {
      return (qh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Vh(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = Kh(e);

        if (t) {
          var o = Kh(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return Wh(this, r);
      };
    }

    function Wh(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function Kh(e) {
      return (Kh = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Jh,
        Hh,
        $h = Object(a.observer)(Lh = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && qh(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Vh(a);

      function a() {
        return Uh(this, a), o.apply(this, arguments);
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          var e = this.props.viewModel;
          return i.a.createElement("div", {
            className: "notes-footer"
          }, i.a.createElement("button", {
            disabled: e.isDirty || e.isSaving,
            type: "button",
            className: "btn btn-secondary",
            onClick: e.restoreMemento
          }, "Discard"), i.a.createElement("button", {
            disabled: e.isDirty || e.isSaving,
            type: "button",
            className: "btn btn-primary",
            onClick: e.saveText
          }, e.isSaving ? i.a.createElement(Q.Spinner, {
            textClassNames: "text-white"
          }) : "Save"));
        }
      }]) && Ih(t.prototype, r), n && Ih(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || Lh,
        Qh = ["viewModel"];

    function Gh(e, t) {
      if (null == e) return {};

      var r,
          n,
          o = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            o = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);

        return o;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
      }

      return o;
    }

    function Yh(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function Xh(e, t) {
      return (Xh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Zh(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = tv(e);

        if (t) {
          var o = tv(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return ev(this, r);
      };
    }

    function ev(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function tv(e) {
      return (tv = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var rv = Object(a.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null);
    }((Hh = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Xh(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Zh(a);

      function a(e) {
        var t;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, a);
        var r = (t = o.call(this, e)).props.text;
        return t.defaultViewModel = new Fh({
          text: r
        }), t;
      }

      return t = a, n = [{
        key: "createViewModel",
        value: function (e) {
          return new Fh(e);
        }
      }], (r = [{
        key: "viewModel",
        get: function () {
          return this.props.viewModel || this.defaultViewModel;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = (e.viewModel, Gh(e, Qh));
          return i.a.createElement(i.a.Fragment, null, i.a.createElement("textarea", Object.assign({}, t, {
            id: this.viewModel.id,
            className: "form-control",
            onChange: this.viewModel.onChangeText,
            value: this.viewModel.text
          })), i.a.createElement($h, {
            viewModel: this.viewModel
          }));
        }
      }]) && Yh(t.prototype, r), n && Yh(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)).prototype, "viewModel", [J.computed], Object.getOwnPropertyDescriptor(Hh.prototype, "viewModel"), Hh.prototype), Jh = Hh)) || Jh;

    function nv(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function ov(e, t, r) {
      return t && nv(e.prototype, t), r && nv(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }

    var iv,
        av = ov(function e(t) {
      var r = this;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.onSave = function (e) {
        return r.workOrdersApi.patch({
          notes: e
        });
      }, this.workOrdersApi = new wu({
        patchPath: null == t ? void 0 : t.path
      }), this.textAreaViewModel = rv.createViewModel({
        text: (null == t ? void 0 : t.text) || "",
        onSave: this.onSave
      }), this.cardModel = new Q.CardModel({
        title: (null == t ? void 0 : t.title) || ""
      }), this.onOpen = this.cardModel.open.bind(this.cardModel), this.onClose = this.cardModel.close.bind(this.cardModel);
    });

    function cv(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function uv(e, t) {
      return (uv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function lv(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = fv(e);

        if (t) {
          var o = fv(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return sv(this, r);
      };
    }

    function sv(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function fv(e) {
      return (fv = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var pv,
        dv,
        yv,
        bv,
        hv,
        vv,
        mv = Object(a.observer)(iv = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && uv(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = lv(a);

      function a(e) {
        var t;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, a), (t = o.call(this, e)).viewModel = new av(t.props), t;
      }

      return t = a, (r = [{
        key: "render",
        value: function () {
          return i.a.createElement(Q.Card, null, i.a.createElement(Q.CardHeader, {
            title: this.viewModel.cardModel.title,
            isOpen: this.viewModel.cardModel.isOpen,
            onOpen: this.viewModel.onOpen,
            onClose: this.viewModel.onClose,
            hasToggle: this.viewModel.cardModel.hasToggle
          }), i.a.createElement(Q.CardBody, {
            isOpen: this.viewModel.cardModel.isOpen
          }, i.a.createElement(rv, {
            viewModel: this.viewModel.textAreaViewModel,
            rows: 10
          })));
        }
      }]) && cv(t.prototype, r), n && cv(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component)) || iv;

    function gv(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Ov(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, (o = n.key, i = void 0, "symbol" == typeof (i = function (e, t) {
          if ("object" != typeof e || null === e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(o, "string")) ? i : String(i)), n);
      }

      var o, i;
    }

    function wv(e, t) {
      return (wv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Pv(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = kv(e);

        if (t) {
          var o = kv(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return jv(this, r);
      };
    }

    function jv(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return _v(e);
    }

    function _v(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function kv(e) {
      return (kv = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Ev(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }

    var Sv = Object(a.observer)((dv = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && wv(e, t);
      }(a, e);
      var t,
          r,
          n,
          o = Pv(a);

      function a(e) {
        var t;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, a), gv(t = o.call(this, e), "currentUnit", yv, _v(t)), gv(t, "currentValue", bv, _v(t)), gv(t, "updateValue", hv, _v(t)), gv(t, "updateUnit", vv, _v(t));
        var r = t.props,
            n = r.current,
            i = r.unitList,
            c = t.props,
            u = c.currentUnit,
            l = c.currentValue;

        if (n) {
          var s = new G.Quantity(n);
          l = "".concat(s.scalar), u = s.units;
        }

        return t.currentUnit = u || new Q.UnitChoiceModel(i[0]).value || "", t.currentValue = l || "", t;
      }

      return t = a, (r = [{
        key: "current",
        get: function () {
          var e, t;
          return this.currentValue || "0" === this.currentValue || "dry" === (null === (e = this.currentUnit) || void 0 === e || null === (t = e.toLowerCase) || void 0 === t ? void 0 : t.call(e)) ? [this.currentValue, this.currentUnit].filter(Boolean).join(" ") : "";
        }
      }, {
        key: "unitChoices",
        get: function () {
          var e = this,
              t = this.props.unitList.map(function (e) {
            return new Q.UnitChoiceModel(e);
          });
          return this.currentUnit && !t.find(function (t) {
            return e.currentUnit === t.value;
          }) ? [new Q.UnitChoiceModel(this.currentUnit)].concat(t) : t;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.name,
              r = e.placeholder;
          return i.a.createElement(i.a.Fragment, null, i.a.createElement("input", {
            type: "hidden",
            name: t,
            value: this.current
          }), i.a.createElement(Q.UnitSelector, {
            placeholder: r,
            valueColumnClassName: "col-sm-6",
            unitColumnClassName: "col-sm-4",
            currentUnit: this.currentUnit,
            currentValue: this.currentValue,
            onUpdateValue: this.updateValue,
            onUpdateUnit: this.updateUnit,
            unitChoices: this.unitChoices
          }));
        }
      }]) && Ov(t.prototype, r), n && Ov(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(o.Component), yv = Ev(dv.prototype, "currentUnit", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), bv = Ev(dv.prototype, "currentValue", [J.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Ev(dv.prototype, "current", [J.computed], Object.getOwnPropertyDescriptor(dv.prototype, "current"), dv.prototype), Ev(dv.prototype, "unitChoices", [J.computed], Object.getOwnPropertyDescriptor(dv.prototype, "unitChoices"), dv.prototype), hv = Ev(dv.prototype, "updateValue", [J.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.currentValue = t;
        };
      }
    }), vv = Ev(dv.prototype, "updateUnit", [J.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.currentUnit = t;
        };
      }
    }), pv = dv)) || pv;
    "undefined" != typeof window ? window.IF2WorkOrders = n : console.warn("Unable to register React components for IF2 Work Orders");
  }]);
});